'use strict';

yalwa.dol = (function(pub) {

	let $document;
	let $window;
	let section_inits = {};
	let cooldown_photoduel_variations = false;
	const API_PATH_DOL = '/api/ajax/dol/';
	const API_PATH_CHAT = '/api/ajax/chat/';
	const IMAGE_ACTIONS = ['image_move_to_top', 'image_add', 'image_replace', 'image_remove', 'image_sort'];
	pub = pub || {};

	pub.init = function() {
		$document = jQuery(document);
		$window = jQuery(window);
		global_ajax_error_handler();
		//once the entire window is loaded then only trigger this function
		//lost password page -> trigger ali label to top
		$window.on('load', function() {
			if (jQuery('.js-ali_input .js-email').val()) {
				jQuery('.js-lost_pw_label').addClass('ali--infocus');
			}
			wow_chat_bubble();
			
			if (yalwa.v.wows_active_country) {
				show_dot_on_play();
			}
			
			if (yalwa.v.who_liked_you_active_country) {
				yalwa.dol.likes.init();
			}
			
			//Stream is enabled
			if (yalwa.v.is_video_stream_active) {
				yalwa.dol.stream.init();
				yalwa.dol.stream.live_stream_toastr_polling();
			}
		});
		determine_if_first_pageview_after_login();
		if (yalwa.v.show_email_confirm_plp) {
			jQuery('.js-dol_register_page').css({height: jQuery(window).height()});
			let login_bg_img = yalwa.v.static_images_url + 'bg/dol/bg/hashtag_dating_bg.png';
			jQuery('.js-dol_email_confirm_page').css({
				'background': "url(" + login_bg_img + ")",
				'background-size': 'cover',
				'background-position': 'center'
			});
		}
		if (jQuery('.js-dol_onboarding').length) {
			yalwa.dol_onboarding.init();
		} else if (yalwa.v.onboarding_type === 'native_ads') {
			//do nothing as of now, but do not let other events getting triggered as well
		} else {
			if (yalwa.basics.is_logged_in()) {
				init_htabs();
				init_global_handlers();
				$document.on('dol.update_counter', chats.update_counter);
				if (yalwa.v.dol_profile_status === yalwa.v.STATUS_ACTIVE) {
					yalwa.basics.ls_remove('dol_reminder_action_count');
				}
				$document.on('visibilitychange', helper.update_status);
				if (is_first_pageview_after_login()) {
					yalwa.dol.push_check('dol-after-login');
				}
			}
			if (!yalwa.v.to_be_deleted) {
				profile.check_status();
			}
			if (jQuery('.js-dol_account_cooldown_plp').length > 0) {
				profile.init_account_cooldown_plp();
			}
			if (yalwa.basics.get_routing() === 'deleteprofile') {
				jQuery('.js-delete_profile_via_email').on('click', function() {
					jQuery('.js-delete_via_email')
						.on('plp_confirm', delete_profile_via_email)
						.trigger('plp_show');
				});
			}
		}
		if (yalwa.mobile.htabs.current() !== 'discover') {
			yalwa.mobile.stop_invisible_start();
		}
		// hide headroom back button when there no pages to go back
		if (history.length === 0 || history.length === 1) {
			yalwa.basics.hide(jQuery('.js-history_back'));
		}

		// load the init_embedded only on certain pages
		if (can_init_embedded()) {
			init_embedded();
		}
		switch (yalwa.dol.url_id()) {
			case yalwa.v.VIEW_CREATE_PW:
				init_create_pw();
				break;
			case yalwa.v.VIEW_CHANGE_PW:
				init_change_pw();
				break;
			case yalwa.v.VIEW_LOST_PW:
				init_lost_pw();
				break;
			case yalwa.v.VIEW_PLEDGE:
				pub.pledge.init();
				break;
			case 'mail-unsubscribe':
				init_mail_unsubscribe();
				break;
			default:
				break;
		}

		yalwa.dol.app_promo.init();
		yalwa.dol.magic_link.init();
		helper.ripple_init();
		handle_back_button();
		handle_email_change_toast();

		// using timeout because of potential reloads being triggered bringing UTMs back
		setTimeout(handle_utm_tracking, 2000);

		yalwa.dol.chats.check_unread_counter();
		// https://yalwa.atlassian.net/browse/DEV-7173
		show_hide_tot_in_play_new();
		timing_tracking();
		initial_check_for_welcome_back_plp();
	};
	
	pub.is_cooldown_photoduel_variations = function() {
		return cooldown_photoduel_variations;
	}
	
	/**
	 * @desc show a new message bubble on chat icon in menu bar when user has wow requests
	 */
	function wow_chat_bubble() {
		if (parseInt(yalwa.v.wows_received_count)) {
			jQuery('.js-menu_counter_mc').addClass('dol_counter');
		}
	}
	
	function timing_bucket(ms, type) {
		let steps;
		switch (type) {
			case 'total':
				steps = [300, 500, 750, 1000, 1500, 2000, 2500, 3000, 4000, 5000, 7500, 10000, 15000, 25000]; // 14
				break;
			case 'wire':
				steps = [2, 5, 10, 25, 50, 150, 300, 400, 500, 600, 800, 1000, 1250, 1500, 1750, 2000, 3000, 5000, 7500]; // 19
				break;
			case 'backend':
				steps = [5, 10, 25, 100, 150, 200, 250, 300, 350, 400, 500, 600, 800, 1000, 1500, 2000, 3000, 5000]; // 18
				break;
			case 'frontend':
				steps = [200, 300, 400, 500, 750, 1000, 1250, 1500, 1750, 2000, 2500, 3000, 4000, 5000, 7500, 10000]; // 16
				break;
		}
		for (let i = 0; i < steps.length; i++) {
			if (ms < steps[i]) {
				return steps[i];
			}
		}
		return 'max';
	}
	
	function timing_tracking() {
		if (yalwa.basics.get_random_int(1,100) > 5 && !location.port) { // track 5%
			return false;
		}
		const result = {total: null, frontend: null, backend: null, wire: null};
		if (typeof(performance) !== 'undefined' && typeof(performance.getEntriesByType) !== 'undefined' && performance.getEntriesByType("navigation").length > 0) {
			let perf = performance.getEntriesByType("navigation")[0];
			result.total = performance.now();
			const wire_client_to_server = perf.requestStart - perf.redirectStart;
			const wire_server_to_client = perf.responseEnd - perf.responseStart;
			result.wire = wire_client_to_server + wire_server_to_client;
			result.frontend = result.total - perf.responseEnd;
			if (yalwa.v.backend_duration) { // calculation for this is more accurate on the server itself
				result.backend = yalwa.v.backend_duration;
				result.wire = perf.responseEnd - perf.redirectStart - result.backend;
			} else {
				result.backend = perf.responseStart - perf.requestStart;
			}
			result.initial_network = perf.connectEnd - perf.domainLookupStart;
			result.request_response = perf.responseEnd - perf.requestStart;
			result.total = timing_bucket(result.total, 'total');
			result.wire = timing_bucket(result.wire, 'wire');
			result.backend = timing_bucket(result.backend, 'backend');
			result.frontend = timing_bucket(result.frontend, 'frontend');
			result.initial_network = timing_bucket(result.initial_network, 'wire');
			result.request_response = timing_bucket(result.request_response, 'wire');
		}
		yalwa.basics.beacon('/api/ajax/track/', {
			t: 'timing_dating',
			page_type:  yalwa.dol.url_id(),
			bucket_frontend: result.frontend,
			bucket_backend: result.backend,
			bucket_wire: result.wire
		});
		return result;
	}
	
	function show_hide_tot_in_play_new() {
		if (yalwa.v.seen_tot_in_play_once) {
			jQuery('.js-htabs').find('[data-sectionid="photo-duel"]').find('.yicon').removeClass('dol_counter');
		} else {
			jQuery('.js-htabs').find('[data-sectionid="photo-duel"]').find('.yicon').addClass('dol_counter');
		}
	}

	function handle_utm_tracking() {
		if (yalwa.basics.is_logged_in() && !yalwa.basics.nav_started()) {
			if (yalwa.basics.get_get('utm_source') || yalwa.basics.get_get('utm_medium') || yalwa.basics.get_get('utm_campaign') || yalwa.basics.get_get('utm_content')) {
				jQuery.ajax({
					url: API_PATH_DOL,
					dataType: 'json',
					type: 'post',
					data: {
						action: 'utm_tracking',
						source: yalwa.basics.get_get('utm_source'),
						medium: yalwa.basics.get_get('utm_medium'),
						campaign: yalwa.basics.get_get('utm_campaign'),
						content: yalwa.basics.get_get('urm_content')
					}
				}).done(function(r) {
					if (r.success) {
						yalwa.basics.set_get({utm_source: null, utm_medium: null, utm_campaign: null, utm_content: null});
					}
				});
			}
		}
	}

	function determine_if_first_pageview_after_login() {
		if (yalwa.basics.is_logged_in()) {
			if (!yalwa.basics.ls_get('first_pageview_after_login') || yalwa.basics.ls_get('first_pageview_after_login') === 'logged_out_before') {
				yalwa.basics.ls_set('first_pageview_after_login', 'yes');
			} else {
				yalwa.basics.ls_set('first_pageview_after_login', 'no_subsequent');
			}
		} else {
			yalwa.basics.ls_set('first_pageview_after_login', 'logged_out_before');
		}
	}

	function is_first_pageview_after_login() {
		return yalwa.basics.ls_get('first_pageview_after_login') === 'yes';
	}

	/**
	 * handle navigate back behavior
	 */
	function handle_back_button() {
		jQuery(window).on('popstate', function() {
			const $open_plp = jQuery('.js-plp').filter(':not(.hidden)').filter(':not(.js-plp_static)');
			if ($open_plp.length) {
				$open_plp.trigger('plp_hide');
			}
		});
		yalwa.basics.state.register('filters', function() {
			if (!jQuery('.js-dol_browse_filters').hasClass('hidden')) {
				discover.hide_filters();
				return true;
			}
		});
		yalwa.basics.state.register('filters_hashtag', function() {
			if (!jQuery('.js-filter_hashtags_modal').hasClass('hidden')) {
				discover.hide_filters_hashtag();
				return true;
			}
		});
	}
	
	function handle_email_change_toast() {
		if(yalwa.v.email_change_label) {
			if(yalwa.v.email_change_status === 'success') {
				yalwa.dol.toast({message: yalwa.v.email_change_label, type: 'success'});
			} else if (yalwa.v.email_change_status === 'error') {
				yalwa.dol.toast({message: yalwa.v.email_change_label, type: 'error'});
			}
		}
	}

	pub.toast = function(config) {
		let dol_toast_config = {preventDuplicates: true};
		yalwa.basics.toast({...config, ...dol_toast_config});
	};

	pub.go_profile = function() {
		const $c = jQuery('.js-profile_view_container');
		if ($c.is(':visible')) {
			yalwa.basics.state.try_cancel('go_profile');
			yalwa.basics.hide($c);
			let deferred = jQuery.Deferred();
			deferred.resolve();
			return deferred;
		}
		yalwa.basics.state.push('go_profile');
		return jQuery.ajax({
			url: API_PATH_DOL,
			dataType: 'json',
			type: 'get',
			data: {
				action: 'view_profile',
				target_profileID: chats.get_profileID_mc()
			}
		}).done(function(r) {
			$c.html(r.html);
			yalwa.basics.ga.pageview({'page': 'dol_profile_other'});
			window.setTimeout(function() {
				yalwa.basics.show($c);
				let client_height = document.documentElement.clientHeight;
				let header_height = jQuery('.js-htabs').closest('header').outerHeight();
				let hashtags_container_height = $c.find('.js-hashtags_container').outerHeight();
				let $profile_core = $c.find('.js-dol_profile_core');
				$profile_core.css({height: client_height - header_height - hashtags_container_height});
				discover.share.init();
				factsheet_height_coversation();
			}, 410);
		});
	};

	function factsheet_height_coversation() {
		const $factsheet_height_bubbles = jQuery('.js-factsheet_height');
		const any_factsheet_height_bubble_on_screen = (changes, observer) => {
			changes.forEach(change => {
				// visible
				
				if(change.intersectionRatio > 0.9) {
					let value = jQuery(changes[0].target).data('value');
					if (!yalwa.v.is_imperial) {
						jQuery(changes[0].target).html(value + ' cm');
					} else {
						let imperial = value / 30.48;
						imperial = imperial.toPrecision(3);
						let imperial_array = imperial.split('.');
						let feet = imperial_array[0];
						let inches = Math.round(imperial_array[1] * 12 / 100);
						if (inches === 12) {
							feet = feet + 1;
							inches = 0;
						}
						jQuery(changes[0].target).html(feet + '′ ' + inches + '″');
					}
				}
			});
		};
		on_screen($factsheet_height_bubbles, any_factsheet_height_bubble_on_screen);
	}

	pub.factsheet_height_coversation = factsheet_height_coversation;

	function on_screen($elements, callback) {
		if (!window.hasOwnProperty('IntersectionObserver') || $elements.length === 0 || typeof callback !== 'function') {
			return false;
		}
		let options = {
			rootMargin: '0px',
			threshold: 0.9 // safari fix the threshold only reach .9xx
		};
		let observer = new IntersectionObserver(callback, options);
		$elements.each(function() {
			observer.observe(jQuery(this)[0]);
		});
	}

	pub.unmatch = function() {
		jQuery('.js-unmatch_really')
			.off('plp_confirm')
			.on('plp_confirm', chats.do_unmatch)
			.trigger('plp_show', {is_queued: true});
	};

	pub.build_url = function(id, path, params = {}) {
		let whitelist = [
			'profile', 'chats', 'discover',
			'settings', 'edit-profile', 'settings-account',
			'terms', 'privacy', 'contact', 'account-status', 'settings-feedback', yalwa.v.VIEW_HASHTAGS, yalwa.v.VIEW_FACTSHEET,
			yalwa.v.VIEW_THISTHAT,
			yalwa.v.VIEW_ONBOARDING,
			yalwa.v.VIEW_RESEND_EMAIL,
			yalwa.v.VIEW_CHANGE_EMAIL,
			yalwa.v.VIEW_PHOTO_DUEL,
			yalwa.v.VIEW_LIKES,
			yalwa.v.VIEW_STREAM
		];
		if (jQuery.inArray(id, whitelist) !== -1 && yalwa.v.dol_url_base) {
			let url = yalwa.v.dol_url_base + id + '/';

			if (path && typeof path === 'string') {
				url += path + '/';
			}

			if (Object.keys(params).length) {
				let get_params = [];
				for (const [key, value] of Object.entries(params)) {
					get_params.push(key + '=' + value);
				}
				url += '?' + get_params.join('&');
			}

			return url;
		}
		return null;
	};

	pub.url_id = function(qualified = false) {
		const match = location.href.match(qualified ? /\/dol\/([a-z-]+(\/([a-z-]+))?)\/?/ : /\/dol\/([a-z-]+)\/?/);
		if (!match || !match[1]) {
			return null;
		}
		return match[1];
	};

	/**
	 * @desc public method to check if page is embedded
	 * @returns {boolean}
	 */
	pub.has_embedded_url = () => {
		return /embedded=1/.test(location.href);
	};

	/**
	 * Android/iOS app promo section
	 *
	 * @see https://yalwa.atlassian.net/browse/DEV-1152
	 */
	pub.app_promo = (function(pub) {

		pub = pub || {};
		let is_initialized = false;

		const SEVEN_DAYS_IN_SECONDS = 604800;
		const THIRTY_DAYS_IN_SECONDS = 2592000;
		let cookie;
		let ls_promo_viewed_times;
		let ls_promo_do_not_show;
		let is_no_more_lonely_words_checked = false;
		pub.timeouts = pub.timeouts || {};
		pub.init = function() {
			cookie = {
				name: 'dol_app_promo',
				value: yalwa.basics.get_cookie('dol_app_promo')
			};
			ls_promo_viewed_times = {
				key: 'dol_app_promo_viewed_times',
				value: yalwa.basics.ls_get('dol_app_promo_viewed_times')
			};
			ls_promo_do_not_show = {
				key: 'dol_app_promo_do_not_show',
				value: yalwa.basics.ls_get('dol_app_promo_do_not_show')
			};
			if (is_initialized) {
				return;
			}
			if (!should_init()) {
				return;
			}
			$document.on('hide_app_promo', hide_promo_on_headroom);
			$document.on('can_show_promo_on_headroom', can_show_promo_on_headroom_handling);
			//try one on init
			can_show_promo_on_headroom_handling();

			is_initialized = true;
		};

		// show do not show checkbox when promo is viewed more than 3 times
		function handle_showing_do_not_show_checkbox() {
			if (ls_promo_viewed_times.value >= 3) {
				let $app_promo_do_not_show_wrap = jQuery('.js-app_promo_do_not_show_wrap');
				yalwa.basics.show($app_promo_do_not_show_wrap);
				$app_promo_do_not_show_wrap.off('click').on('click', function() {
					if (jQuery('.js-app_promo_do_not_show_input').is(':checked')) {
						yalwa.basics.datalayer_push({
							'event': 'app_install_promo_dont_show',
							'app_install_promo_touchpoint': 'app_promo_headroom_swipe'
						});
					}
				});
			}
		}

		// increase the promo viewed times by one
		function increase_promo_viewed_count() {
			yalwa.basics.ls_set(
				ls_promo_viewed_times.key,
				(ls_promo_viewed_times.value) ?
					parseInt(ls_promo_viewed_times.value) + 1 : 1);
		}

		function hide_promo_on_headroom() {
			if (pub.timeouts.hasOwnProperty('to1')) {
				clearTimeout(pub.timeouts.to1);
			}
			if (pub.timeouts.hasOwnProperty('to2')) {
				clearTimeout(pub.timeouts.to2);
			}
			jQuery('.js-app_promotion_topbar').slideUp('slow');
			setTimeout(() => {
				jQuery('.js-htabs').css({'position': 'fixed'});
				jQuery('.js-htabs_dummy').css({'height': '44px'});
				helper.set_height_initial();
			}, 500);
		}

		/**
		 * close the promo and adjust the height accordingly
		 */
		pub.close_promo_on_headroom = function() {
			jQuery('.js-app_promotion_topbar').slideUp('slow');
			setTimeout(() => {
				jQuery('.js-app_promotion_topbar').remove();
				jQuery('.js-htabs').css({'position': 'fixed'});
				jQuery('.js-htabs_dummy').css({'height': '44px'});
				helper.set_height_initial();
			}, 500);
		};

		/**
		 * while closing the app promo, when user opt for do not show, we need to set it on local storage
		 */
		function handle_setting_do_not_show_ls() {
			if (!jQuery('.js-app_promo_do_not_show_wrap').hasClass('hidden')) {
				if (jQuery('.js-app_promo_do_not_show_input').is(':checked')) {
					yalwa.basics.ls_set(ls_promo_do_not_show.key, true);
				}
			}
		}

		/**
		 * while handling closing the promo, we need to set cookie/local storage, close the promo
		 */
		function handle_closing_promo_on_headroom() {
			increase_promo_viewed_count();
			handle_setting_do_not_show_ls();
			yalwa.dol.app_promo.close_promo_on_headroom();
			set_cookie_to_hide_promo_until_then();
			yalwa.basics.datalayer_push({
				'event': 'app_install_promo_close_user',
				'app_install_promo_touchpoint': 'app_promo_headroom_swipe'
			});
		}

		// set cookies that is decides when we have to show the promo next time
		function set_cookie_to_hide_promo_until_then(event) {
			if (event === 'cta_click') {
				yalwa.basics.set_cookie(cookie.name, 1, THIRTY_DAYS_IN_SECONDS);
			} else if (!ls_promo_viewed_times.value || ls_promo_viewed_times.value < 3) {
				yalwa.basics.set_cookie(cookie.name, 1, SEVEN_DAYS_IN_SECONDS);
			} else if (ls_promo_viewed_times.value >= 3) {
				yalwa.basics.set_cookie(cookie.name, 1, THIRTY_DAYS_IN_SECONDS);
			}
		}

		/**
		 * shows the promo on the headroom and adjust heights accordingly
		 */
		function show_promo_on_headroom() {
			jQuery('.js-webpush_priming').remove();
			if (!is_no_more_lonely_words_checked) {
				yalwa.basics.no_more_lonely_words(jQuery('.js-app_promotion_topbar_body'));
				is_no_more_lonely_words_checked = true;
			}
			let last_like_name = yalwa.basics.ss_get('last_like_name');
			if (jQuery('.js-app_promotion_label').length > 0 && last_like_name) {
				let label = yalwa.v.lang.dol_pwa_promo_like_text;
				jQuery('.js-app_promotion_label').text(label.replace('%1$s', last_like_name));
			}
			
			if (!jQuery('.js-app_promotion_label').length > 0 || (jQuery('.js-app_promotion_label').length > 0 && last_like_name)) {
				jQuery('.js-app_promotion_topbar').slideDown('slow');
				jQuery('.js-htabs').css({'position': 'relative'});
				jQuery('.js-htabs_dummy').css({'height': 'auto'});
				
				// gtm tracking
				// https://yalwa.atlassian.net/browse/DEV-10418
				yalwa.basics.datalayer_push({
					'event': 'app_install_promo_impression',
					'app_install_promo_touchpoint': 'app_promo_headroom_swipe'
				});
				
				const ONE_MINUTE_IN_MILLISECONDS = 60000; // 1000 * 60
				setTimeout(auto_close_promo_on_headroom, ONE_MINUTE_IN_MILLISECONDS);
			}
		}

		function auto_close_promo_on_headroom() {
			// check if promo is still not closed and in the DOM
			if (!jQuery('.js-app_promotion_topbar').length) {
				return;
			}
			yalwa.dol.app_promo.close_promo_on_headroom();
			yalwa.basics.ss_set('auto_closed_dol_app_promo', true);
			// gtm tracking
			// https://yalwa.atlassian.net/browse/DEV-10418
			yalwa.basics.datalayer_push({
				'event': 'app_install_promo_auto_close',
				'app_install_promo_touchpoint': 'app_promo_headroom_swipe'
			});
		}

		function can_show_promo_on_headroom_handling() {
			// show the promo when cookie is not there and user does not opt for do not show and have not used android app
			if (can_show_promo_on_headroom()) {
				// if not a dol app then proceed to show the app promo
				if (!yalwa.basics.is_dol_app()) {
					pub.timeouts.to1 = setTimeout(show_promo_on_headroom, 400);
					pub.timeouts.to2 = setTimeout(helper.set_height_initial, 500);

					handle_showing_do_not_show_checkbox();
					// handle closing the promo
					jQuery('.js-app_promotion_close_headroom_swipe').off('click').on('click', handle_closing_promo_on_headroom);
					jQuery('.js-app_install').on('click', function(event) {
						event.preventDefault();
						increase_promo_viewed_count();
						set_cookie_to_hide_promo_until_then('cta_click');
						let url = jQuery('.js-app_install').attr('href');
						yalwa.basics.navigate(url);
						yalwa.dol.app_promo.close_promo_on_headroom();
					});
				}
			}
		}

		/**
		 * decides if the app promo on headroom can be shown to the user
		 * @returns {boolean}
		 */
		function can_show_promo_on_headroom() {
			return window.navigator.cookieEnabled &&
				!cookie.value &&
				!ls_promo_do_not_show.value &&
				((helper.detect_device_type() === 'Android') || (helper.detect_device_type() === 'iOS') || (jQuery('.js-pwa_install').length && yalwa.mobile.install_pwa_prompt_available())) &&
				yalwa.basics.ls_get('dol_reaction_count') >= 3 &&
				yalwa.basics.overlay.current_count() === 0 &&
				jQuery('.js-generic_shadow').hasClass('hidden') &&
				!yalwa.basics.ss_get('auto_closed_dol_app_promo') &&
				!yalwa.v.is_phonegap &&
				!yalwa.basics.is_pwa();
		}

		/**
		 * decides whether should we initialize android app promo
		 * @returns {boolean}
		 */
		function should_init() {
			switch (yalwa.dol.url_id()) {
				case yalwa.v.VIEW_PROFILE:
				case yalwa.v.VIEW_DISCOVER:
				case yalwa.v.VIEW_CHATS:
					return (helper.detect_device_type() === 'Android' && !yalwa.v.seen_with_android_app) || (helper.detect_device_type() === 'iOS' && !yalwa.v.seen_with_ios_app) || jQuery('.js-pwa_install').length;

				default:
					return false;
			}
		}

		return pub;

	})(pub.app_promo);

	pub.push_check = function(touchpoint, params) {
		if (jQuery('.js-generic_shadow').hasClass('hidden') && yalwa.basics.overlay.current_count() === 0) {
			if (yalwa.basics.is_dol_app()) {
				if (params && params.hasOwnProperty('push_enabled')) {
					yalwa.basics.ls_set('push_enabled', params.push_enabled);
				} else if (yalwa.basics.ls_get('push_enabled') === null) {
					yalwa.basics.ls_set('push_enabled', true);
				}
				let is_enabled = yalwa.basics.ls_get('push_enabled');
				params = params || {push_enabled: is_enabled};
				yalwa.basics.ls_set('request_push_change', params);
				$document.trigger('request_push_change');
			} else if (yalwa.basics.webpush.is_default()) {
				yalwa.basics.webpush.ask_or_update_existing(touchpoint);
			}
		}
	};

	/**
	 * @desc method to see if embedded pages scripts should be initialized on onboarding
	 * or legal pages
	 * @returns {boolean}
	 */
	function can_init_embedded() {
		return yalwa.basics.get_routing() === 'dol_onboarding' ||
			yalwa.dol.has_embedded_url() ||
			yalwa.dol.url_id() === 'terms' ||
			yalwa.dol.url_id() === 'privacy';
	}

	/**
	 * @description method to initialize and handles clicks on the embedded legal pages
	 * on onboarding flow
	 */
	function init_embedded() {
		// handling contact form links to open on popup or browser
		jQuery('.js-dol_contact_link').on('click', (event) => {
			event.preventDefault();
			event.stopPropagation();
			if (!yalwa.dol.has_embedded_url()) {
				yalwa.basics.navigate(event.target.href);
			}
			parent.jQuery('body').trigger('hide_legal_popup_show_contact');
		});
		$document.on('hide_legal_popup_show_contact', function() {
			jQuery('.js-dol_plp_legal').trigger('plp_hide');
			setTimeout(() => {
				const contact_plp_text = jQuery('.js-plp_dol_contact_pg_embed .plp__text');
				if (contact_plp_text.text() === '1') {
					contact_plp_text.html(helper.create_iframe(yalwa.v.VIEW_CONTACT));
				}
				jQuery('.js-plp_dol_contact_pg_embed').trigger('plp_show');
			}, 500);
		});

		if (yalwa.dol.url_id() === yalwa.v.VIEW_CONTACT && yalwa.dol.has_embedded_url()) {
			jQuery('.faq_contact_form__wrapper').css({'padding': '0px'});
			jQuery('.faq_contact_form__header').css({'padding-left': '0px'});
		}

		// handling contact form links to open on popup or browser
		jQuery('.js-dol_privacy_link, .js-dol_terms_link').on('click', (event) => {
			event.preventDefault();
			event.stopPropagation();
			if (!yalwa.dol.has_embedded_url()) {
				yalwa.basics.navigate(event.target.href);
			}
			if (event.target.href.indexOf(yalwa.v.VIEW_TERMS) !== -1) {
				parent.jQuery('body').trigger('hide_legal_popup_show_other', [yalwa.v.VIEW_TERMS]);
			} else if (event.target.href.indexOf(yalwa.v.VIEW_PRIVACY) !== -1) {
				parent.jQuery('body').trigger('hide_legal_popup_show_other', [yalwa.v.VIEW_PRIVACY]);
			}
		});
		$document.on('hide_legal_popup_show_other', function(event, show) {
			jQuery('.js-dol_plp_legal').trigger('plp_hide');
			setTimeout(() => {
				if (show === yalwa.v.VIEW_PRIVACY) {
					yalwa.dol_onboarding.show_privacy();
				} else if (show === yalwa.v.VIEW_TERMS) {
					jQuery('.js-plp_dol_terms').trigger('plp_show');
				}
			}, 500);
		});
	}

	function init_htabs() {
		yalwa.mobile.htabs.register_abort_check((sectionID) => {
			if (sectionID === yalwa.v.VIEW_CHATS && yalwa.basics.get_get('sl_index') > 0) {
				yalwa.basics.state.back();
				return true;
			}
			if (jQuery('.js-htabs_item[data-sectionid="' + sectionID + '"]').hasClass('htabs__item--chosen')) {
				return true;
			}
			return false;
		});
		$document.on('htabs_dol', function(e, tab) {
			htab_visual_change(tab);
			if (tab !== yalwa.v.VIEW_PHOTO_DUEL) {
				yalwa.v.disable_random_play_section = false;
			}
			if (tab !== yalwa.v.VIEW_CHATS) {
				yalwa.basics.set_get({cID: null});
				yalwa.basics.set_get({sl_index: null});
			}
			yalwa.basics.ga.pageview({'page': '/' + yalwa.v.path_segment + '/dol/' + tab + '/'});
			init_section(tab);
			if (tab === yalwa.v.VIEW_DISCOVER) {
				setTimeout(function() {
					if (jQuery('.js-dol_browse_filters').is(':visible')) {
						yalwa.basics.show(jQuery('.js-dol_tabbar'));
						yalwa.basics.show(jQuery(".js-dol_browse_filters_done"));
					}
				}, 1000);
			} else {
				yalwa.basics.hide(jQuery('.js-dol_tabbar'));
				yalwa.basics.hide(jQuery(".js-dol_browse_filters_done"));
			}
			if (tab === yalwa.v.VIEW_LIKES) {
				//Track boost+likes combo pageviews
				if (jQuery('.js-boost_with_likedyou_page').length) {
					yalwa.basics.datalayer_push({
						'event': 'pf_all_promo_pageview',
						'pf_all_promo_pageview': 'liked_you_package_match_boost',
						'pf_all_type': 'see_who_liked_you',
						'pf_is_app': yalwa.basics.is_dol_app() !== false,
					});
				}
				if (jQuery('.js-discover_premium').length) {
					yalwa.basics.datalayer_push({
						'event': 'pf_all_promo_pageview',
						'pf_all_promo_pageview': 'PF_bundle_via_liked_you',
						'pf_all_type': 'premium_bundle',
						'pf_pb_promo_page_position' : 'first_position',
						'pf_is_app': yalwa.basics.is_dol_app() !== false,
					});
				}
				if (yalwa.basics.is_dol_app() && yalwa.v.is_iap_activated_for_combo) {
					yalwa.mobile.cordova_dol.cordova_send({action: 'iap_product_data'});
				}
			}
			if (tab !== yalwa.v.VIEW_STREAM) {
				//Check if stream is on going
				if (yalwa.stream_helper && yalwa.stream_helper.check_and_show_progress_stream_htab_icon) {
					yalwa.stream_helper.check_and_show_progress_stream_htab_icon();
				}
			} else {
				yalwa.basics.hide(jQuery('.js-stream_live_ongoing'));
				if (yalwa.stream_helper && yalwa.stream_helper.streamer_rating_heart_plp_trigger) {
					yalwa.stream_helper.streamer_rating_heart_plp_trigger();
					
					// motivational plp
					yalwa.stream_helper.streamer_motivational_info_plp_init();
					jQuery('body').off('not_eligible_for_heart_rating_plp').on('not_eligible_for_heart_rating_plp', () => {
						if (yalwa.stream_helper && yalwa.stream_helper.streamer_motivational_plp_trigger) {
							yalwa.stream_helper.streamer_motivational_plp_trigger();
						}
					});
				}
				
			}
			
			if (tab === yalwa.v.VIEW_STREAM) {
				//On tab change, again create the session and start polling
				if (yalwa.stream_helper) {
					yalwa.stream_helper.create_watcher_session_and_start_landing_polling();
				}
			}
			if (tab === yalwa.v.VIEW_PROFILE) {
				update_profile_premium_tp_html();
			}
		});
		init_section(yalwa.mobile.htabs.current());
		htab_visual_change(yalwa.mobile.htabs.current());
		helper.set_height_initial();
		if (yalwa.basics.get_cookie('sp') && !yalwa.v.show_email_confirm_pl && !yalwa.v.is_foto_skipped) {
			htabs_get_item(yalwa.v.VIEW_DISCOVER).trigger('click');
		}
	}
	
	function update_profile_premium_tp_html() {
		jQuery.ajax({
			url: yalwa.basics.API_PATH_DOL,
			dataType: 'json',
			type: 'get',
			data: {
				action: 'profile_premium_tp_html',
			}
		}).done(function(response) {
			if (response.success && response.html) {
				jQuery('.js-swly_premium_box').remove();
				jQuery('.js-bundle_premium_box').after(response.html);
			} else {
				yalwa.basics.sentry.submit_error(new Error('error in response from profile_premium_tp_html'));
			}
		});
	}

	function htabs_get_item(sectionID) {
		return jQuery('.js-htabs_item[data-sectionid="' + sectionID + '"]');
	}

	function init_section(section) {
		if (section === undefined) {
			return;
		}
		yalwa.basics.toggle(jQuery('.js-dol_swipe_tip'), section === yalwa.v.VIEW_DISCOVER);
		jQuery('.js-section').scrollTop(0);
		switch (section) {
			case yalwa.v.VIEW_DISCOVER:
				if (!section_inits[section]) {
					discover.init();
				}
				break;
			case yalwa.v.VIEW_PROFILE:
				if (!section_inits[section]) {
					profile.init();
				}
				break;
			case yalwa.v.VIEW_CHATS:
				if (!section_inits[section]) {
					chats.load().done(function() {
						chats.load_chat_resources();
						chats.init();
					});
				} else {
					if (yalwa.chat) {
						yalwa.chat.reload_list(yalwa.chat.current_context()).done(function() {
							const ls_dol_chats_filter = yalwa.basics.ls_get('dol_chats_filter', true);
							if (ls_dol_chats_filter && !jQuery.isEmptyObject(ls_dol_chats_filter)) {
								jQuery('.js-chat_filter_option').prop('checked', false);
								jQuery.each(ls_dol_chats_filter, function(filter) {
									const $filtered_by = jQuery('.js-chat_filter_option[value="' + filter + '"]');
									$filtered_by.prop('checked', true);
									chats.update_filtered_by($filtered_by.data('label'));
								});
							}
							chats.check_empty_chats_view();
							yalwa.chat.init_country_tooltip('dol_international_flag_tooltip');
						});
						if (yalwa.basics.get_get('view') === 'requests') {
							yalwa.chat.show_chat_requests();
						}
					}
				}
				let params = {
					init_check: true
				};
				if (yalwa.basics.is_dol_app()) {
					yalwa.basics.ls_set('request_push_change', params);
					$document.trigger('request_push_change');
				}
				break;
			
			case yalwa.v.VIEW_PHOTO_DUEL:
				yalwa.dol.photo_duel_loader.load_assets();
				break;
				
			case yalwa.v.VIEW_LIKES:
				if (!section_inits[section]) {
					likes.init();
				}
				break;
			case yalwa.v.VIEW_STREAM:
				if (!section_inits[section]) {
					stream.init();
				}
				
				break;
		}
		if (!section_inits[section]) {
			section_inits[section] = true;
		}
	}

	function init_global_handlers() {
		$document.on('click', '.js-dol_profile_location_distance', helper.profile_location_distance); // show tip for long location names/distance
		yalwa.basics.state.register('go_profile', function() {
			if (!jQuery('.js-profile_view_container').hasClass('hidden')) {
				yalwa.basics.hide(jQuery('.js-profile_view_container'));
				return true;
			}
		});
	}

	pub.burger_menu_feedback = () => {
		yalwa.basics.hide(jQuery('.js-dol_feedback_error'));
		// we store the default title in localstorage when we change the title
		// when shown after bad app rating
		const title = yalwa.basics.ls_get('feedback_form_title');
		if (title) {
			jQuery('.js-feedback_popup .plp__title').text(title);
			yalwa.basics.ls_remove('feedback_form_title');
		}
		jQuery('.js-feedback_popup')
			.off('plp_confirm')
			.on('plp_hide', function() {
				jQuery(document).off('generic_shadow_hide.dol_feedback_popup');
			})
			.on('plp_confirm', function() {
				if (dol_feedback_send()) {
					jQuery(this).closest('.js-plp').trigger('plp_hide');
					jQuery('.js-dol_feedback_text').val(''); // empty the feedback
					jQuery('.js-dol_feedback_type').val('dol');
				}
			})
			.trigger('plp_show');
		$document.on('generic_shadow_hide.dol_feedback_popup', function() {
			jQuery('.js-feedback_popup').trigger('plp_hide');
		});
		jQuery('.js-plp_container').on('click.default', function(e) {
			if (jQuery(e.target).hasClass('js-plp_container')) {
				jQuery('.js-feedback_popup').trigger('plp_hide');
			}
		});
	};

	function dol_feedback_send() {
		let feedback_text = jQuery.trim(jQuery('.js-dol_feedback_text').val());
		const feedback_type = jQuery('.js-dol_feedback_type').val();
		if (!feedback_text) {
			yalwa.basics.show(jQuery('.js-dol_feedback_error'));
			return false;
		}
		yalwa.basics.import_js('dol/feedback.js').then((Module) => {
			yalwa.feedback.feedback_try_send(feedback_type, feedback_text);
		});
		return true;
	}

	function htab_visual_change(tab) {
		let $discover_icon = htabs_get_item(yalwa.v.VIEW_DISCOVER).find('.yicon');
		if (tab === yalwa.v.VIEW_DISCOVER) {
			yalwa.basics.show(jQuery('.js-htabs_icon_grad'));
			yalwa.basics.hide(jQuery('.js-htabs_icon_black'));
			$document.trigger('height_check');
		} else {
			yalwa.basics.hide(jQuery('.js-htabs_icon_grad'));
			yalwa.basics.show(jQuery('.js-htabs_icon_black'));
		}
		
		let $likes_icon = htabs_get_item(yalwa.v.VIEW_LIKES).find('.yicon');
		if (tab === yalwa.v.VIEW_LIKES) {
			if (yalwa.likes) {
				yalwa.likes.refresh_like_page();
			}
			yalwa.basics.hide(jQuery('.js-htabs_heart_icon_navy'));
			yalwa.basics.show(jQuery('.js-htabs_heart_icon_mint'));
		} else {
			yalwa.basics.show(jQuery('.js-htabs_heart_icon_navy'));
			yalwa.basics.hide(jQuery('.js-htabs_heart_icon_mint'));
		}
		yalwa.mobile.force_repaint($discover_icon);
		yalwa.mobile.force_repaint($likes_icon);
	}

	// change password form handling
	function init_change_pw() {
		jQuery('.js-change_pw_form').on('submit', (event) => {
			event.preventDefault();
			if (helper.is_valid_pwd(jQuery('.js-pwd_new')) && helper.check_current_pw(jQuery('.js-pwd_old'))) {
				const change_pw_warning_plp = jQuery('.js-dol_change_pw_warning');
				if (change_pw_warning_plp.length) {
					change_pw_warning_plp
						.on('plp_confirm', () => event.currentTarget.submit())
						.trigger('plp_show');
					return;
				}
				event.currentTarget.submit();
			}
		});
	}

	// create password form handling
	function init_create_pw() {
		jQuery('.js-create_pw_form').on('submit', (event) => {
			event.preventDefault();
			if (helper.is_valid_pwd(jQuery('.js-pwd_new'))) {
				const create_pw_warning_plp = jQuery('.js-dol_create_pw_warning');
				if (create_pw_warning_plp.length) {
					create_pw_warning_plp
						.on('plp_confirm', () => event.currentTarget.submit())
						.trigger('plp_show');
					return;
				}
				event.currentTarget.submit();
			}
		});
	}

	// lost password form handling
	function init_lost_pw() {
		jQuery('.js-lost_pw_form').on('submit', (event) => {
			event.preventDefault();
			const email = jQuery('.js-lost_pw_form .js-email').val();
			is_hybrid_user(email).done((response) => {
				if (!response.success) {
					event.currentTarget.submit();
					return;
				}
				const lost_pw_warning_plp = jQuery('.js-dol_lost_pw_warning');
				if (lost_pw_warning_plp.length) {
					lost_pw_warning_plp
						.on('plp_confirm', () => event.currentTarget.submit())
						.trigger('plp_show');
				}
			});
		});
		// https://yalwa.atlassian.net/browse/DEV-6936
		jQuery('body').css({"overflow-y" : "auto"});
	}
	
	function init_mail_unsubscribe() {
		// do tracking as specified in DEV-11373
		let data = {};
		if (yalwa.v.tracking_category) {
			if (yalwa.basics.get_get('resubscribe')) {
				yalwa.basics.datalayer_push({
					'event': 're-subscribe_emails_view',
					// this is currently the only touchpoint. will be variable in the future:
					'unsubscribe_touchpoint': 'email_footer',
					// assigned in dol_page_unsubscribe php class
					'unsubscribe_email_category': yalwa.v.tracking_category
				});
			} else {
				yalwa.basics.datalayer_push({
					'event': 'unsubscribe_emails_view',
					// this is currently the only touchpoint. will be variable in the future:
					'unsubscribe_touchpoint': 'email_footer',
					// assigned in dol_page_unsubscribe php class
					'unsubscribe_email_category': yalwa.v.tracking_category
				});
			}
		}
	}

	function is_hybrid_user(email) {
		return jQuery.ajax({
			url: API_PATH_DOL,
			type: 'post',
			dataType: 'json',
			data: {
				action: 'is_hybrid_user',
				email: email
			}
		});
	}

	const helper = (function(pub) {

		pub = pub || {};

		var is_tippy_loaded = false;
		const HEADER_HEIGHT_IN_PIXEL = 44;
		const location_fallback_input = true;
		let selected_location_suggestion;
		let is_datePicker_open = false;

		pub.ripple_init = function() {
			jQuery('body').on('click', '.animation_ripple', ripple_click);
			jQuery('.animation_ripple').map((index, el) => {
				jQuery(el).prepend(jQuery('<div class="ripple_fx"></div>'));
			});
		};

		pub.ripple_add = function($elements) {
			if ($elements) {
				$elements.each(index => {
					let $element = jQuery($elements[index]);
					if (!$element.hasClass('animation_ripple')) {
						$element.addClass('animation_ripple');
						$element.prepend(jQuery('<div class="ripple_fx"></div>'));
					}
				});
			}
		};

		function ripple_click(e) {
			const ripple_duration = 410;
			let el = this;
			let $el = jQuery(el);
			let el_offset = el.getBoundingClientRect();
			let click_offset = {
				x: Math.round(e.clientX - el_offset.left),
				y: Math.round(e.clientY - el_offset.top)
			};
			let css_vars = {};
			css_vars['--click-offset-x'] = click_offset.x + 'px';
			css_vars['--click-offset-y'] = click_offset.y + 'px';
			css_vars['--click-max-r'] = Math.round(Math.sqrt(Math.pow(Math.max(click_offset.x, el.offsetWidth - click_offset.x), 2) + Math.pow(Math.max(click_offset.y, el.offsetHeight - click_offset.y), 2))) + 'px';
			css_vars['--click-el-w'] = el.offsetWidth + 'px';
			css_vars['--click-wl-h'] = el.offsetHeight + 'px';
			css_vars['--rd'] = ripple_duration + 'ms';
			jQuery.each(css_vars, (key, value) => {
				el.style.setProperty(key, value);
			});
			$el.find('.ripple_fx').addClass('animate');
			setTimeout(() => {
				$el.find('.ripple_fx').removeClass('animate');
			}, ripple_duration);
		}

		pub.set_height_initial = function() {
			// open/closed keyboard is a factor as well
			const client_height = yalwa.v.is_ios ? window.innerHeight : document.documentElement.clientHeight;
			// when the settings page is reloaded, the header height is 0, set it manually
			const header_height = jQuery('.js-htabs').closest('header').outerHeight() || HEADER_HEIGHT_IN_PIXEL;
			const h = client_height - header_height;
			jQuery('.js-htab_section').each(function() {
				jQuery(this).css({height: h});
			});
		};

		pub.tippy_init = function(element, content) {
			if (is_tippy_loaded) {
				return apply_tippy(element, content);
			}
			is_tippy_loaded = true;
			return yalwa.basics.load_tippy().done(() => {
				apply_tippy(element, content);
			});
		};

		pub.profile_location_distance = function(event) {
			let $this = event.target;
			if ($this.offsetWidth < $this.scrollWidth) {
				helper.tippy_init($this, $this.innerText);
			}
		};

		function apply_tippy(element, content) {
			tippy(element, {
				content: content,
				theme: 'dating',
				placement: 'top',
				maxWidth: 200,
				showOnCreate: true,
				trigger: 'click',
				interactive: true,
				hideOnClick: true,
				offset: [0, 15]
			});
		}

		pub.is_valid_pwd = function($pwd, show_toaster = true) {
			let result;
			jQuery.ajax({
				url: '/api/ajax/general',
				type: 'post',
				dataType: 'json',
				async: false,
				cache: false,
				data: {
					dol: true,
					action: 'check_pw_validation',
					pwd: $pwd.val()
				}
			}).done((response) => {
				if (response.success === true) {
					result = true;
				} else {
					result = false;
					if (show_toaster) {
						$pwd.velocity('callout.shake');
						yalwa.dol.toast({message: response.message, type: 'error'});
					}
				}
			});
			return result;
		};

		pub.check_current_pw = function($pwd) {
			let result;
			jQuery.ajax({
				url: API_PATH_DOL,
				type: 'post',
				dataType: 'json',
				async: false,
				cache: false,
				data: {
					action: 'check_current_pw',
					current_pwd: $pwd.val()
				}
			}).done((response) => {
				if (response.success === true) {
					result = true;
				} else {
					result = false;
					$pwd.velocity('callout.shake');
					yalwa.dol.toast({message: yalwa.v.lang.change_pw_error, type: 'error'});
				}
			});
			return result;
		};

		/**
		 * @desc function to add random background image to the element
		 * @param $element
		 */
		pub.add_random_background = ($element) => {
			if ($element === undefined) {
				return;
			}

			if ($element.length === 0) {
				return;
			}

			const bg_img = yalwa.v.static_images_url + 'bg/dol/bg/' + yalwa.basics.get_random_int(1, 12) + '.jpg';
			$element.css({
				'background': "url(" + bg_img + ")",
				'background-size': 'cover',
				'background-position': 'center'
			});
		};

		pub.create_iframe = ($page) => {
			const $allowed_iframes = [yalwa.v.VIEW_TERMS, yalwa.v.VIEW_PRIVACY, yalwa.v.VIEW_CONTACT];
			if (!$page) {
				return null;
			}
			if ($allowed_iframes.indexOf($page) === -1) {
				return null;
			}
			const iframe = document.createElement("iframe");
			iframe.src = yalwa.dol.build_url($page) + '?embedded=1';
			return iframe;
		};

		pub.convert_local_to_db_standard = function(parts) {
			// standard db format is yyyy.mm.dd
			let sorted = [];
			switch (yalwa.v.countryID) {
				case 1:
					sorted.push(parts[2]);
					sorted.push(parts[0]);
					sorted.push(parts[1]);
					break;
				case 5:
				case 6:
				case 9:
					sorted = parts;
					break;
				default:
					sorted = parts.reverse();
			}
			return sorted;
		};

		pub.convert_db_standard_to_local = function(input_text) {
			//standard db format yyyy-mm-dd
			let converted_input = '';
			if (input_text === '' || input_text === null) {
				return input_text;
			}
			let parts = input_text.split('-');
			//already converted ?
			if (parts.length < 3) {
				return input_text;
			}
			let delimiter;
			delimiter = '.';

			switch (yalwa.v.countryID) {
				case 1:
					converted_input = parts[1] + delimiter + parts[2] + delimiter + parts[0];
					break;
				case 5:
				case 6:
				case 9:
					converted_input = parts[0] + delimiter + parts[1] + delimiter + parts[2];
					break;
				default:
					converted_input = parts[2] + delimiter + parts[1] + delimiter + parts[0];
					break;
			}

			return converted_input;
		};

		/**
		 * get the profile status from the server
		 */
		pub.get_status = () => {
			return yalwa.basics.ajaxservice({
				action: 'status',
				resource: 'profile',
			});
		};

		pub.is_frozen = () => yalwa.v.dol_profile_status === yalwa.v.STATUS_FROZEN;

		pub.is_unconfirmed = () => yalwa.v.dol_profile_status === yalwa.v.STATUS_UNCONFIRMED;

		pub.is_pending = () => yalwa.v.dol_profile_status === yalwa.v.STATUS_PENDING;

		pub.is_active = () => yalwa.v.dol_profile_status === yalwa.v.STATUS_ACTIVE;
		
		pub.is_paused = () => yalwa.v.dol_profile_status === yalwa.v.STATUS_PAUSED;

		pub.is_female = () => yalwa.v.gender === yalwa.v.GENDER_FEMALE;

		pub.detect_device_type = () => {
			var sUserAgent = navigator.userAgent,
				isMobile =
					{
						Android: sUserAgent.match(/Android|Silk/i),
						iOS: sUserAgent.match(/iPhone|iPad|iPod/i),
						Windows: sUserAgent.match(/IEMobile/i)
					};
			isMobile.other = !(isMobile.Android || isMobile.iOS || isMobile.Windows);
			if (sUserAgent.match(/Android|Silk/i)) {
				return 'Android';
			} else if (sUserAgent.match(/iPhone|iPad|iPod/i)) {
				return 'iOS';
			} else if (sUserAgent.match(/IEMobile/i)) {
				return 'Windows';
			} else {
				return 'Default';
			}
		};

		pub.nickname_valid = function(context) {
			var $n = jQuery('.js-dol_nickname');
			var $n_without_spaces = $n.val().replace(/\s+/g, '');
			if ($n_without_spaces.length < 3) {
				$n.velocity('callout.shake');
				yalwa.dol.toast({message: yalwa.v.lang.dol_name_too_short, type: 'error'});
				return false;
			}
			if (!$n.val()) {
				$n.velocity('callout.shake');
				yalwa.dol.toast({message: yalwa.v.lang.dol_name_too_short, type: 'error'});
				return false;
			}
			if ($n.val().length < 3) {
				$n.velocity('callout.shake');
				yalwa.dol.toast({message: yalwa.v.lang.dol_name_too_short, type: 'error'});
				return false;
			}
			if ($n.val().match(/[^A-Za-z-_àáâäœæçéèêëîïíñoöôóùúûüÿÄÖÜ\s]/)) {
				$n.velocity('callout.shake');
				if (context === 'onboarding') {
					jQuery('.js-name_numbers_symbols').trigger('plp_show');
				} else {
					yalwa.dol.toast({message: yalwa.v.lang.dol_name_invalid_characters_error, type: 'error'});
				}
				return false;
			}
			if (yalwa.v.name_change_forced) {
				if ($n.val().search(yalwa.v.name_change_forced) > -1) {
					$n.velocity('callout.shake');
					yalwa.dol.toast({message: yalwa.v.lang.dol_name_error_not_changed, type: 'error'});
					return false;
				}
			}
			return true;
		};

		pub.on_geolocation = function(event, position) {
			if (position && position.coords && position.coords.latitude && position.coords.longitude) {
				let lat = position.coords.latitude;
				let lon = position.coords.longitude;
				jQuery.ajax({
					url: '/api/geo/nnsearch/',
					data: {
						lat: lat,
						lon: lon,
						opencage: true
					},
					dataType: 'json'
				}).done(function(response) {
					if (response.success && response.location) {
						let location_source = response.hasOwnProperty('source') ? response.source : 1;
						let location_data = response.hasOwnProperty('add_data') ? response.add_data : {};
						pub.save_location(response.location, lat, lon, response.distance, location_source, location_data);
					}
				}).fail(function() {
					yalwa.dol.toast({message: yalwa.v.lang.an_error_occurred, type: 'error'});
				});
			}
		};

		pub.no_gps = function(event, error) {
			if (error && yalwa.v.is_dol_app) {
				yalwa.basics.ga.event({
					category: 'dol_geolocation_error',
					action: yalwa.v.is_dol_app,
					label: 'code: ' + error.code + ' message: ' + error.message
				});
			}
			
			if (yalwa.basics.get_routing() === 'dol_onboarding' ||  yalwa.dol.upload.get_signup_flow() === 'native_ads') {
				if (yalwa.basics.ls_get('last_areaID') && parseInt(yalwa.basics.ls_get('last_areaID')) !== 255) {
					jQuery.ajax({
						url: '/api/geo/coordinates_by_area',
						dataType: 'json',
						type: 'get',
						data: {areaID: yalwa.basics.ls_get('last_areaID')}
					}).done((response) => {
						pub.save_location(response.name, response.location.lat, response.location.lon, 0).fail(() => {
							if (location_fallback_input) {
								pub.location_problem_show();
							} else {
								no_location();
							}
						});
					});
				} else {
					get_location_fallback().done((r) => {
						if (r.success) {
							if (location_fallback_input) {
								pub.location_problem_show(r);
							} else {
								pub.save_location(r.name, r.lat, r.lon, 0).fail(no_location);
							}
						} else {
							if (location_fallback_input) {
								pub.location_problem_show();
							} else {
								no_location();
							}
						}
					});
				}
			} else {
				no_location();
			}
		};

		pub.trigger_geolocation = function(delay) {
			if (navigator.permissions) {
				navigator.permissions.query({name: 'geolocation'})
					.then(function(a) {
						switch (a.state) {
							case 'denied':
								pub.no_gps();
								break;
							case 'prompt':
							case 'granted':
							default:
								setTimeout(() => {
									yalwa.mobile.get_current_position(10000, 'dol');
								}, delay);
								break;
						}
					});
			} else {
				setTimeout(() => {
					yalwa.mobile.get_current_position(10000, 'dol');
				}, delay);
			}
		};

		pub.save_location = function(name, lat, lon, distance, source = 1, add_data = {}) {
			jQuery('.js-dol_location_input').val(name);
			return yalwa.dol.profile.save({
				action: 'save',
				section: 'location',
				location_lat: lat,
				location_lon: lon,
				location_name: name,
				location_distance: distance,
				location_source: source,
				location_data: JSON.stringify(add_data),
				pid: yalwa.basics.get_get('pid')
			}).done(function(r) {
				if (r.success) {
					$document.trigger('dol.geolocation_save_success');
					if (jQuery('.js-dol_edit_location_name').length) { // profile
						jQuery('.js-dol_edit_location_name').text(name).velocity('callout.pulse');
					} else {
						if (name) {
							jQuery('.js-dol_location_success_button').text(jQuery('.js-dol_location_input').val());
							jQuery('.js-dol_location_success').removeClass('invisible');
							jQuery('.js-dol_location_success').velocity('callout.pulse');
							//Hide Loader
							yalwa.basics.hide(jQuery('.js_onboarding_location_loader'));
							//Show Next BUtton
							jQuery('.js-dol_register_next_at_location').removeClass('invisible--slide_in');
						}
						clearTimeout(yalwa.v.location_timeout);
						let $next = jQuery('.js-s_active .js-dol_register_next');
						$next.removeClass('invisible--slide_in');
						yalwa.mobile.yli.progress($next, 2000);
						if (yalwa.dol.upload.get_signup_flow() === 'native_ads') {
							//Trigger "done" GA Event
							const discover_url = yalwa.dol.build_url(yalwa.v.VIEW_DISCOVER);
							yalwa.basics.datalayer_push({
								'event': 'onboarding_done_native',
								'settings.page': '/' + yalwa.v.path_segment + '/dol/native-ads-signup/done/',
								'eventCallback': function() {
									yalwa.basics.navigate(discover_url + '?naplp=1');
								},
							});
							
						} else {
							yalwa.v.location_timeout = setTimeout(yalwa.dol.nav.to_discover, 2000);
						}
						
					}
					// for standalone registration send confirmation emails
					if (yalwa.basics.get_routing() === 'dol_onboarding' && yalwa.dol_onboarding.is_brand_new_user()) {
						yalwa.dol_onboarding.send_confirmation_emails();
					}
				} else {
					if (r && r.errors) {
						jQuery(r.errors).each(function(i, error) {
							if (error.message) {
								yalwa.dol.toast({message: error.message, type: 'error'});
							}
						});
					} else {
						yalwa.dol.toast({message: yalwa.v.lang.an_error_occurred, type: 'error'});
					}
				}
			});
		};

		function get_location_fallback() {
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'post',
				data: {
					action: 'get_location_fallback',
				}
			});
		}

		pub.location_problem_show = function(suggestion) {
			location_autocomplete();
			pub.location_problem_show_once = true;
			yalwa.basics.hide(jQuery('.js-location_problem_toggle'));
			yalwa.basics.show(jQuery('.js-dol_location_problem'));
			yalwa.basics.hide(jQuery('.js_onboarding_location_loader'));
			setTimeout(function() {
				jQuery('.js-location_slide').css('top', 0);
			}, 500);
			jQuery('.js-dol_location_problem').parent().parent().css('background', 'none');
			yalwa.basics.bem_modifier(jQuery('.js-location_slide'), 'problem', 'add');

			if (suggestion && suggestion.suggestion && suggestion.lat && suggestion.lon) {
				selected_location_suggestion = {
					display: suggestion.suggestion,
					lat: suggestion.lat,
					lon: suggestion.lon
				};
				jQuery('.js-dol_location_manual').val(suggestion.suggestion).trigger('blur');
				jQuery('.js-dol_location_problem_next').prop('disabled', false);
			}

			jQuery('.js-dol_onboarding_back').css({filter: "invert(1)"});
			jQuery('.js-dol_location_problem_next').on('click', () => {
				if (selected_location_suggestion) {
					yalwa.dol.helper.save_location(selected_location_suggestion.display, selected_location_suggestion.lat, selected_location_suggestion.lon);
					pub.location_problem_hide();
				}
			});
		};

		function location_autocomplete() {
			const $input = jQuery('.js-dol_location_manual');
			$input.on('click', () => {
				jQuery('.js-mbody').css('cssText', 'overflow: unset !important');
			});
			$input.on('input', () => {
				jQuery('.js-dol_location_problem_next').prop('disabled', true);
			});

			let last_suggestions;
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/jquery.autocomplete.js', function() {
				$input.autocomplete({
					appendTo: '.js-location_slide',
					forceFixPosition: true,
					serviceUrl: '/api/geo/geo_search_autocomplete',
					minChars: 2,
					zIndex: 10,
					paramName: 'term',
					params: {
						mobile: 1
					},
					deferRequestBy: 200,
					orientation: 'auto',
					showNoSuggestionNotice: true,
					maxHeight: 400,
					noSuggestionNotice: yalwa.v.lang.dol_location_no_suggestion,
					preventBadQueries: false,
					beforeRender: function(container, suggestions) {
						jQuery(container).addClass('autocomplete-suggestions--locations');
					},
					onSelect: function(suggestion) {
						selected_location_suggestion = suggestion;
						jQuery('.js-dol_location_manual').val(suggestion.display);
						jQuery('.js-dol_location_problem_next').prop('disabled', false);
					},
					onHide: function(container) {
						if (!selected_location_suggestion) {
							setTimeout(() => {
								if (!selected_location_suggestion && last_suggestions.length) {
									jQuery.each(last_suggestions, function(i, e) {
										let q = jQuery('.js-dol_location_manual').val().toLowerCase();
										if (q === e.display.toLowerCase() || q === e.value.toLowerCase()) {
											selected_location_suggestion = e;
											jQuery('.js-dol_location_manual').val(e.display);
											jQuery('.js-dol_location_problem_next').prop('disabled', false);
											return;
										}
									});
								}
							}, 200);
						}

					},
					onSearchComplete: function(query, suggestions) {
						last_suggestions = suggestions;
					}
				});
				if ($input[0].scrollIntoView) {
					$input.on('focus', () => {
						setTimeout(function() {
							$input[0].scrollIntoView({block: 'start'});
						}, 300);
					});
				}
			});
		}

		function no_location() {
			jQuery('.js-dol_no_gps').trigger('plp_show');
			jQuery('.js-toggle_label').each(function(i, e) {
				var $e = jQuery(e);
				switch ($e.data('toggle_label')) {
					case 'dol_your_location_off_how':
						let label = yalwa.v.lang.dol_your_location_off_how;
						if (yalwa.v.is_phonegap && yalwa.v.is_ios) {
							label = yalwa.v.lang.dol_your_location_off_how_ios;
						}
						if (yalwa.v.is_phonegap && !yalwa.v.is_ios) {
							label = yalwa.v.lang.dol_your_location_off_how_android;
						}
						$e.text(label).removeClass('js-toggle_label');
						break;
					default:
						$e.text($e.data('toggle_label')).removeClass('js-toggle_label');
				}
			});
		}

		pub.location_problem_hide = function() {
			jQuery('.js-dol_onboarding_back').css({filter: ''});
			yalwa.basics.show(jQuery('.js-location_problem_toggle'));
			yalwa.basics.hide(jQuery('.js-dol_location_problem'));
			yalwa.basics.bem_modifier(jQuery('.js-location_slide'), 'problem', 'remove');
		};

		pub.init_wheel_date_picker = () => {
			if (!jQuery('.js-dol_birthday_select').length) {
				return;
			}
			// this bd variable only available on settings page
			// on onboarding flow
			// for standalone users it initialized with empty value
			// for hybrid users it is locanto's birthday
			let bd = yalwa.dol.helper.convert_db_standard_to_local(jQuery('.js-dol_birthday_select').val());
			jQuery('.js-dol_birthday_select').val(bd);
			let language_file = 'en';
			let date_time_format = 'dd.MM.yyyy';
			switch (yalwa.basics.language()) {
				case 'german':
					language_file = 'de';
					break;
				case 'french':
					language_file = 'fr';
					break;
				case 'spanish':
					language_file = 'es';
					break;
				default:
					language_file = 'en';
			}
			date_time_format = yalwa.basics.get_datetime_format();
			let date_string = new Date().toDateString();
			let date_array = date_string.split(' ');
			date_array[3] = date_array[3] - 18;
			date_string = date_array.join(' ');
			let selected_date = jQuery(".js-dol_birthday_select").val() ? jQuery(".js-dol_birthday_select").val() : '';
			jQuery('.js-dol_birthday_select').AnyPicker({
				mode: "datetime",
				i18n: jQuery.AnyPicker.i18n[language_file],
				dateTimeFormat: date_time_format,
				theme: yalwa.dol.helper.detect_device_type(),
				selectedDate: selected_date,
				layout: 'popup',
				animationDuration: 0,
				viewSections: {
					footer: ['cancelButton', 'setButton'],
					contentTop: [],
					contentBottom: [],
					header: [],
				},
				onInit: function() {
					$.AnyPicker.extra.bHasCSSAnimation = false;
					// override customized functions
					this._onStartDrag = function(e) {
						var apo = e.data.apo;
						apo.tmp.ap_cont_clicked = true;
						if (!apo.tmp.bIsManualDragging) {
							apo.tmp.bIsManualDraggingAfterShow = true;
							apo.tmp.bIsManualDragging = true;
						}
						apo.tmp.bIsTouched = true;
						apo.tmp.bEnd = false;
						apo.tmp.iPos = apo._getTouchPosition(e);
						apo.tmp.bFromTouchStart = true;
						apo._setScrollingData(e);

						if ($.CF.compareStrings(apo.setting.theme, "Windows")) {
							var $oComp = $(apo.tmp.overlaySelector).find("#ap-component-" + apo.tmp.iScrollingComp);
							if (apo.tmp.bIsManualDragging) {
								$(apo.tmp.overlaySelector).find(".ap-component").removeClass("ap-component-modifying");
								$oComp.addClass("ap-component-modifying");
							}
						}

						if (e.type === "mousedown") {
							$(document).on("mousemove." + apo.setting.timestamp, e.data, apo._onDrag);
							$(document).on("mouseup." + apo.setting.timestamp, e.data, apo._onEndDrag);
						}

						e.preventDefault();
						e.stopPropagation();
						return false;
					};
					this._addViewSectionComponents = function() {
						var apo = this;
						var iTempIndex1, iTempIndex2,
							bWindowsTheme = $.CF.compareStrings(apo.setting.theme, "Windows");

						for (iTempIndex1 = 0; iTempIndex1 < $.AnyPicker.extra.sArrViewSections.length; iTempIndex1++) {
							var sViewSection = $.AnyPicker.extra.sArrViewSections[iTempIndex1];
							var sArrComponents = apo.setting.viewSections[sViewSection];
							if (sArrComponents.length > 0) {
								for (iTempIndex2 = 0; iTempIndex2 < sArrComponents.length; iTempIndex2++) {
									var sComp = sArrComponents[iTempIndex2],
										oComp = apo.setting[sComp] || null,
										$oCompElem = $(oComp.markup);
									if (bWindowsTheme && $.CF.isValid(oComp.markupContentWindows)) {
										$oCompElem.html(oComp.markupContentWindows);
									}

									if (oComp !== undefined && oComp !== null && oComp !== "") {
										if ($.CF.compareStrings(sViewSection, "header")) {
											$(apo.tmp.overlaySelector).find(".ap-header").append($oCompElem); // Append Component
											if ($.CF.compareStrings(oComp.type, "Button") && $.CF.compareDataType(oComp.action, "function")) {
												$oCompElem.on("click." + apo.setting.timestamp, {"apo": apo}, oComp.action);
											} // Bind Action
										} else if ($.CF.compareStrings(sViewSection, "contentTop")) {
											$(apo.tmp.overlaySelector).find(".ap-content-top").append($oCompElem); // Append Component
											if ($.CF.compareStrings(oComp.type, "Button") && $.CF.compareDataType(oComp.action, "function")) {
												$oCompElem.on("click." + apo.setting.timestamp, {"apo": apo}, oComp.action);
											} // Bind Action
										} else if ($.CF.compareStrings(sViewSection, "contentBottom")) {
											$(apo.tmp.overlaySelector).find(".ap-content-bottom").append($oCompElem); // Append Component
											if ($.CF.compareStrings(oComp.type, "Button") && $.CF.compareDataType(oComp.action, "function")) {
												$oCompElem.on("click." + apo.setting.timestamp, {"apo": apo}, oComp.action);
											} // Bind Action
										} else if ($.CF.compareStrings(sViewSection, "footer")) {
											var $oeButtonCont = $(apo.tmp.overlaySelector).find(".ap-button-cont");
											if ($oeButtonCont.length > 0) {
												$oeButtonCont.append($oCompElem);
											} else {
												$(apo.tmp.overlaySelector).find(".ap-footer").append($oCompElem);
											} // Append Component
											if ($.CF.compareStrings(oComp.type, "Button") && $.CF.compareDataType(oComp.action, "function")) {
												$oCompElem.on("click." + apo.setting.timestamp, {"apo": apo}, oComp.action);
											} // Bind Action
										}

										if ($.CF.compareStrings(sComp, "headerTitle") && $.CF.compareStrings(oComp.contentBehaviour, "Static")) {
											$(apo.tmp.overlaySelector).find(".ap-header__title").text(apo.setting.i18n.headerTitle);
										}

										if ($.CF.compareStrings(sComp, "setButton")) {
											if (!bWindowsTheme || (bWindowsTheme && apo.tmp.bModified.set)) {
												$oCompElem.text(apo.setting.i18n.setButton);
											} else if (bWindowsTheme && !apo.tmp.bModified.set) {
												$oCompElem.find(".ap-button-text").text(apo.setting.i18n.setButton);
											}
										} else if ($.CF.compareStrings(sComp, "clearButton")) {
											if (!bWindowsTheme || (bWindowsTheme && apo.tmp.bModified.clear)) {
												$oCompElem.text(apo.setting.i18n.clearButton);
											} else if (bWindowsTheme && !apo.tmp.bModified.clear) {
												$oCompElem.find(".ap-button-text").text(apo.setting.i18n.clearButton);
											}
										} else if ($.CF.compareStrings(sComp, "nowButton")) {
											if (!bWindowsTheme || (bWindowsTheme && apo.tmp.bModified.now)) {
												$oCompElem.text(apo.setting.i18n.nowButton);
											} else if (bWindowsTheme && !apo.tmp.bModified.now) {
												$oCompElem.find(".ap-button-text").text(apo.setting.i18n.nowButton);
											}
										} else if ($.CF.compareStrings(sComp, "cancelButton")) {
											if (!bWindowsTheme || (bWindowsTheme && apo.tmp.bModified.cancel)) {
												$oCompElem.text(apo.setting.i18n.cancelButton);
											} else if (bWindowsTheme && !apo.tmp.bModified.cancel) {
												$oCompElem.find(".ap-button-text").text(apo.setting.i18n.cancelButton);
											}
										}

										if ($.CF.compareStrings(oComp.type, "Button")) {
											if (!$.CF.compareDataType(oComp.action, "function")) {
												if ($.CF.compareStrings(sComp, "setButton")) {
													$oCompElem.on("click." + apo.setting.timestamp, {"apo": apo}, apo._setButtonAction);
												} else if ($.CF.compareStrings(sComp, "clearButton")) {
													$oCompElem.on("click." + apo.setting.timestamp, {"apo": apo}, apo._clearButtonAction);
												} else if ($.CF.compareStrings(sComp, "nowButton")) {
													$oCompElem.on("click." + apo.setting.timestamp, {"apo": apo}, apo._nowButtonAction);
												} else if ($.CF.compareStrings(sComp, "cancelButton")) {
													$oCompElem.on("click." + apo.setting.timestamp, {"apo": apo}, apo._cancelButtonAction);
												}
											}
										}
									}
								}
							}
						}

						if (bWindowsTheme) {
							$(".ap-button-icon, .ap-button-text").click(function(e) {
								$(this).closest(".ap-button").trigger("click");
							});
						}

						$(apo.tmp.overlaySelector).find(".ap-button")
							.on("mousedown touchstart", function(e) {
								//e.stopPropagation();
								//e.preventDefault();
								$(this).addClass("ap-button-active");
							})
							.on("mouseup touchend", function(e) {
								//e.stopPropagation();
								//e.preventDefault();
								$(this).removeClass("ap-button-active");
							});

						$(window).on("blur." + apo.setting.timestamp, function(e) {
							apo.tmp.prevActive = document.activeElement;
						});

						$(apo.tmp.overlaySelector).off("click." + apo.setting.timestamp);

						setTimeout(function() {
							$(apo.tmp.overlaySelector).on("click." + apo.setting.timestamp, function(e) {
								if (apo.tmp.ap_cont_clicked) {
									apo.tmp.ap_cont_clicked = false;
									return false;
								}
								var iDTDiff = Date.now() - apo.tmp.iCompDragStart;
								if (!apo.setting.bIsTouched && iDTDiff > 1000) {
									apo._hidePicker();
								}
							});
						}, 300);
						$(apo.tmp.overlaySelector).find(".ap-cont, .ap-cont *").on("click." + apo.setting.timestamp, function(e) {
							apo.tmp.ap_cont_clicked = true;
							e.stopPropagation();
						});

						$(apo.tmp.overlaySelector).find(".ap-content-switch-date").click(function(e) {
							e.stopPropagation();
							apo._setDateTimeTabs("date");
						});

						$(apo.tmp.overlaySelector).find(".ap-content-switch-time").click(function(e) {
							e.stopPropagation();
							apo._setDateTimeTabs("time");
						});
						$(apo.tmp.overlaySelector).find(".ap-cont, .ap-cont *").on("mousedown." + apo.setting.timestamp, function(e) {
							apo.tmp.ap_cont_clicked = true;
						});
						$(apo.tmp.overlaySelector).find(".ap-cont, .ap-cont *").on("mouseup." + apo.setting.timestamp, function(e) {
							apo.tmp.ap_cont_clicked = false;
						});
						$(window).resize(function() {
							apo._adjustOnOrientationChange();
						});
					};

				},
				onShowPicker: function() {
					is_datePicker_open = true;
					if (yalwa.dol.url_id() === yalwa.v.VIEW_SETTINGS_ACCOUNT) {
						yalwa.v.dol_user_birthday = jQuery(this.setting.inputElement).val();
					}
					if (jQuery(this.setting.inputElement).val() === '') {
						this.setSelectedDate(new Date(date_string));
					}

					if (jQuery(this.setting.inputElement).val()) {
						const current_set_date = jQuery(this.setting.inputElement).val();
						let date_splitted = current_set_date.split('.');
						let date_obj = {};
						switch (yalwa.v.countryID) {
							case 1:
								// 'MM.dd.yyyy';
								date_obj.year = date_splitted[2];
								date_obj.month = date_splitted[0] - 1; // as months are indexed from 0 in js
								date_obj.day = date_splitted[1];
								break;
							case 5:
							case 6:
							case 9:
								// 'yyyy.MM.dd';
								date_obj.year = date_splitted[0];
								date_obj.month = date_splitted[1] - 1; // as months are indexed from 0 in js
								date_obj.day = date_splitted[2];
								break;
							default:
								// 'dd.MM.yyyy';
								date_obj.year = date_splitted[2];
								date_obj.month = date_splitted[1] - 1; // as months are indexed from 0 in js
								date_obj.day = date_splitted[0];
						}
						const b_day = new Date(date_obj.year, date_obj.month, date_obj.day);
						this.setSelectedDate(b_day);
					}
				},
				buttonClicked: function(button) {
					is_datePicker_open = false;
					if (button === 'cancel') {
						if (yalwa.dol.url_id() !== yalwa.v.VIEW_SETTINGS_ACCOUNT) {
							jQuery(this.setting.inputElement).val('');
						}
					}
					jQuery(this.setting.inputElement).trigger('blur');
				},
				onBeforeHidePicker: function() {
					if (yalwa.dol.url_id() === yalwa.v.VIEW_SETTINGS_ACCOUNT) {
						// if the new birthday is same just return
						if (yalwa.v.dol_user_birthday === jQuery(this.setting.inputElement).val()) {
							return;
						}

						// check birthday valid, if invalid, just fill it in with previous birthday
						if (!pub.birthday_valid()) {
							jQuery(this.setting.inputElement).val(yalwa.v.dol_user_birthday);
							return;
						}
						let bd = pub.get_entered_birthday();
						yalwa.basics.ajaxservice({
							action: 'update_profile_birthday',
							resource: 'profile',
							type : 'post',
							data: {
								
								birthday: bd
							}
						})
							
							
							.then(function(r) {
							if (r.success) {
								yalwa.dol.toast({message: yalwa.v.lang.dol_birthday_updated, type: 'success'});
								jQuery('.js-dol_profile_core_age').html(r.age);
							} else {
								yalwa.dol.toast({message: r.message, type: 'error'});
							}
						});
					}

				},
				maxValue: new Date(Date.now()),
				minValue: new Date('1920-01-01'),
			});
		};

		pub.is_datePicker_open = () => is_datePicker_open;

		pub.get_entered_birthday = function() {
			let input_text = jQuery('.js-dol_birthday_select').val() ? jQuery('.js-dol_birthday_select').val() : '';
			if (input_text === '') {
				return input_text;
			}
			let bd_parts = input_text.split('.');
			bd_parts = yalwa.dol.helper.convert_local_to_db_standard(bd_parts);
			let converted_input = '';
			for (let i = 0; i < bd_parts.length; i++) {
				converted_input += bd_parts[i];
				if (bd_parts.length - 1 !== i) {
					converted_input += '-';
				}
			}
			return converted_input;
		};

		pub.birthday_valid = function() {
			var bd = pub.get_entered_birthday();
			if (!is_valid_date(bd)) {
				jQuery('.js-dol_birthday').velocity('callout.shake');
				yalwa.dol.toast({message: yalwa.v.lang.dol_birthday_invalid, type: 'error'});
				return false;
			}
			if (pub.calc_age(bd) < 18) {
				yalwa.dol.toast({message: yalwa.v.lang.dol_birthday_underage_error, type: 'error'});
				return false;
			}
			return true;
		};

		function is_valid_date(d) {
			return !isNaN((new Date(d)).getTime());
		}

		pub.calc_age = function(birthday) {
			var ageDifMs = Date.now() - new Date(birthday).getTime();
			var ageDate = new Date(ageDifMs);
			return Math.abs(ageDate.getUTCFullYear() - 1970);
		};

		pub.show_headroom_htabs = function() {
			yalwa.basics.show(jQuery('.js-htabs_headroom'));
			yalwa.basics.show(jQuery('.js-htabs_dummy'));
		};

		pub.hide_headroom_htabs = function() {
			yalwa.basics.hide(jQuery('.js-htabs_headroom'));
			yalwa.basics.hide(jQuery('.js-htabs_dummy'));
		};

		pub.update_status = function() {
			if (jQuery(this).prop('visibilityState') === 'visible') {
				pub.get_status().then((response) => {
					if (response.success) {
						if (response.status !== parseInt(yalwa.v.dol_profile_status)) {
							yalwa.basics.reload();
						}
					}
				});
			}
		};

		pub.track_tot = function(action, label, value) {
			return yalwa.basics.ga.event({
				category: 'ToT_feature',
				action: action,
				label: label,
				value: value
			});
		};

		pub.init_show_email_confirm_plp = function($confirm_plp, plp_options) {
			$confirm_plp
				.off('click')
				.on('click', '.js-plp_ok', () => {
					const edit_email_url = yalwa.dol.build_url('change-email');
					yalwa.basics.navigate(edit_email_url);
				})
				.off('plp_confirm')
				.on('plp_confirm', function() {
					const resend_url = yalwa.dol.build_url('resend-email')
					yalwa.basics.navigate(resend_url);
				})
				.trigger('plp_show', plp_options);
		};

		return pub;

	}(pub.helper));

	const profile = (function(pub) {

		pub = pub || {};

		let profile_initialized = false;
		let visibility_change_initialized = false;
		let $htab;
		let $profile_edit;
		let $profile_preview_page;

		pub.init = function() {
			if (profile_initialized) {
				return;
			}

			$profile_edit = jQuery('.js-dol_profile_edit');
			$profile_preview_page = jQuery('.js-profile_overview_page');

			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/profile.js', function() {
				profile_initialized = true;
			});
		};

		pub.update_html = function(callback) {
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {action: 'update_dol_profile_own'}
			}).done((r) => {
				jQuery('.js-dol_profile').replaceWith(r.html);
				if (typeof callback === "function") {
					callback();
				}
			});
		};

		pub.save = function(data, use_post) {
			if (IMAGE_ACTIONS.includes(data.action)) {
				data.dim = yalwa.v.dim; //dol_image csrf
			}
			return jQuery.ajax({
				url: API_PATH_DOL,
				data: data,
				dataType: 'json',
				type: use_post ? 'post' : 'get'
			}).done(function(response) {
				if (response.success === true && yalwa.v.has_dol_profile) {
					if (jQuery.inArray(data.action, ['age_range', 'distance', 'gender_interested'])) {
						yalwa.v.filters_changed = true;
					}
					if (jQuery.inArray(data.action, ['gender_interested']) && jQuery('.js-hashtag_selected').length) {
						discover.update_popular_hashtags();
					}
				}
				pub.after_changes_saved();
			}).fail((e) => console.log('error', e));
		};

		function handle_visibility_change_init() {
			if (jQuery(this).prop('visibilityState') === 'visible') {
				refresh_when_status_changed_from_unconfirmed();
			}
		}

		function refresh_when_status_changed_from_unconfirmed() {
			helper.get_status().then((response) => {
				if (response.success) {
					if (typeof (yalwa.v.STATUS_UNCONFIRMED) !== 'undefined' && yalwa.v.dol_profile_status === yalwa.v.STATUS_UNCONFIRMED &&
						response.status !== parseInt(yalwa.v.STATUS_UNCONFIRMED) &&
						response.status !== parseInt(yalwa.v.STATUS_PAUSED)) {
						yalwa.basics.reload();
					}
				}
			});
		}

		pub.show_email_confirm_plp = function(section_id, clicked = false) {
			const plp_options = [{
				is_queued: true,
				htab: {
					allowed: true,
					clicked: clicked
				}
			}]
			const $email_confirm_plp = jQuery('.js-dol_email_confirm_notify_plp');
			const $email_confirm_profile_plp = jQuery('.js-dol_email_confirm_notify_profile_plp');

			if (!$email_confirm_plp.hasClass('hidden')) {
				$email_confirm_plp.trigger('plp_hide', plp_options);
			}
			if (!$email_confirm_profile_plp.hasClass('hidden')) {
				$email_confirm_profile_plp.trigger('plp_hide', plp_options);
			}

			switch (section_id) {
				case 'discover':
					//discover.hide_filter_icon();
					// when profile is paused, do not wait for document trigger to init
					if (clicked) {
						if (discover.results_init_done()) {
							yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/unconfirmed_swipes.js', function() {
								yalwa.unconfirmed_swipes.init(yalwa.v.unconfirmed_swipes_data, clicked);
							});
						} else {
							if (yalwa.dol.discover.results_init_done) {
								yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/unconfirmed_swipes.js', function() {
									yalwa.unconfirmed_swipes.init(yalwa.v.unconfirmed_swipes_data, clicked);
								});
							} else {
								$document.on('results_init_done', () => {
									yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/unconfirmed_swipes.js', function() {
										yalwa.unconfirmed_swipes.init(yalwa.v.unconfirmed_swipes_data, clicked);
									});
								});
							}
						}
					} else {
						// hide the profile section plp
						$email_confirm_profile_plp.trigger('plp_hide', plp_options);
						yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/unconfirmed_swipes.js', function() {
							yalwa.unconfirmed_swipes.init(yalwa.v.unconfirmed_swipes_data, clicked);
						});
					}
					break;
				case 'chats':
					$email_confirm_profile_plp.trigger('plp_hide', plp_options);
					if (parseInt(yalwa.v.matches_count)) {
						helper.init_show_email_confirm_plp($email_confirm_plp);
						//helper.allow_switching_tabs(clicked);
					} else if (!$email_confirm_plp.hasClass('hidden')) {
						$email_confirm_plp.trigger('plp_hide', plp_options);
					}
					break;
				case yalwa.v.VIEW_PHOTO_DUEL:
					// hide the profile section plp
					$email_confirm_profile_plp.trigger('plp_hide', plp_options);
					break;

				case yalwa.v.VIEW_LIKES:
					$email_confirm_profile_plp.trigger('plp_hide', plp_options);
					break;
					
				default:
					$email_confirm_plp.trigger('plp_hide', plp_options);
					// init and show email confirm plp
					helper.init_show_email_confirm_plp($email_confirm_profile_plp, plp_options);
					//helper.allow_switching_tabs(clicked);
					break;
			}
			refresh_when_status_changed_from_unconfirmed();
			if (!visibility_change_initialized) {
				visibility_change_initialized = true;
				$document.on('visibilitychange', handle_visibility_change_init);
			}
		};

		pub.check_status = function() {
			jQuery('.js-pic_guide_link_on_plp').off('click').on('click', show_pic_guide_from_frozen_plp);
			if (yalwa.v.show_email_confirm_plp) {
				email_confirm_plp();
				return;
			}
			if (!yalwa.basics.is_logged_in()) {
				return;
			}
			const $htabs = jQuery('.js-htabs_headroom .js-htabs_item');
			if (!yalwa.v.is_email_confirmed) {
				setTimeout(pub.show_email_confirm_plp(yalwa.dol.url_id()), 500);
				// show email confirmation plp on clicking swipe or chat htab
				$htabs.on('click', function() {
					let section_id = jQuery(this).data('sectionid');
					pub.show_email_confirm_plp(section_id, true);
				});
				return;
			}
			if (!yalwa.v.has_dol_profile) {
				return;
			}

			if (helper.is_frozen()) {
				yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/frozen_swipes.js', function() {
					yalwa.frozen_swipes.init(yalwa.dol.url_id(), false, yalwa.v.frozen_swipes_data);
				});
				$htabs.on('click', function(e, show_silently) {
					const section_id = jQuery(this).data('sectionid');
					yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/frozen_swipes.js', function() {
						yalwa.frozen_swipes.init(section_id, true, yalwa.v.frozen_swipes_data, show_silently);
					});
				});
			}
		};

		/**
		 * method decides which frozen plp should be shown to the users
		 */
		let frozen_info_title = "";
		let frozen_info_shortinfo = "";
		//true = ff_activated (will see new changed)
		//false = ff not activated (will not see new changes)
		let ff_frozen_info_active = true;
		
		pub.show_frozen_plp = () => {
			if (!helper.is_frozen()) {
				return;
			}

			// do not show on feedback view
			if (yalwa.dol.url_id() === 'settings-feedback' || yalwa.dol.url_id() === 'edit-profile') {
				return;
			}
			
			if (!yalwa.v.has_pictures) {
				if (!yalwa.v.is_foto_skipped) {
					if (ff_frozen_info_active) {
						trigger_frozen_overlay('frozen_info__overlay_blocked', yalwa.v.dol_pic_rules_title2, yalwa.v.dol_pic_rules_info2);
					}

					let $dol_photo_profile_moderated_plp = jQuery('.js-dol_photo_profile_moderated');
					$dol_photo_profile_moderated_plp
						.off('plp_confirm')
						.on('plp_confirm', user_without_pictures_handling)
						.on('plp_show', function() {
							yalwa.basics.ls_set('fr_plp', 'foto_del');
						});
					//https://yalwa.atlassian.net/browse/DEV-9265
					if (yalwa.dol.url_id() !== yalwa.v.VIEW_PROFILE) {
						if (yalwa.dol.url_id() === yalwa.v.VIEW_LIKES) {
							//trigger_frozen_plp_to_show_on_likes($dol_photo_profile_moderated_plp);
						} else {
							if (yalwa.dol.url_id() === yalwa.v.VIEW_STREAM) {
								//do nothing
							} else {
								$dol_photo_profile_moderated_plp.trigger('plp_show');
							}
						}
					}
					
				} else { // plp for foto skipped profiles
					//https://yalwa.atlassian.net/browse/DEV-9265
					let $foto_skipped_plp = jQuery('.js-dol_foto_skipped_plp');
					$foto_skipped_plp
						.off('plp_confirm')
						.on('plp_confirm', user_without_pictures_handling)
						.on('plp_show', function() {
							yalwa.basics.ls_set('fr_plp', 'foto_skip');
						});
					//https://yalwa.atlassian.net/browse/DEV-9265
					if (yalwa.dol.url_id() !== yalwa.v.VIEW_PROFILE) {
						if (yalwa.dol.url_id() === yalwa.v.VIEW_LIKES) {
							//trigger_frozen_plp_to_show_on_likes($foto_skipped_plp);
						} else if (yalwa.dol.url_id() === yalwa.v.VIEW_STREAM) {
							//do nothing
						} else {
							$foto_skipped_plp.trigger('plp_show');
						}
					}
				}
				
			}  else {
				if (yalwa.v.name_change_forced) {
					let $dol_name_change_necessary = jQuery('.js-dol_name_change_necessary');
					$dol_name_change_necessary
						.off('plp_confirm')
						.on('plp_confirm', name_change_forced_handling)
						.trigger('plp_show');
				} else if (yalwa.v.profile_picture_change_forced) {
					//Trigger frozen overlay
					if (ff_frozen_info_active) {
						trigger_frozen_overlay('frozen_info__overlay_rejected', yalwa.v.dol_pic_rules_title, yalwa.v.dol_pic_rules_info);
					}
					let $dol_profile_image_change_necessary = jQuery('.js-dol_profile_image_change_necessary');
					$dol_profile_image_change_necessary
						.off('plp_confirm')
						.on('plp_confirm', image_change_necessary_handling)
						.on('plp_show', function() {
							yalwa.basics.ls_set('fr_plp', 'foto_change');
						});
					//https://yalwa.atlassian.net/browse/DEV-9265
					if (yalwa.dol.url_id() !== yalwa.v.VIEW_PROFILE) {
						if (yalwa.dol.url_id() === yalwa.v.VIEW_LIKES) {
							//trigger_frozen_plp_to_show_on_likes($dol_profile_image_change_necessary);
						} else if (yalwa.dol.url_id() === yalwa.v.VIEW_STREAM) {
							//do nothing
						} else {
							$dol_profile_image_change_necessary.trigger('plp_show');
						}
					}
				}
			}
		};
		
		/**
		 * @desc method to show the plp on liked you
		 * @param $element
		 */
		function trigger_frozen_plp_to_show_on_likes($element) {
			if (document.readyState === "complete") {
				if (yalwa.v.has_liked_by_profiles) {
					$element.trigger('plp_show');
				}
			} else {
				jQuery(window).on('load', function () {
					if (yalwa.v.has_liked_by_profiles) {
						$element.trigger('plp_show');
						yalwa.frozen_swipes.allow_switching_tabs(yalwa.v.VIEW_LIKES);
					}
				});
			}
		}
		/**
		 * New Methods for frozen overlay
		 */
		function trigger_frozen_overlay($type, $title, $info) {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/frozen_overlay.js');
			//Set this everytime
			frozen_info_title = $title;
			frozen_info_shortinfo = $info;
			if (!yalwa.basics.ls_get($type)) {
				show_frozen_overlay();
				yalwa.basics.ls_set($type, true);

				yalwa.basics.ga.event({
					category: 'frozen_review_page',
					label: ($type === 'frozen_info__overlay_rejected') ? 'No Person' : 'Blocked',
					action: 'impressions',
					method_explicit: 'c.send'
				});

				return true;
			}
			return false;
		}

		if (ff_frozen_info_active) {
			init_frozen_overlay();
		}

		function init_frozen_overlay() {
			if (!ff_frozen_info_active) {
				return false;
			}
			//yalwa.basics.load_js(yalwa.basics.static_url('js') + 'mobile/dol/frozen_overlay.js');
			//Trigger image upload on click
			jQuery('.js-frozen_info_trigger_image_upload').on('click', function() {
				jQuery('.js-dol_profile_image_change_necessary').trigger('plp_hide');
				hide_frozen_overlay();
				image_change_necessary_handling();
			});
		}

		function show_frozen_overlay() {
			jQuery('.js-frozen_info_title').html(frozen_info_title);
			jQuery('.js-frozen_info_shortinfo').html(frozen_info_shortinfo);
			yalwa.basics.show(jQuery('.js-full_screen_overlay'));

		}

		function hide_frozen_overlay() {
			yalwa.basics.hide(jQuery('.js-full_screen_overlay'));
		}

		function show_pic_guide_from_frozen_plp() {
			if (ff_frozen_info_active) {
				show_frozen_overlay();
				return false;
			}
			$htab = jQuery('.js-htabs_item[data-sectionid="' + yalwa.v.VIEW_PROFILE + '"]');
			jQuery(this).closest('.js-plp').trigger('plp_hide');
			// margin-top is set to switch between tabs on profile view
			// so reset here when showing pic guide
			jQuery('.js-generic_shadow').css({'margin-top': '0'});

			// when profile section/tab is not opened
			if (jQuery('.js-htab_section[data-htabs_sectionid="' + yalwa.v.VIEW_PROFILE + '"]').hasClass('hidden')) {
				$htab.trigger('click', [true]);
				// hide the opened frozen plp on clicking the profile tab
				jQuery('.js-plp').not('.hidden').trigger('plp_hide');
				setTimeout(() => {
					yalwa.dol.pic_guide.init('', 'frozen_plp');
				}, 500);
				return;
			}
			if (!$profile_edit.hasClass('hidden')) {
				setTimeout(() => {
					yalwa.dol.pic_guide.init('', 'frozen_plp');
				}, 500);
				return;
			}
			$htab.trigger('click', [true]);
			hide_profile_preview();
			setTimeout(() => {
				yalwa.dol.pic_guide.init('', 'frozen_plp');
			}, 500);
		}

		function hide_profile_preview() {
			const $profile_preview = jQuery('.js-dol_profile');
			if ($profile_preview.hasClass('hidden')) {
				return;
			}
			yalwa.basics.hide($profile_preview);
			reset_profile_section_height();
			yalwa.dol.helper.show_headroom_htabs();
			yalwa.basics.show(jQuery('.js-profile_overview_page'));
		}

		pub.hide_profile_preview = hide_profile_preview;

		function reset_profile_section_height() {
			const HTABS_HEIGHT = 44;
			jQuery('.js-htab_section[data-htabs_sectionid="' + yalwa.v.VIEW_PROFILE + '"]').css({'height': window.innerHeight - HTABS_HEIGHT});
		}

		pub.reset_profile_section_height = reset_profile_section_height;

		pub.init_account_cooldown_plp = function() {
			jQuery('.js-dol_account_cooldown_plp').on('click', '.js-plp_ok', function() {
				if (yalwa.basics.is_dol_app()) {
					yalwa.basics.auth.logout().done(function(response) {
						if (response.success) {
							yalwa.mobile.cordova.cordova_send({action: 'logout', params: {}});
							//Turn off auto sign-in for future visits
							if (yalwa.basics.auth.credential_api_support()) {
								navigator.credentials.preventSilentAccess();
							}
							yalwa.basics.navigate(yalwa.v.dol_url_base + 'signup/');
						} else {
							yalwa.basics.toast({message: response.message, type: 'error'});
						}
					});
				} else {
					if (parseInt(yalwa.v.dol_user_type) === 2) { // hybrid
						yalwa.basics.navigate(yalwa.v.chp_url);
					} else {
						yalwa.basics.auth.logout().done(() => {
							yalwa.basics.navigate(yalwa.v.dol_url_base + 'signup/');
						});
					}
				}
			});
		};

		function check_icon_blue() {
			const $icon = jQuery('.js-dol_settings_back');
			yalwa.basics.yicon_modifier($icon, 'gray', 'remove');
			yalwa.mobile.force_repaint(jQuery('.js-dol_settings_back'));
		}

		pub.after_changes_saved = function() {
			check_icon_blue();
		};

		pub.pause_request = function(action) {
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {
					action: action + '_profile',
				}
			});
		};

		function email_confirm_plp() {
			let close_via_confirm = false;
			jQuery('.js-dol_email_confirm_plp')
				.off('plp_confirm')
				.on('plp_confirm', function() {
					close_via_confirm = true;
					yalwa.basics.set_get({'email-confirm': null});
					check_redirect_after_email_confirm();
				})
				.on('plp_hide', function() {
					if (!close_via_confirm) {
						yalwa.basics.navigate(yalwa.v.dol_url_base + yalwa.v.VIEW_DISCOVER);
					}
				})
				.trigger('plp_show');

			//To Trigger the frozen PLP (even after user click on upload photo and then cancel it
			const $htabs = jQuery('.js-htabs_headroom .js-htabs_item');
			if (helper.is_frozen()) {
				$htabs.on('click', function(e, show_silently) {
					const section_id = jQuery(this).data('sectionid');
					yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/frozen_swipes.js', function() {
						yalwa.frozen_swipes.init(section_id, true, yalwa.v.frozen_swipes_data, show_silently);
					});
				});
			}
		}

		function check_redirect_after_email_confirm() {
			if (yalwa.basics.is_logged_in()) {
				if (yalwa.v.email_confirmed) {
					if (!yalwa.v.swipe_pledge_value) {
						//yalwa.basics.navigate(yalwa.v.dol_url_base + yalwa.v.VIEW_SWIPE_PREFERENCE);
					} else if (yalwa.v.redirect_to_photo_upload) {
						//Show photo native upload dialog
						user_without_pictures_handling();
					} else {
						if (location.href.search(yalwa.v.path_segment + '/dol/discover') === -1) {
							yalwa.basics.navigate(yalwa.v.dol_url_base + yalwa.v.VIEW_DISCOVER);
						}
					}
				} else {
					if (yalwa.v.redirect_to_photo_upload && redirect_to_foto) {
						user_without_pictures_handling();
					} else {
						yalwa.basics.navigate(yalwa.v.dol_url_base + yalwa.v.VIEW_PROFILE);
					}
				}
			} else {
				yalwa.basics.navigate(yalwa.v.dol_url_base + yalwa.v.VIEW_ONBOARDING);
			}
		}

		function name_change_forced_handling() {
			if (!$htab || !$htab.length) {
				$htab = jQuery('.js-htabs_item[data-sectionid="' + yalwa.v.VIEW_PROFILE + '"]');
			}
			$htab.trigger('click');
			const $modal = jQuery('.js-modal[data-modal_id="name"]');
			modal_open($modal);
			jQuery('.js-dol_update_name').on('click', nickname_check);
		}

		function modal_open($modal) {
			yalwa.basics.state.push('settings_modal');
			yalwa.basics.hide($modal.closest('.js-dol_page').find('.js-settings_body'));
			yalwa.basics.show($modal);
			yalwa.basics.show($modal.closest('.js-settings_modals'));
			$modal.trigger('modal_shown');
		}

		pub.modal_open = modal_open;

		function nickname_check() {
			if (!helper.nickname_valid()) {
				return;
			}
			var data = {action: 'save', 'section': 'name_change'};
			profile.save(jQuery.extend(data, {
				'name': jQuery('.js-dol_nickname').val()
			})).done(function(r) {
				if (r.success) {
					yalwa.basics.reload();
				} else {
					if (r && r.errors) {
						jQuery(r.errors).each(function(i, error) {
							if (error.message) {
								jQuery('.js-dol_nickname').velocity('callout.shake');
								yalwa.dol.toast({message: error.message, type: 'error'});
							}
						});
					} else {
						yalwa.dol.toast({message: yalwa.v.lang.an_error_occurred, type: 'error'});
					}
				}
			});
		}

		pub.user_without_pictures_handling = () => user_without_pictures_handling();

		function user_without_pictures_handling() {
			$htab = jQuery('.js-htabs_item[data-sectionid="' + yalwa.v.VIEW_PROFILE + '"]');
			// from settings-account page
			if (yalwa.dol.url_id() === yalwa.v.VIEW_SETTINGS_ACCOUNT) {
				// go two step back
				yalwa.basics.state.back();
				yalwa.basics.state.back();
				trigger_image_upload_click();
				return;
			}

			// from settings page
			if (yalwa.dol.url_id() === 'settings') {
				yalwa.basics.state.back();
				trigger_image_upload_click();
				return;
			}

			if (jQuery('.js-htab_section[data-htabs_sectionid="' + yalwa.v.VIEW_PROFILE + '"]').hasClass('hidden')) {
				$htab.trigger('click');
				// hide the opened plp
				jQuery('.js-plp').not('.hidden').trigger('plp_hide');
				trigger_image_upload_click();
				return;
			}

			if (!$profile_edit.hasClass('hidden')) {
				trigger_image_upload_click();
				return false;
			}

			if (!$htab.hasClass('htabs__item--chosen')) {
				$htab.trigger('click');
			}
			
			if (!$profile_preview_page.hasClass('hidden')) {
				yalwa.basics.hide($profile_preview_page);
				yalwa.profile.edit_profile_show();
			}

			hide_profile_preview();
			trigger_image_upload_click();
		}

		pub.image_change_necessary_handling = image_change_necessary_handling;

		function image_change_necessary_handling() {
			user_without_pictures_handling();
		}

		pub.trigger_image_upload_click = trigger_image_upload_click;

		function trigger_image_upload_click() {
			if (yalwa.v.is_phonegap && !yalwa.v.is_ios) {
				setTimeout(function() {
					jQuery(jQuery('.js-dol_upload_overview')[0]).trigger('click');
				}, 1000);
			} else {
				jQuery(jQuery('.js-dol_file')[0]).trigger('click');
			}
		}

		pub.chat_app_promo = () => {
			// show app promo on chat top
			const $app_promo_chat_top = jQuery('.js-app_promo_chat_top');
			const chat_partner_name = jQuery('.js-chat_details_name').data('partner-name');
			const chat_partner_img = jQuery('.js-mc_details_head__avatar').attr('src');
			if (($app_promo_chat_top.length && yalwa.dol.profile.show_cordova_app_promo())
				&& (yalwa.dol.profile.check_chat_promo_delay() && !yalwa.basics.get_cookie('dol_chat_promo') && !yalwa.basics.ls_get('dol_chat_promo_do_not_show'))
			) {
				const $element = jQuery('.js-app_promo_chat_top');
				if (jQuery('.js-app_promotion_label--chat').length && chat_partner_name && chat_partner_img) {
					let label = yalwa.v.lang.dol_pwa_promo_message_text;
					jQuery('.js-app_promotion_label--chat').text(label.replace('%1$s', chat_partner_name));
					jQuery('.js-chat_promo_usr_img').attr('src', chat_partner_img);
					yalwa.basics.no_more_lonely_words(jQuery('.js-app_promotion_label--chat'));
					yalwa.basics.show($element);
					yalwa.basics.ls_set('dol_last_seen_chat_promo', Date.now());
					setTimeout(yalwa.dol.profile.auto_close_chat_promo, 60000);
					yalwa.basics.ls_set('dol_chat_promo_seen_count', yalwa.basics.ls_get('dol_chat_promo_seen_count') ? parseInt(yalwa.basics.ls_get('dol_chat_promo_seen_count')) + 1 : 1);
					yalwa.dol.profile.handle_showing_do_not_show_checkbox_chat();
					// gtm tracking
					// https://yalwa.atlassian.net/browse/DEV-10418
					yalwa.basics.datalayer_push({
						'event': 'app_install_promo_impression',
						'app_install_promo_touchpoint': 'app_promo_headroom_mc'
					});
				}
				jQuery('.js-app_promotion_close_chat').off('click').on('click', {cookie: true}, yalwa.dol.profile.handle_closing_promo_on_chat);
				jQuery('.js-view_back').on('click', {cookie: false}, yalwa.dol.profile.handle_closing_promo_on_chat);
				jQuery('.js-promo_install_btn').on('click', function() {
					yalwa.basics.navigate(yalwa.v.app_promo_url);
				});
			}
		};

		pub.show_cordova_app_promo = () => {
			return ((yalwa.dol.helper.detect_device_type() === 'Android' && !yalwa.v.seen_with_android_app) || (yalwa.dol.helper.detect_device_type() === 'iOS' && !yalwa.v.seen_with_ios_app)) && !yalwa.v.is_phonegap;
		};

		pub.handle_showing_do_not_show_checkbox_chat = () => {
			if (yalwa.basics.ls_get('dol_chat_promo_seen_count') >= 3) {
				let $app_promo_do_not_show_wrap = jQuery('.js-app_promo_do_not_show_wrap');
				yalwa.basics.show($app_promo_do_not_show_wrap);
				$app_promo_do_not_show_wrap.off('click').on('click', function() {
					if (jQuery('.js-app_promo_do_not_show_input').is(':checked')) {
						yalwa.basics.datalayer_push({
							'event': 'app_install_promo_dont_show',
							'app_install_promo_touchpoint': 'app_promo_headroom_mc'
						});
					}
				});
			}
		};

		pub.auto_close_chat_promo = () => {
			yalwa.basics.hide(jQuery('.js-app_promo_chat_top'));
			
			// gtm tracking
			// https://yalwa.atlassian.net/browse/DEV-10418
			yalwa.basics.datalayer_push({
				'event': 'app_install_promo_auto_close',
				'app_install_promo_touchpoint': 'app_promo_headroom_mc'
			});
		};

		pub.check_chat_promo_delay = () => {
			let last_seen = yalwa.basics.ls_get('dol_last_seen_chat_promo');
			if (last_seen === null) {
				return true;
			}
			let three_days_ago = new Date();
			three_days_ago.setDate(three_days_ago.getDate() - 3);
			return last_seen < three_days_ago;
		};

		pub.handle_closing_promo_on_chat = (event) => {
			let ls_promo_viewed_times = yalwa.basics.ls_get('dol_chat_promo_seen_count');

			if (event.data.cookie) {
				if (!ls_promo_viewed_times || ls_promo_viewed_times < 3) {
					yalwa.basics.set_cookie('dol_chat_promo', 1, yalwa.basics.ONE_WEEK);
				} else if (ls_promo_viewed_times >= 3) {
					yalwa.basics.set_cookie('dol_chat_promo', 1, yalwa.basics.ONE_MONTH);
				}
			}

			if (!jQuery('.js-app_promo_do_not_show_wrap').hasClass('hidden')) {
				if (jQuery('.js-app_promo_do_not_show_input').is(':checked')) {
					yalwa.basics.ls_set('dol_chat_promo_do_not_show', true);
				}
			}

			yalwa.basics.hide(jQuery('.js-app_promo_chat_top'));
			yalwa.basics.datalayer_push({
				'event': 'app_install_promo_close_user',
				'app_install_promo_touchpoint': 'app_promo_headroom_mc'
			});
		};

		return pub;

	}(pub.profile));

	const discover = (function(pub) {

		var browse_results = [];
		var initialized = false;
		var animating = false;
		var first = true;
		var delta = 0;
		var $profile;
		var $dislike;
		var $like;
		var $like_button;
		var $dislike_button;
		var $buttons;
		var touch = 'ontouchstart' in document.documentElement;
		var startX;
		var x_on_animation_frame_request;
		var last_animation_frame_request;
		var last_animation_frame_request_check;
		var startY;
		var duration = 300;
		var threshold = 80;
		const delta_max = 60;
		var last_results = null;
		var first_frame = true;
		var $results;
		var classes_active = 'dol_browse_profile--active';
		var classes_swiping = 'dol_browse_profile--during_swipe';
		var $profile_current;
		var $profile_next;
		var browse_hashtag_initialized = false;
		var buffer_exclude_items = [];
		var buffer_exclude_discover_promos = [];
		let loading_results_in_progress = false;
		let loading_results_in_progress_callback;
		let browse_popular_hashtag_initialized = false;
		let results_init_done = false;
		let cool_down_page_initialized = false;
		let show_filter_remove_plp = false;
		let dont_show_motivation_plp_profileID = false;
		let last_filtered_hashtags = null;
		let global_swipe_keep_hashtag_filters = true;
		let profile_current_has_more_images = false;
		let is_promo = false;
		let ss_swipe_count;
		let current_profile = {};
		let siwpe_promo_manually = false;

		pub = pub || {};

		pub.init = function() {
			if (initialized) {
				return;
			}
			
			$results = jQuery('.js-dol_results');
			if (typeof ResizeObserver === 'function') {
				const resize_observer = new ResizeObserver(entries => {
					window.requestAnimationFrame(set_height);
				});
				let body = jQuery('body')[0];
				resize_observer.observe(body);
			}
			
			if (yalwa.v.browse_results_initial) {
				let data = yalwa.v.browse_results_initial.data;
				jQuery.each(data, function(index, value) {
					buffer_exclude_items.push(value.ID); //prepare exclude items for next buffer
					if(value.promo_ID) {
						buffer_exclude_discover_promos.push(value.promo_ID);
					}
				});
				load_results_done(data, false);
				//Only on page load
				if (yalwa.v.browse_results_initial.filter_options.distance_filter_removed) {
					yalwa.dol.second_chance.update_distance();
				}
				//yalwa.v.browse_results_initial = null;
				if (!yalwa.v.init_settings.swipe_guide) {
					yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/swipe_guide.js');
				}
			} else {
				pub.load_results_default().done(() => {
					yalwa.mobile.stop_invisible_start();
				});
			}
			
			$document.on('height_check', function() {
				window.setTimeout(function() {
					set_height();
				}, 400);
			});
			
			jQuery('.js-dol_browse_filters_done').on('click', show_filter_results);
			
			
			if (yalwa.v.is_ios) {
				jQuery('html,body,.js-dol_results').on('touchmove', on_body_touch);
			}
			
			// ask push permission for profiles with matches and when no profiles to swipe
			if (parseInt(yalwa.v.matches_count)) {
				$document.on('no_results_shown', () => {
					yalwa.dol.push_check('dol-noresults');
				});
			}
			$document.on('results_init_done', function() {
				results_init_done = true;
				if (document.readyState === 'complete') {
					if (!yalwa.v.init_settings.swipe_guide) {
						yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/swipe_guide.js');
					}
				} else {
					$window.on('load', function() {
						if (!yalwa.v.init_settings.swipe_guide) {
							yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/swipe_guide.js');
						}
					});
				}
			});
			
			// initialize rewind
			if (yalwa.v.premium_enabled_country) {
				rewind.init();
			}
			// separate discover module code into new discover.js file
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/discover.js', function() {
				initialized = true;
				is_promo = $profile_current && $profile_current.data('card_type') === 'promo' || false;
				if(is_promo && $profile_current.data('promo_type') === 'myinfo-video-promo') {
					yalwa.discover.inbetween_promo.init();
				}
			});
		};
		
		pub.results_init_done = results_init_done;

		function show_filter_results() {
			if(!jQuery('.js-dol_browse_filters_global_swipe').hasClass('hidden') || !jQuery('.js-filter_hashtags_modal').hasClass('hidden')) {
				yalwa.basics.hide(jQuery('.js-dol_browse_filters_global_swipe'));
				yalwa.dol.discover.hide_filters_hashtag();
				return;
			}
			yalwa.basics.show(jQuery('.js-dol_search_refine'));
			yalwa.basics.hide(jQuery('.js-dol_tabbar'));
			yalwa.basics.hide(jQuery(".js-dol_browse_filters_done"));
			yalwa.basics.show(jQuery('.js-ptr_dol'));
			let was_showing_empty_view = !jQuery('.js-dol_browse_empty').hasClass('hidden');

			if (was_showing_empty_view) {
				yalwa.basics.hide(jQuery('.js-dol_browse_empty'));
			}

			var selected_hashtags_text = hashtags.get_selected_text();
			var selected_hashtags = hashtags.get_selected();

			jQuery('.js-dol_browse_search_hashtag').val(selected_hashtags.join(', '));

			let tmp = selected_hashtags_text.length ? selected_hashtags_text.join() : null;
			if (tmp === last_results && !was_showing_empty_view && !yalwa.v.filters_changed) {
				yalwa.basics.hide(jQuery('.js-dol_browse_filters'));
				yalwa.basics.hide(jQuery('.js-dol_browse_filters_global_swipe'));
				return; // no need to reload
			}
			jQuery('.js-dol_results').empty();
			last_results = tmp;
			pub.load_results_default();
			yalwa.v.filters_changed = false;
			//Show filter Clear PLP

			if (loading_results_in_progress) {
				loading_results_in_progress_callback = () => {
					if (show_filter_remove_plp) {
						if (jQuery($profile_next).data('id') === show_filter_remove_plp.profileID) {
							//Check for databucket to show optional filter removal PLP
							if (yalwa.v.init_global_swipe && show_filter_remove_plp.show_hashtag_optional_plp) {
								yalwa.dol.discover.show_optional_filter_removal_plp();
								return;
							}
							yalwa.dol.second_chance.show_tool_tip(show_filter_remove_plp);
							global_swipe_keep_hashtag_filters = true;
							show_filter_remove_plp = null;
						}
					}
				};
			}

			if (yalwa.v.init_global_swipe) {
				jQuery('.js-gs_country_info_tooltip_btn').on('click', init_global_swipe_country_info_tooltip);
			}
		}
		pub.show_filter_results = show_filter_results;

		

		pub.show_optional_filter_removal_plp = () => {
			let hashtag_filters = [];
			let ls_hashtag_filters = JSON.parse(yalwa.basics.ls_get('keep_hashtag_filters'));
			jQuery('.js-dol_selected_hashtag_item').each(function() {
				hashtag_filters.push(jQuery(this).data('hashtag-id'));
			});
			if (hashtag_filters.length < 1) {
				//No # filters applied, break this
				return;
			}

			if (JSON.stringify(hashtag_filters) === JSON.stringify(ls_hashtag_filters)) {
				return;
			}

			jQuery('.js-optional_filter_removal_plp')
				.on('plp_confirm', remove_filters_and_load_profiles)
				.on('plp_ok', keep_hashtag_filters)
				.trigger('plp_show', [{is_queued: true}]);
		}

		function remove_filters_and_load_profiles() {
			//Remove the hashtags and load fresh Profiles
			jQuery('.js-dol_selected_hashtag_item').each(function() {
				let thisData = jQuery(this).data('hashtag-id');
				jQuery(this).remove();
				yalwa.dol.discover.remove_hashtag_from_filter_overview(thisData);
			});
			yalwa.v.filters_changed = true;
			yalwa.dol.discover.load_results_default(false);
		}

		function keep_hashtag_filters() {
			let thisData = [];
			jQuery('.js-dol_selected_hashtag_item').each(function() {
				thisData.push(jQuery(this).data('hashtag-id'));
			});
			if (thisData.length) {
				yalwa.basics.ls_set('keep_hashtag_filters', thisData);
			}
			global_swipe_keep_hashtag_filters = false;
		}

		pub.hide_filters = () => {
			jQuery('.js-dol_browse_filters_done').trigger('click');
		};

		pub.hide_filters_hashtag = () => {
			yalwa.basics.hide(jQuery('.js-filter_hashtags_modal'));
			yalwa.basics.show(jQuery('.js-filters'));
			yalwa.basics.show(jQuery('.js-dol_tabbar'));
		};

		pub.hide_filter_icon = () => {
			const $filter_icon = jQuery('.js-dol_search_refine');
			if ($filter_icon.length && !$filter_icon.hasClass('hidden')) {
				yalwa.basics.hide($filter_icon);
			}
		};

		pub.is_sharing_active = function() {
			switch (yalwa.basics.is_dol_app()) {
				case 'dol_ios':
					return yalwa.basics.dol_app_version() > 4300;
				case 'dol_android':
					return yalwa.basics.dol_app_version() > 4212;
				default:
					return typeof navigator.share === 'function';
			}
		};

		pub.share = (function(pub) {

			pub = pub || {};
			let once = true;
			pub.init = function() {
				let $init_on;
				if (!discover.is_sharing_active()) {
					jQuery('.js-dol_share_profile').remove();
					return false;
				}
				yalwa.basics.show(jQuery('.js-dol_share_profile'));
				helper.ripple_add(jQuery('.js-dol_share_profile'));
				if (!once) {
					return false;
				}
				once = false;
				$init_on = jQuery('body');
				$init_on
					.off('click', '.js-dol_share_profile', share_click_handler)
					.on('click', '.js-dol_share_profile', share_click_handler);
			};

			function share_click_handler(event) {
				let profile_id;
				switch (yalwa.dol.url_id()) {
					case yalwa.v.VIEW_CHATS:
						profile_id = jQuery(event.target).closest('.js-dol_browse_profile_single_view').data('id');
						break;
					default:
						profile_id = jQuery(event.target).closest('.js-dol_browse_profile').data('id');

				}

				const gtm_params = '&utm_source=dating&utm_medium=profile_share&utm_campaign=' + encodeURIComponent(yalwa.basics.app_type());
				let share_body_label = yalwa.v.lang.dol_share_profile_expl;
				let continue_url = yalwa.dol.build_url('discover') + '?sp=' + profile_id + gtm_params;
				let url = continue_url;

				let share_body = share_body_label.replace('%1$s', '');
				let share_title = yalwa.v.lang.dol_share_profile_title;
				share_title = share_title.replace(/&nbsp;/g, ' ');
				share_body = share_body.replace(/&nbsp;/g, ' ');
				let label;
				if (yalwa.basics.is_dol_app()) {
					label = yalwa.basics.is_dol_app();
				} else {
					label = helper.detect_device_type() + '_browser';
				}
				let share_data = {
					'title': share_title,
					'text': share_body,
					'url': url
				};
				let data = {action: 'save', 'section': 'share_count', 'sp': profile_id};
				if (yalwa.v.is_ios && !yalwa.basics.is_dol_app()) {
					// Safari native share.api do not resolves or rejects promise
					ios_native_share_workaround(data, label);
				}
				dol_share(share_data).then(function(res) {
					//on iOS do not resolved
					return profile.save(data).done(function(r) {
						if (r.success) {
							return track_share('share_profile_click_success', label).then(_ => {
							});
						} else {
							return track_share('share_profile_click_error', label + ': ' + r.errors[0].message).then(_ => {
							});
						}
					});
				}).catch(function(error) {
					return track_share('share_profile_click_error', label + ': ' + error).then(_ => {
						//user abort before select any app to share profile
					});
				});
			}

			function ios_native_share_workaround(data, label) {
				if (!document.hidden) {
					return profile.save(data).done(function(r) {
						if (r.success) {
							return track_share('share_profile_click_success', label).then(_ => {
								yalwa.basics.reload();
							});
						} else {
							return track_share('share_profile_click_error', label + ': ' + r.errors[0].message).then(_ => {
								yalwa.basics.reload();
							});
						}
					});
				}
			}

			function dol_share(share_data) {
				if (yalwa.basics.is_dol_app()) {
					if (yalwa.mobile.cordova_dol) {
						let deferred = jQuery.Deferred();
						yalwa.mobile.cordova_dol.cordova_send({
							action: 'share',
							params: share_data
						});
						$document.on('share_success', _ => {
							deferred.resolve();
						});
						$document.on('share_error', _ => {
							deferred.reject();
						});
						return deferred.promise();
					}
				} else {
					return navigator.share(share_data);
				}
			}

			function track_share(action, label) {
				var deferred = jQuery.Deferred();
				if (!action || !label) {
					deferred.resolve();
				}
				yalwa.basics.ga.event({
					category: 'app_share',
					action: action,
					label: label
				}).then(_ => {
					deferred.resolve();
				});

				return deferred.promise();
			}

			return pub;

		})(pub.share);

		pub.init_hashtag = function(context) {
			if (browse_hashtag_initialized === true) {
				return;
			}

			browse_hashtag_initialized = true;
			jQuery('.js-dol_browse_filters__popular_hashtag').on('click', '.js-dol_browse_popular_hashtag_item', function() {
				let hashtag_id = jQuery(this).attr('data-hashtag-id');
				let hashtag_text = jQuery(this).attr('data-hashtag-text');
				let hashtag_cat_id = jQuery(this).attr('data-category-id');
				if (jQuery('.js-dol_selected_hashtag_item').length === 3) {
					yalwa.dol.toast({
						message: yalwa.v.lang.dol_hashtags_partner_search_limit,
						type: 'error'
					});
				} else {
					const append_html = `<div class="dol_browse_filters__selected_hashtag_item
						js-dol_selected_hashtag_item hitbox_before dol_hashtag_category_${hashtag_cat_id}"
						data-hashtag-id ="${hashtag_id}"
						data-hashtag-text ="${hashtag_text}">#${hashtag_text}</div>`;
					jQuery('.js-selected_hashtag').append(append_html);
					yalwa.basics.hide(jQuery(this));
					pub.append_hashtag_to_filter_overview(hashtag_id, hashtag_text, hashtag_cat_id);
				}
			});

			jQuery('.js-selected_hashtag').on('click', '.js-dol_selected_hashtag_item', function() {
				let hashtag_id = jQuery(this).attr('data-hashtag-id');
				yalwa.basics.show(jQuery('.js-dol_browse_filters__popular_hashtag').find("[data-hashtag-id='" + hashtag_id + "']"));
				jQuery(this).remove();
				jQuery('.js-dol_browse_search_hashtag').val('');
				remove_hashtag_from_filter_overview(hashtag_id);
			});

			if (context === 'onboarding') {
				yalwa.basics.show(jQuery('.js-hashtags_heading_onboarding'));
				//yalwa.basics.hide(jQuery('.js-hashtag_selected_subtitle'));
				hashtags.set_first_htab_as_selected(context);
			}
		};

		pub.remove_hashtag_from_filter_overview = remove_hashtag_from_filter_overview;
		pub.append_hashtag_to_filter_overview = (id, text, cat_id) => {
			const $no_hashtags = jQuery('.js-no_hashtags_selected');
			if ($no_hashtags.length && !$no_hashtags.hasClass('hidden')) {
				yalwa.basics.hide($no_hashtags);
			}
			yalwa.basics.hide(jQuery(this));
			const $hashtags_selected = jQuery('.js-hashtags_selected');
			const append_html = `<button type="button" class="dol_radio_button dol_radio_button--selected
				js-hashtag_selected dol_hashtag_category_${cat_id}"
				data-category-id = "${cat_id}"
				data-hashtag-id="${id}"
				data-hashtag-text="${text}"><span>#${text}</span></button>`;
			$hashtags_selected.append(append_html);
			jQuery('.js-selected_hashtags_count').html('(' + $hashtags_selected.children().length + '/3)');
		};

		/**
		 * remove the hashtag from filter overview section
		 * update the selected hashtag counter
		 * show no hashtags selected when selected hashtag count is zero
		 * @param hashtag_id
		 */
		function remove_hashtag_from_filter_overview(hashtag_id) {
			if (!hashtag_id) {
				return;
			}
			const $hashtags_selected = jQuery('.js-hashtags_selected');
			$hashtags_selected.children("[data-hashtag-id='" + hashtag_id + "']").remove();
			jQuery('.js-selected_hashtags_count').html('(' + $hashtags_selected.children().length + '/3)');
			const $no_hashtags = jQuery('.js-no_hashtags_selected');
			if (!$hashtags_selected.children().length) {
				yalwa.basics.show($no_hashtags);
			}
		}

		pub.update_popular_hashtags = function() {
			yalwa.basics.ajaxservice({
				resource: 'profile',
				service: 'hashtags',
				action: 'get_popular_hashtags',
			}).then(function(response) {
				if (response.success) {
					let hashtagIds = [];
					let counter_changed = false;
					if (response.hashtags.length) {
						yalwa.basics.show(jQuery('.js-dol_search_refine'));
						const $filters_popular_hashtag = jQuery('.js-dol_browse_filters__popular_hashtag');
						$filters_popular_hashtag.html(''); //clear current html
						if ($filters_popular_hashtag.hasClass('hidden')) {
							yalwa.basics.show($filters_popular_hashtag);
							yalwa.basics.show(jQuery('.js-filters_popular_hashtag_head'));
						}
						let selected_hashtags = hashtags.get_selected();
						response.hashtags.forEach(function(item) {
							if (selected_hashtags.indexOf('#' + item.text) !== -1) {
								//console.log("remove " + item.text);
							} else {
								const html = `<div class="dol_browse_filters__popular_hashtag_item
								js-dol_browse_popular_hashtag_item grouped_hashtags--item_${item.category_id}"
								data-category-id = "${item.category_id}"
								data-hashtag-id = "${item.id}"
								data-hashtag-text = "${item.text}">#${item.text}</div>`;
								jQuery('.js-dol_browse_filters__popular_hashtag').append(html);
								hashtagIds.push(parseInt(item.id));
							}
						});
						if (yalwa.v.filter_hashtags) {
							jQuery('.js-dol_browse_filters__popular_hashtag').children().each(function () {
								if (yalwa.v.filter_hashtags.includes(this.dataset.hashtagText)) {
									jQuery(this).click();
								}
							});
							last_results = yalwa.v.filter_hashtags;
							selected_hashtags = last_filtered_hashtags = yalwa.v.filter_hashtags.join();
							delete yalwa.v.filter_hashtags;
						}
					}
					// jQuery('.js-dol_selected_hashtag_item').each(function() {
					// 	let thisData = jQuery(this).data('hashtag-id');
					// 	if (!hashtagIds.indexOf(thisData) !== -1) {
					// 		jQuery(this).remove();
					// 		counter_changed = true;
					// 		remove_hashtag_from_filter_overview(thisData);
					// 	} else {
					// 		yalwa.basics.hide(jQuery('.js-dol_browse_popular_hashtag_item[data-hashtag-id="' + thisData +  '"]'));
					// 	}
					// });

					if (counter_changed) {
						jQuery('.js-dol_hashtag_counter').html(jQuery('.js-dol_selected_hashtag_item').length);
					}
				}
			});
		};

		function load_results_done(response, hashtags_selected) {
			if (response.error) {
				if (response.error === 'limit_reached') {
					yalwa.basics.hide(jQuery('.js-dol_browse_filters'));
					if (yalwa.v.premium_enabled_country) {
						rewind.hide();
					}
					show_limit_reached();
				}

				if (response.error === 'tot_swipe_limit_reached') {
					yalwa.basics.hide(jQuery('.js-dol_browse_filters'));
					if (yalwa.v.premium_enabled_country) {
						rewind.hide();
					}
					show_tot_swipe_limit_reached(response.cta_variation);
					return;
				}

				if (response.error === 'profile_paused') {
					if (!jQuery('.js-profile_paused').length && yalwa.v.is_email_confirmed) {
						yalwa.basics.reload();
					} else {
						jQuery('.js-profile_paused')
							.on('plp_ok', () => {
								profile.pause_request('unpause').done(yalwa.basics.reload);
							}).trigger('plp_show');
					}
					yalwa.basics.hide(jQuery('.js-dol_search_refine'));
				}
			} else {
				if (hashtags_selected && !response.length) {
					jQuery('.js-dol_search_refine').trigger('click');
					if (yalwa.mobile.htabs.current() !== yalwa.v.VIEW_DISCOVER) {
						yalwa.basics.hide(jQuery('.js-dol_tabbar'));
						yalwa.basics.hide(jQuery(".js-dol_browse_filters_done"));
					}
					jQuery('.js-dol_hashtags_no_result')
						.off('plp_confirm')
						.on('plp_confirm')
						.on('plp_ok', () => {
							jQuery('.js-dol_selected_hashtag_item').each(function() {
								let thisData = jQuery(this).data('hashtag-id');
								jQuery(this).remove();
								remove_hashtag_from_filter_overview(thisData);
							});
						})
						.trigger('plp_show');
					show_out_of_results();
				} else {
					browse_results = response;

					if (yalwa.basics.get_cookie('sp') && !yalwa.v.show_email_confirm_pl && !yalwa.v.is_foto_skipped) {
						yalwa.basics.set_cookie('sp', '', 0);
						yalwa.basics.state.push('discover', null, yalwa.dol.build_url('discover'));
					}
					show_next(true);
					if (jQuery('.js-dol_browse_filters_done').hasClass('hidden')) {
						yalwa.basics.hide(jQuery('.js-dol_browse_filters'));
					}
					yalwa.basics.show($results);
				}
			}
			jQuery('.js-show_sc_info_plp').on('click', yalwa.dol.second_chance.show_info_plp);
		}

		pub.init_paused_plp = function() {
			jQuery('.js-profile_paused')
				.on('plp_ok', () => {
					profile.pause_request('unpause').done(yalwa.basics.reload);
				}).trigger('plp_show');
		};
		
		function load_results(selected_hashtags = null, exclude_profiles = null, exclude_promos = null) {
			let dont_remove_distance_filter = false;
			if (yalwa.basics.ls_get('distance_filter_removed')) {
				let distance_filter_cookie = JSON.parse(yalwa.basics.ls_get('distance_filter_removed'));
				if (yalwa.v.userID === distance_filter_cookie.profileID) {
					dont_remove_distance_filter = true;
				}
			}
			let result = jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {
					action: 'get_browse_results',
					hashtags: selected_hashtags,
					exclude_profiles: exclude_profiles,
					exclude_promos: exclude_promos,
					profile_that_should_be_shown_first: yalwa.basics.get_cookie('sp'),
					dont_remove_distance_filter: dont_remove_distance_filter || false,
					fresh_call: (selected_hashtags !== last_filtered_hashtags) || yalwa.v.filters_changed,
					dont_remove_hashtag_filter: (yalwa.v.init_global_swipe) ? global_swipe_keep_hashtag_filters : false,
					save_filter_hashtags: true
				}
			});
			cooldown_photoduel_variations = false;
			if (selected_hashtags !== last_filtered_hashtags) {
				last_filtered_hashtags = selected_hashtags;
			}
			return result;
		}

		pub.load_results_default = function(is_buffer = false) {
			loading_results_in_progress = true;
			var selected_hashtags_text = hashtags.get_selected_text();
			if (!is_buffer) {
				buffer_exclude_items = []; //reset exclude items if it's not buffer request
				buffer_exclude_discover_promos = [];
			}

			return load_results(
				selected_hashtags_text.length ? selected_hashtags_text.join() : null,
				is_buffer && buffer_exclude_items.length ? buffer_exclude_items.join() : null,
				buffer_exclude_discover_promos.length ? buffer_exclude_discover_promos.join() : null
			).done(function(ajax_response) {
				let response = ajax_response.data;
				let profileID = false;
				if (response.length) {
					profileID = response[0].ID;
				}
				if (yalwa.v.init_global_swipe && !ajax_response.tot_swipes_limit) {
					if (ajax_response.data_buckets && ajax_response.data_buckets.length === 1) {
						if (ajax_response.data_buckets.indexOf(4) === 0 && !ajax_response.filter_options.hashtag_filter_removed) {
							//Only International profiles are there
							show_filter_remove_plp = {
								hashtag_filter_removed: ajax_response.filter_options.hashtag_filter_removed,
								distance_filter_removed: ajax_response.filter_options.distance_filter_removed,
								show_hashtag_optional_plp: ajax_response.show_hashtag_optional_plp,
								'profileID': profileID || false,
								data_buckets: ajax_response.data_buckets
							};
						}
					}
				}
				if (ajax_response.filter_options && (ajax_response.filter_options.hashtag_filter_removed || ajax_response.filter_options.distance_filter_removed) && !ajax_response.tot_swipes_limit) {
					//Hashtag Filter is Removed - Store the Profile ID
					let remove_filter_data = {
						hashtag_filter_removed: ajax_response.filter_options.hashtag_filter_removed,
						distance_filter_removed: ajax_response.filter_options.distance_filter_removed,
						show_hashtag_optional_plp: false,
						'profileID': profileID || false,
						data_buckets: ajax_response.data_buckets
					};
					show_filter_remove_plp = remove_filter_data;
				}
				if (!response.error && response.length) {
					jQuery.each(response, function(index, value) {
						buffer_exclude_items.push(value.ID); //prepare exclude items for next buffer
						if(value.promo_ID) {
							buffer_exclude_discover_promos.push(value.promo_ID); //prepare exclude items for next buffer
						}
					});
				}
				if (!is_buffer) {
					load_results_done(response, !!selected_hashtags_text.length);
				} else {
					if (!response.error && response.length) {
						browse_results = browse_results.concat(response);
						if (yalwa.basics.get_cookie('sp') && !yalwa.v.show_email_confirm_pl && !yalwa.v.is_foto_skipped) {
							yalwa.basics.set_cookie('sp', '', 0);
							yalwa.basics.state.push('discover', null, yalwa.dol.build_url('discover'));
						}
					}
				}
				loading_results_in_progress = false;
				if (typeof loading_results_in_progress_callback === 'function') {
					loading_results_in_progress_callback();
					loading_results_in_progress_callback = null;
				}
			});
		};

		pub.flag = (function(pub) {

			pub = pub || {};

			const types = {
				4: 'PR_INAPPROPRIATE_PHOTO',
				5: 'PR_FAKE_OR_STOLEN_PHOTO',
				6: 'PR_MULTIPLE_PROFILES',
				7: 'PR_UNDERAGE',
				8: 'PR_OTHER',
				9: 'MC_INAPPROPRIATE',
				10: 'MC_LIKE_SPAM',
				11: 'MC_FAKE_OR_SPAM',
				12: 'MC_PROFESSIONAL_USER',
				13: 'MC_UNDERAGE',
				14: 'MC_OTHER'
			}
			let MC = false;

			const plp_options = [{
				is_queued: true
			}]

			function flag_profile_submit(info) {
				return jQuery.ajax({
					url: API_PATH_DOL,
					dataType: 'json',
					type: 'get',
					data: jQuery.extend({
						action: 'flag_profile_submit',
					}, info)
				});
			}

			pub.mc_init = () => {
				const $button = jQuery('.js-dol_flag_mc');
				$button.on('click', mc_show);
			}

			function get_flag_mc_profile_data($form) {
				return {
					action: 'flag_toggle',
					flag: $form.data('type'),
					conversationID: get_conversationID(),
					reason: $form.val()
				};
			}

			function get_conversationID() {
				return jQuery('.js-c_select.js-selected').data('conversationid');
			}

			function flag_change_request(data) {
				return jQuery.ajax({
					url: API_PATH_CHAT,
					type: 'post',
					dataType: 'json',
					data: data
				});
			}

			function mc_show() {
				MC = true;
				close_advanced_options();
				let $current_chat = jQuery('.js-chat_instance');
				let flagged_userID = $current_chat.data('dol_profileid');
				jQuery.ajax({
					url: API_PATH_DOL,
					dataType: 'json',
					type: 'get',
					data: {
						action: 'flag_dialog',
						userID: flagged_userID,
						MC: true
					}
				}).done(function(response) {
					clear_old_temp();
					jQuery('body').append(response.html);
					jQuery('.js-flag_mc_type').on('click', init_flag_form);
					jQuery('.js-flag_mc_dialog').trigger('plp_show', plp_options);
					// plp before_confirm_callback
					jQuery('.js-flag_mc_form')[0].fn_validate = function() {
						let $textarea = jQuery('.js-flag_mc_form').find('.js-flag_mc_comment');
						let is_not_valid = !$textarea.val() || $textarea.val().match(/\S+/g).length < 3;
						if (is_not_valid) {
							$textarea.velocity('callout.shake');
						}

						return !is_not_valid;
					};
					jQuery('.js-flag_mc_form').on('plp_confirm', function() {
						let $textarea = jQuery('.js-flag_mc_form').find('.js-flag_mc_comment');
						let info = get_flag_mc_profile_data($textarea);
						flag_change_request(info).done(function(response) {
							if (response.success) {
								track(types[info.flag], 'success');
								yalwa.chat.flag_toggle_dom(info.flag);
								yalwa.chat.request_details(null, null, true);
								yalwa.dol.unmatch();
							} else {
								track(types[info.type], 'error');
								yalwa.dol.toast({message: response.text, type: 'error'});
							}
						});
					});
				});
			}

			function close_advanced_options() {
				const $menu = jQuery('.js-advanced_options_menu');
				yalwa.basics.hide($menu);
				yalwa.basics.state.try_cancel('advanced_options');
			}

			function clear_old_temp() {
				let context = MC ? 'mc' : 'profile';
				jQuery('.js-flag_' + context + '_dialog').remove();
				jQuery('.js-flag_' + context + '_form').remove();
				jQuery('.js-flag_confirm').remove();
				jQuery('.js-howto_contact_plp').remove();
			}

			pub.flag_profile_show = () => {
				MC = false;
				yalwa.basics.hide(jQuery('.js-profile_options'));
				//yalwa.mobile.generic_shadow.show_queued();
				var $current = discover.get_current_profile();
				let flagged_userID = $current.data('id');
				jQuery.ajax({
					url: API_PATH_DOL,
					dataType: 'json',
					type: 'get',
					data: {
						action: 'flag_dialog',
						userID: flagged_userID
					}
				}).done(function(response) {
					clear_old_temp();
					jQuery('body').append(response.html);
					var $current = discover.get_current_profile();
					jQuery('.js-flag_profile_dialog')[0].fn_validate = function() {
						let info = get_flag_profile_data($current);
						let is_valid = info.type && info.userID_flagged;
						if (!is_valid) {
							jQuery('.js-flag_profile_dialog label').velocity('callout.shake');
						}
						return is_valid;
					};
					jQuery('.js-flag_profile_type').on('click', init_flag_form);
					jQuery('.js-howto_contact').on('click', init_howto_contact);
					jQuery('.js-flag_profile_dialog').trigger('plp_show', plp_options);
					const $flag_profile_form = jQuery('.js-flag_profile_form');
					$flag_profile_form[0].fn_validate = function() {
						let is_valid = true;
						let $textarea = $flag_profile_form.find('.js-flag_profile_comment');
						if ($textarea.data('is_pr_other_flag')){
							is_valid = $textarea.val() && $textarea.val().match(/\S+/g).length >= 3;
							if (!is_valid) {
								$textarea.velocity('callout.shake');
							}
						}
						return is_valid;
					};
					$flag_profile_form.on('plp_confirm', function() {
						let info = get_flag_profile_data($current);
						flag_profile_submit(info).done(function(response) {
							if (response.success) {
								jQuery('.js-flag_confirm').trigger('plp_show', plp_options);
								track(types[info.type], 'success');
								jQuery('.js-flag_confirm').velocity('fadeOut', {
									delay: 2000,
									duration: 400,
									complete: function() {
										jQuery('.js-flag_confirm').trigger('plp_hide', plp_options);
										profile_dislike($current);
									}
								});
							} else {
								track(types[info.type], 'error');
								yalwa.dol.toast({message: response.text, type: 'error'});
							}
						});
					});
				});
			}

			function track(type, label) {
				var deferred = jQuery.Deferred();
				let category = 'dol_flagging_click';
				if (!type || !label) {
					deferred.resolve();
				}
				yalwa.basics.ga.event({
					category: category,
					action: type,
					label: label,
				}).then(() => {
					deferred.resolve();
				});

				return deferred.promise();
			}

			function init_flag_form(event) {
				let $type = jQuery(event.currentTarget);
				let context = MC ? 'mc' : 'profile';
				let $form = jQuery('.js-flag_' + context + '_form');
				yalwa.basics.hide(jQuery('.js-flag_' + context + '_dialog'));
				$form.find('.js-flag_form_title').html($type.data('title'));
				$form.find('.js-flag_form_body').html($type.data('body'));
				jQuery('.js-flag_' + context + '_comment').data('type', $type.data('value'));
				jQuery('.js-flag_' + context + '_comment').data('is_pr_other_flag', $type.data('is_pr_other_flag'));
				update_flag_profile_form_placeholder($type.data('value')).done(function(response) {
					jQuery('.js-flag_profile_comment').attr('placeholder', response.label);
					$form.trigger('plp_show', {is_queued: true});
				});
				
			}
			function update_flag_profile_form_placeholder($type) {
				return jQuery.ajax({
					url: API_PATH_DOL,
					dataType: 'json',
					type: 'get',
					data: {
						action: 'flag_profile_profile_placeholder_label',
						type: $type,
					}
				});
			}

			function init_howto_contact() {
				let $plp = jQuery('.js-howto_contact_plp');
				yalwa.basics.hide(jQuery('.js-flag_profile_dialog'));
				$plp.trigger('plp_show');
			}

			function get_flag_profile_data($current) {
				return {
					userID_flagged: $current.data('id'),
					type: jQuery('.js-flag_profile_comment').data('type'),
					comment: jQuery('.js-flag_profile_comment').val()
				};
			}

			return pub;

		})(pub.flag)

		function decide() {
			var $this = jQuery(this);
			var $profile = $this.closest('.js-dol_browse_profile');
			if (yalwa.v.premium_enabled_country) {
				rewind.set_last_reacted_profile($profile.clone(true, true));
			}
			if ($this.hasClass('js-profile_like')) {
				$profile.find('.js-profile_dislike,.js-profile_like').off('click', decide); // avoid logging reactions twice when clicking very fast
				profile_like($profile, true);
			} else {
				$profile.find('.js-profile_dislike,.js-profile_like').off('click', decide); // avoid logging reactions twice when clicking very fast
				profile_dislike($profile, true);
			}
		}

		function remove_handlers() {
			$results[0].removeEventListener((touch ? 'touchmove' : 'mousemove'), on_move, {passive: true});
			$results[0].removeEventListener((touch ? 'touchend' : 'mouseup'), on_end, {passive: true});
			$results[0].removeEventListener((touch ? 'touchout' : 'mouseout'), on_end, {passive: true});
		}

		//Android Webview do not fire some times touchend event see DEV-824
		function is_touchend_event_missing_check() {
			window.is_touchend_event_missing_check_timer = window.setInterval(function() {
				if (last_animation_frame_request_check === last_animation_frame_request) {
					on_end();
					return;
				}
				last_animation_frame_request_check = last_animation_frame_request;
			}, 200);
		}

		function on_start(e) {
			if (animating) {
				return;
			}

			if (yalwa.basics.is_dol_app() === 'dol_android') {
				is_touchend_event_missing_check();
			}
			$profile = jQuery(this);
			is_promo = $profile.data('card_type') === 'promo' || false;
			if(!is_promo) {
				$buttons = $profile.find('.js-buttons_static');
				$dislike_button = $buttons.find('.js-dol_shadow_clone').eq(0);
				$like_button = $buttons.find('.js-dol_shadow_clone').eq(1);
			}
			x_on_animation_frame_request = 0;
			startX = e.pageX || e.originalEvent.touches[0].pageX;
			startY = e.pageY || e.originalEvent.touches[0].pageY;

			$results[0].addEventListener((touch ? 'touchmove' : 'mousemove'), on_move, {passive: true});
			$results[0].addEventListener((touch ? 'touchend' : 'mouseup'), on_end, {passive: true});
			$results[0].addEventListener((touch ? 'touchout' : 'mouseout'), on_end, {passive: true});
		}

		function on_body_touch(e) {
			let $e = jQuery(e.target);
			if (animating && $e.closest('.js-dol_browse_profile').length) {
				if (typeof e.cancelable !== 'boolean' || e.cancelable) {
					e.preventDefault();
				}
				e.stopPropagation();
				return false;
			}
		}

		function on_end() {
			if (yalwa.basics.is_dol_app() === 'dol_android') {
				window.clearInterval(window.is_touchend_event_missing_check_timer);
			}
			remove_handlers();
			on_release();
			first_frame = true;
			$profile.removeClass(classes_swiping);
			setTimeout(() => {
				if ($profile.hasClass(classes_swiping)) {
					$profile.removeClass(classes_swiping);
				}
			}, 150);
		}

		function on_move(e) {
			var x = e.pageX || e.touches[0].pageX;
			var y = e.pageY || e.touches[0].pageY;

			var delta_y = Math.abs(y - startY);
			var delta_x = Math.abs(x - startX);
			if (delta_y > delta_x && first) {
				remove_handlers();
				on_release();

				return;
			}
			first = false;
			delta = (x - startX);
			animating = true;
			let difference = x - x_on_animation_frame_request;
			let needed_pixel_size_for_animation_call = 1;

			//Fewer AnimationFrame requests
			if ((difference < needed_pixel_size_for_animation_call && difference > 0) || (difference > -needed_pixel_size_for_animation_call && difference < 0)) {
				//difference is not enough
				return;
			} else {
				x_on_animation_frame_request = x;
			}
			requestAnimationFrame(function() {
				last_animation_frame_request = Date.now();
				if (first_frame) {
					$profile.addClass(classes_swiping);
				}
				first_frame = false;
				let css = {transform: 'translate3d(' + delta + 'px,0,0) rotate(' + deg(delta) + 'deg)'};
				if (delta < 0) {// dislike
					css.opacity = opacity_dislike(delta);
				}
				$profile.css(css);
				let delta_copy = delta;
				if (delta_copy > delta_max) {
					delta_copy = delta_max;
				}
				if (delta_copy < delta_max * -1) {
					delta_copy = delta_max * -1;
				}
				let scale = delta_copy / 50;
				if (scale > 0.8) {
					scale = 0.8;
				} else if (scale < -0.8) {
					scale = -0.8;
				}
				let scale_like = (1 + scale);
				let scale_dislike = (1 - scale);
				let translate_like;
				let translate_dislike;
				let translate_y_like;
				let translate_y_dislike;
				let y;
				if ($buttons.position().top < 120) {
					y = Math.abs(delta_copy);
				} else {
					y = Math.abs(delta_copy) * -1;
				}
				if (delta_copy > 0) { // like
					translate_like = -1 * delta_copy;
					translate_dislike = 0;
					translate_y_dislike = 0;
					translate_y_like = y;
				} else { // dislike
					translate_like = 0;
					translate_dislike = Math.abs(delta_copy);
					translate_y_like = 0;
					translate_y_dislike = y;
				}
				$like_button.css('transform', 'scale(' + scale_like + ') translateX(' + translate_like + 'px) translateY(' + translate_y_like + 'px)');
				$dislike_button.css('transform', 'scale(' + scale_dislike + ') translateX(' + translate_dislike + 'px) translateY(' + translate_y_dislike + 'px)');
			});
		}

		function on_release() {
			if (typeof (jQuery.Velocity) === 'undefined') {
				return;
			}
			if (Math.abs(delta) >= threshold) {
				jQuery.Velocity.hook($profile, 'translateX', delta);
				jQuery.Velocity.hook($profile, 'rotateZ', (delta / 10) + 'deg');
				jQuery.Velocity.hook($profile, 'opacity', delta < 0 ? opacity_dislike(delta) : 1);
				if (delta >= threshold && !is_promo) {
					profile_like($profile);
				} else if (delta <= -threshold && !is_promo) {
					profile_dislike($profile);
				}
				//Promo Swipe (left + right)
				else if (delta >= threshold && is_promo) {
					siwpe_promo_manually = true;
					promo_swipe($profile, 'right');
				}else if (delta <+ threshold && is_promo) {
					siwpe_promo_manually = true;
					promo_swipe($profile, 'left');
				}
			} else if (animating) {
				jQuery.Velocity.hook($profile, 'translateX', delta);
				jQuery.Velocity.hook($profile, 'rotateZ', (delta / 10) + 'deg');
				$profile.velocity({translateX: 0, rotateZ: 0, opacity: 1}, {duration: duration});
				jQuery.Velocity.hook($profile, 'opacity', 1);
				$dislike_button.velocity({scale: 1}, {duration: duration});
				jQuery.Velocity.hook($dislike_button, 'scale', 1);
				$like_button.velocity({scale: 1}, {duration: duration});
				jQuery.Velocity.hook($like_button, 'scale', 1);
			}

			delta = 0;
			if (animating) {
				setTimeout(() => {
					animating = false;
				}, duration + 50);
			}

			first = true;
		}

		function deg(delta) {
			return delta / 10;
		}

		function opacity_dislike(delta) {
			var opacity = 1.2 + (delta / 100);
			if (opacity < 0.2) {
				opacity = 0.2;
			}
			return opacity;
		}

		pub.is_distance_filter_is_applied = function() {
			let filters_count = false;
			let $distance_element = jQuery(".js-distance_slider_max");
			let distance = parseInt($distance_element.val());
			let max_distance = parseInt($distance_element.attr('max'));
			if (distance < max_distance) {
				//user has used this filter
				filters_count = true;
			}
			return filters_count || false;
		}

		pub.is_age_filter_applied = function() {
			let filters_count = false;
			let $age_min_element = jQuery('.js-age_range_slider_min');
			let $age_max_element = jQuery('.js-age_range_slider_max');
			let min_age = parseInt($age_min_element.attr('min'));
			let max_age = parseInt($age_min_element.attr('max'));
			let min_value = parseInt($age_min_element.val());
			let max_value = parseInt($age_max_element.val());
			if ((min_value > min_age) || (max_value < max_age)) {
				filters_count = true;
			}
			return filters_count || false;
		}
		let max_attempts = 0;

		function show_browse_empty() {
			if (show_filter_remove_plp && max_attempts < 2) {
				//max attempts is to fix the raise condition
				discover.load_results_default();
				show_filter_remove_plp = null;
				max_attempts++;
				return;
			}
			if (yalwa.dol.hashtags.get_selected_text().length) {
				discover.load_results_default();
				return;
			}
			track_out_of_swipes();
			// hide the 3 dots
			yalwa.basics.hide(jQuery('.js-more_images_info'));
			show_out_of_results();
			if (!jQuery('.js-dol_browse_limit_cta').hasClass('hidden')) {
				yalwa.basics.hide(jQuery('.js-dol_browse_limit_cta'));
			}
			if (jQuery('.js-dol_hashtag_counter:visible').length) {
				let $refine_tip = jQuery('.js-refine_tip');
				$refine_tip.text(yalwa.v.lang.dol_no_profiles_advice);
				yalwa.basics.show($refine_tip);
				$refine_tip.parent().addClass('snh_tip_html');
			}
			if (!hashtags.get_selected().length) {
				jQuery.ajax({
					url: API_PATH_DOL,
					dataType: 'json',
					type: 'get',
					data: {action: 'no_results_left'}
				});
			}
			yalwa.basics.hide(jQuery('.js-dol_results'));
			$document.trigger('no_results_shown');
			// DEV-7005
			if((yalwa.dol.helper.is_frozen() || yalwa.dol.helper.is_unconfirmed())){
				jQuery('.js-discover_top_bar_actions').css('top' , '20px');
			}
		}

		function show_out_of_results() {
			jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {action: 'get_out_of_results_view'},
				beforeSend: function() {
					yalwa.basics.show(jQuery('.js-oor_loader'));
				},
				complete: function() {
					yalwa.basics.hide(jQuery('.js-oor_loader'));
				}
			}).done(out_of_results_variation);
		}

		function hide_top_bar_sections() {
			yalwa.basics.hide(jQuery('.js-dol_search_refine'));
			yalwa.basics.hide(jQuery('.js-more_images_info'));
			rewind.hide();
		}

		function out_of_results_variation(response) {
			if (response && response.success) {
				const $browse_empty = jQuery('.js-dol_browse_empty');
				$browse_empty.html(response.html);
				yalwa.basics.show($browse_empty);
				//hide_top_bar_sections();
				yalwa.basics.hide(jQuery('.js-more_images_info'));
				rewind.hide();
				const $search_refine = jQuery('.js-dol_trigger_search_refine');
				cooldown_photoduel_variations = false;
				switch (response.variation) {
					// filtered
					case 1:
						$search_refine.on('click', function() {
							yalwa.basics.ga.event({category: 'out_of_swipes', action: 'out_of_swipes_filter_click'});
							second_chance.open_filter_panel();
						});
						yalwa.basics.ga.event({category: 'out_of_swipes', action: 'out_of_swipes_filter_view'});
						break;
					// no filter blog view
					case 2:
						yalwa.basics.ga.event({category: 'out_of_swipes', action: 'out_of_swipes_nofilter_blog_view'});
						// initialize
						jQuery('.js-blog_card')
							.velocity("transition.slideUpBigIn", {duration: 1000, delay: 500})
							.on('click', function() {
								yalwa.basics.ga.event({
									category: 'out_of_swipes',
									action: 'out_of_swipes_nofilter_blog_click'
								}).done(() => {
									yalwa.basics.new_tab(jQuery(this).data('href'));
								});
							});
						break;
					// no filter MC prompt view
					case 3:
						yalwa.basics.ga.event({category: 'out_of_swipes', action: 'out_of_swipes_nofilter_MC_view'});
						jQuery('.js-oor_no_filters_chat_cta').on('click', function() {
							yalwa.basics.ga.event({
								category: 'out_of_swipes',
								action: 'out_of_swipes_nofilter_MC_click'
							}).done(() => {
								jQuery('.js-htabs').find('[data-sectionid="chats"]').trigger('click');
							});
						});
						break;
					// filtered photo duel
					case 4:
						$search_refine.on('click', function() {
							yalwa.basics.ga.event({category: 'out_of_swipes', action: 'out_of_swipes_filter_click'});
							second_chance.open_filter_panel();
						});
						yalwa.basics.ga.event({
							category: 'out_of_swipes',
							action: 'out_of_swipes_filter_photo_duel_view'
						});
						jQuery('.js-oor_with_filters_duel_cta, .js-oor_filters_duel_images').on('click', function() {
							const data_label = jQuery(this).data('label');
							yalwa.basics.ga.event({
								category: 'out_of_swipes',
								action: 'out_of_swipes_filter_photo_duel_click',
								label: data_label
							});
							jQuery('.js-htabs').find('[data-sectionid="photo-duel"]').trigger('click');
						});
						cooldown_photoduel_variations = true;
						break;

					case 5:
						yalwa.basics.ga.event({
							category: 'out_of_swipes',
							action: 'out_of_swipes_nofilter_photo_duel_view'
						});
						jQuery('.js-oor_no_filters_duel_cta, .js-oor_no_filters_duel_images').on('click', function() {
							const data_label = jQuery(this).data('label');
							yalwa.basics.ga.event({
								category: 'out_of_swipes',
								action: 'out_of_swipes_nofilter_photo_duel_click',
								label: data_label
							});
							jQuery('.js-htabs').find('[data-sectionid="photo-duel"]').trigger('click');
						});
						cooldown_photoduel_variations = true;
						break;
					default:
						break;
				}
			}
		}

		function add_next_profile_dom(html) {
			let $break_after_adding_promo = false;
			
			yalwa.dol.inbetween_fixed_promos.prompts_inbetween_swipe().forEach(function (element) {
				let profiles_swiped_so_far = parseInt(yalwa.basics.ss_get('swipes_count'))+1;
				if (element.can_show && (element.show_at_positions.indexOf(profiles_swiped_so_far) >= 0) || element.force_show_at_position && profiles_swiped_so_far === element.force_show_at_position) {
					if(!yalwa.basics.ls_get('AK_TAKEN_IBPROMO_'+element.type)) {
						let force_show = false;
						if (element.force_show_at_position && profiles_swiped_so_far === element.force_show_at_position) {
							force_show = true;
						}
						element.html_card(element.type, force_show).done(function (response) {
							let $html = response.html_card;
							let $add = jQuery($html);
							if ($add.length) {
								$profile_next = $add;
								$results.prepend($add);
								$break_after_adding_promo = true;
								if (typeof element.loaded_callback === 'function') {
									//Good for any tracking or anything required in future
									element.loaded_callback();
								}
							}
						});
					}
				}
				if ($break_after_adding_promo) {
					//returning from loop
					return;
				}
			});
			
			if ($break_after_adding_promo) {
				// break it here
				return;
			}
			
			if (html && html.html_card) {
				let $add = jQuery(html.html_card);
				if ($add.length) {
					$profile_next = $add;
					$results.prepend($add);
				}
			}
			
			let profiles_swiped_so_far = parseInt(yalwa.basics.ss_get('swipes_count'));
			if (profiles_swiped_so_far % 5 === 0) {
				if (yalwa.stream_helper && yalwa.stream_helper.check_and_show_progress_stream_htab_icon) {
					yalwa.stream_helper.check_and_show_progress_stream_htab_icon();
				}
			}
			
		}

		function results_init(first, second) {
			$results.empty();
			if (second) {
				let $add = jQuery(second.html_card);
				$profile_next = $add;
				$results.prepend($add);
			} else {
				$profile_next = null;
			}
			if (first) {
				let $add = jQuery(first.html_card);
				$profile_current = $add;
				$results.append($add);
			} else {
				$profile_current = null;
			}
			return init_current();
		}

		function init_current() {
			if ($profile_current && $profile_current.length) {
				$profile_current.addClass(classes_active);
				$profile_current.find('.js-profile_dislike,.js-profile_like').off('click').on('click', decide);
				$profile_current.find('.js-swipe_inbetween_promo').off('click').on('click', hide_inbetween_promo);
				$profile_current.find('.js-take_to_likeyou').off('click').on('click', function () {
					yalwa.dol.nav.to_like_you({touchpoint: 'liked_you_between_swipes'})
				});
				$profile_current.off('mousedown touchstart').on('mousedown touchstart', on_start);
				discover.share.init();
				yalwa.dol.show_wow_new_icon(true);
				current_profile.name = $profile_current.find('.js-dol_profile_core_name').html();
				current_profile.profile_pic =  $profile_current.find('.js-dol_profile_core_img').attr('src');
				return true;
			} else {
				show_browse_empty();
				return false;
			}
		}

		pub.init_current = init_current;

		pub.current_profile = current_profile;
		
		pub.scroll_to_hashtags = function() {
			if (yalwa.mobile.htabs.current() === 'profile') {
				let $c = jQuery('.js-dol_profile');
				let $card = $c.find('.js-dol_profile_core');
				if ($card.length) {
					$c.closest('.js-section').scrollTop($card.height());
				}
			} else {
				let $c = discover.get_current_profile();
				let $card = $c.find('.js-dol_swipe_card');
				if ($card.length) {
					$c.stop().animate({scrollTop: $card.height()}, 500);
				}
			}
		};

		function set_next() {
			$profile_current = $profile_next;
			is_promo = $profile_current && $profile_current.data('card_type') === 'promo' || false;
			if(is_promo && $profile_current && $profile_current.data('promo_type') === 'myinfo-video-promo') {
				yalwa.discover.inbetween_promo.init();
			}
			if (is_promo && $profile_current && $profile_current.data('promo_type') === 'swipe-preference-selection') {
				yalwa.dol.inbetween_fixed_promos.show_swipe_preference();
			}
			if (is_promo && $profile_current && $profile_current.data('promo_type') === 'stream-female-promo') {
				yalwa.dol.inbetween_fixed_promos.init_stream_promo();
			}
			if (is_promo && $profile_current && $profile_current.data('promo_type') === 'relationship-hashtag-selection') {
				yalwa.discover.inbetween_promo.init_relationship_hashtag_promo();
			}
			$profile_next = null;
			return init_current();
		}

		pub.get_current_profile = function() {
			return $profile_current;
		};
		
		pub.get_next_profile = () => $profile_next;

		pub.set_current_profile = function($profile) {
			$profile_current = $profile;
		};

		function show_next(first) {

			if (browse_results.length === 1) {
				discover.load_results_default(true);
			}

			const next_result = browse_results.shift();
			// fight race condition when loading next results is slow, so we don't show "no results left" wrongly
			if (loading_results_in_progress && !next_result) {
				loading_results_in_progress_callback = () => {
					show_next(first);
				};
				return;
			}

			let profile_shown;
			if (first) {
				profile_shown = results_init(next_result, browse_results.length ? browse_results.shift() : null);
				$document.trigger('results_init_done');
			} else {
				profile_shown = set_next();
				add_next_profile_dom(next_result);
				if (yalwa.dol.helper.is_unconfirmed()) {
					yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/unconfirmed_swipes.js', function() {
						yalwa.unconfirmed_swipes.show_plp_on_last_profile();
					});
				}
			}

			if (!profile_shown) {
				return;
			}
			pub.current_profile_init();
			return true;
		}

		pub.current_profile_init = function() {
			check_more_images_indicator();
			const $c = discover.get_current_profile();
			$c.find('.js-dol_flag_profile').on('click', pub.flag.flag_profile_show);
			let to = null;
			$c.find('.js-dol_profile_core').on('touchstart', (e) => {
				if (!jQuery(e.target).hasClass('js-core_profile_hashtag')) {
					to = setTimeout(() => {
						yalwa.basics.hide($c.find('.dol_profile_core_hashtags'));
					}, 100);
				}
			}).on('touchend touchmove', () => {
				clearTimeout(to);
				if (!helper.is_unconfirmed() && !helper.is_frozen()) {
					yalwa.basics.show(jQuery('.dol_profile_core_hashtags'));
				}
			});
			set_height();

			if (jQuery('.js-dol_result_image').length > 2) {
				yalwa.basics.show(jQuery('.js-see_more'));
			} else {
				yalwa.basics.hide(jQuery('.js-see_more'));
			}

			init_current_profile_image_slides();
			return true;
		};

		function init_current_profile_image_slides() {
			const $c = discover.get_current_profile();
			profile_current_has_more_images = $c.find('.js-dol_result_image').length;

			if (!profile_current_has_more_images) {
				// hide the three dots icon
				yalwa.basics.hide(jQuery('.js-more_images_info'));
				return;
			}

			if (helper.is_unconfirmed() || helper.is_frozen()) {
				yalwa.basics.hide(jQuery('.js-more_images_info'));
			}

			const queue = get_image_queue();
			$c.find('.js-dol_profile_core').on('click', function(e) {
				// https://stackoverflow.com/a/59626426/6345257
				let center = jQuery(this).width() / 2;
				if (e.offsetX > center) { // right click
					$c.find('.js-dol_profile_core_img').attr('src', queue[1]);
					const first_image = queue.shift();
					queue.push(first_image);
				} else { // left click
					$c.find('.js-dol_profile_core_img').attr('src', queue[queue.length - 1]);
					const last_image = queue.pop();
					queue.unshift(last_image);
				}
			});
		}

		function get_image_queue() {
			const queue = [];
			const $cp = discover.get_current_profile();
			queue.push($cp.find('.js-dol_profile_core img').attr('src'));
			const $other_images = $cp.find('.js-dol_result_image');
			if ($other_images.length) {
				if (!helper.is_unconfirmed() && !helper.is_frozen()) {
					yalwa.basics.show(jQuery('.js-more_images_info'));
				}
				jQuery.each($other_images, function(index, $img) {
					queue.push(jQuery($img).attr('src'));
				});
			}
			return queue;
		}

		function check_more_images_indicator() {
			const $current = discover.get_current_profile();
			if (!$current.length) {
				return;
			}
			const factsheets_available = $current.find('.js-factsheets').length;
			const show_indicator = $current.find('.js-dol_result_image').length || factsheets_available;
			const $el = $current.find('.js-indicate_more_images');
			if (show_indicator) {
				$el.on('click', discover.scroll_to_hashtags);
				yalwa.basics.bem_modifier($el, 'animate', 'add');
				$current.one('scroll', () => { // also needed for technical reasons: page flickers on iOS with animation during scroll/swipe
					yalwa.basics.bem_modifier($el, 'animate', 'remove');
				});
				yalwa.basics.show($el);
			}
			if (factsheets_available) {
				factsheet_height_coversation();
			}
		}

		function set_height() {
			if (discover.get_current_profile() === undefined) {
				return;
			}
			let client_height = document.documentElement.clientHeight;
			let header = jQuery('.js-htabs').outerHeight();
			let $card = jQuery('.js-dol_swipe_card');
			pub.buttons_container_height = $card.siblings('.js-buttons_static').outerHeight();
			if (pub.buttons_container_height === 0) {
				window.setTimeout(function() {
					set_height();
				}, 200)
			}
			$card.css({minHeight: client_height - header - 20 - pub.buttons_container_height});
			let $current_profile = discover.get_current_profile();
			if ($current_profile && $current_profile.length) {
				$current_profile.find('.dol_profile_core__image').addClass('dol_profile_core__image--regular');
			}

			set_filter_icon_position();
			//Show Filter Tooltip
			if (show_filter_remove_plp && jQuery($current_profile).data('id') === show_filter_remove_plp.profileID) {
				//Check for data buckets to show optional filter removal PLP
				if (yalwa.v.init_global_swipe && show_filter_remove_plp.show_hashtag_optional_plp) {
					yalwa.dol.discover.show_optional_filter_removal_plp();
					global_swipe_keep_hashtag_filters = true;
					show_filter_remove_plp = null;
					return;
				}

				if (show_filter_remove_plp.hashtag_filter_removed || show_filter_remove_plp.distance_filter_removed) {
					yalwa.dol.second_chance.show_tool_tip(show_filter_remove_plp);
					global_swipe_keep_hashtag_filters = true;
					show_filter_remove_plp = null;
				}
			}
			if (yalwa.v.init_global_swipe) {
				jQuery('.js-gs_country_info_tooltip_btn').on('click', init_global_swipe_country_info_tooltip);
			}
		}

		pub.set_height = set_height;

		function profile_like($profile, is_click) {
			let $like_btn = $profile.find('.js-like_btn');
			if ($like_btn.length && $like_btn.hasClass('js-like_limit_reached')) {
				yalwa.discover.init_cooldown_premium_prompt();
				if (!is_click) {
					let $current = discover.get_current_profile();
					$current.attr('style', '');
					$current.find('.js-dislike_btn,.js-like_btn').attr('style', '');
				}
				discover.init_current();
				return;
			}
			
			$profile.velocity({translateX: 450, rotateZ: '30deg'}, {
				duration: duration, complete: () => {
					$profile.remove();
				}
			});
			log_reaction('like', $profile);
			let one_more_available = show_next();
			yalwa.basics.ga.metric_set('CM_DOL_LIKE', 1);
			if (one_more_available) {
				yalwa.basics.ga.pageview({'page': '/' + yalwa.v.path_segment + '/dol/' + yalwa.v.VIEW_DISCOVER + '/'});
			} else {
				yalwa.basics.ga.pageview({'page': 'dol_browse_empty'});
			}
			yalwa.basics.ga.metric_unset('CM_DOL_LIKE');
		}

		function profile_dislike($profile, is_click) {
			$profile.velocity({translateX: -450, rotateZ: '-30deg'}, {
				duration: duration, complete: () => {
					$profile.remove();
				}
			});
			log_reaction('dislike', $profile);
			let one_more_available = show_next();
			yalwa.basics.ga.metric_set('CM_DOL_DISLIKE', 1);
			if (one_more_available) {
				yalwa.basics.ga.pageview({'page': '/' + yalwa.v.path_segment + '/dol/' + yalwa.v.VIEW_DISCOVER + '/'});
			} else {
				yalwa.basics.ga.pageview({'page': 'dol_browse_empty'});
			}
			yalwa.basics.ga.metric_unset('CM_DOL_DISLIKE');
		}
		
		function promo_swipe($promo, direction, extra_param = '') {
			//Show the filters and rewind swipe again
			yalwa.basics.show(jQuery('.js-discover_top_bar_actions'));
			
			let promo_type = $profile.data('promo_type');
			let promo_id = $profile.data('promo_id');
			if(direction == 'left') {
				$promo.velocity({translateX: -450, rotateZ: '-30deg'}, {
					duration: duration, complete: () => {
						$promo.remove();
					}
				});
			}else {
				$profile.velocity({translateX: 450, rotateZ: '30deg'}, {
					duration: duration, complete: () => {
						$profile.remove();
					}
				});
			}
			
			//DL event to track promo swipes
			//location_selection
			if (siwpe_promo_manually) {
				let data = {event: 'between_swipes_promo_close', between_swipes_promo: promo_type};
				yalwa.basics.datalayer_push(data);
			}
			
			show_next();
			if (promo_type === 'swipe-preference-selection') {
				yalwa.dol.inbetween_fixed_promos.set_action_taken('swipe_preference_selection');
			}
			
			if (promo_type === 'stream-female-promo') {
				//track click
				if (extra_param !== 'action_taken') {
					yalwa.basics.datalayer_push({event: 'start_stream_promo_clicks', 'stream_promo_actions': 'start_stream_promo_close'});
				}
			}
			
			//Ajax call to log the reaction
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {
					action: 'log_promo_reaction',
					promo_type: promo_type,
					promo_id: promo_id
				}
			}).done(function () {  });
			//Init the next profile again
			show_next();
		}
		pub.promo_swipe = promo_swipe;
		
		function hide_inbetween_promo() {
			let $card = jQuery('.js-inbetween_promo');
			promo_swipe($card, 'right');
		}

		let swipes_count = 0;
		let like_swipes_count = 0;
		let dislike_swipes_count = 0;
		let is_first_swipe = false;
		let is_first_like = false;
		let is_first_dislike = false;

		function set_swipe_count_in_ss(type) {
			if (yalwa.basics.ss_get('swipes_count')) {
				swipes_count = yalwa.basics.ss_get('swipes_count');
			}
			
			swipes_count = Number(swipes_count) + Number(1);
			is_first_swipe = swipes_count === 1;
			yalwa.basics.ss_set('swipes_count', swipes_count);
			
			if (yalwa.basics.ss_get(type + '_swipes_count')) {
				if (type === 'like') {
					like_swipes_count = yalwa.basics.ss_get(type + '_swipes_count');
				} else {
					dislike_swipes_count = yalwa.basics.ss_get(type + '_swipes_count');
				}
			}
			
			if (type === 'like') {
				like_swipes_count = Number(like_swipes_count) + Number(1);
				is_first_like = like_swipes_count === 1;
				yalwa.basics.ss_set(type + '_swipes_count', like_swipes_count);
			} else {
				dislike_swipes_count = Number(dislike_swipes_count) + Number(1);
				is_first_dislike = dislike_swipes_count === 1;
				yalwa.basics.ss_set(type + '_swipes_count', dislike_swipes_count);
			}
		}
		
		function is_first_swipe_of_session() {
			return is_first_swipe;
		}

		function get_hours_between_unix_dates($end_date, $start_date) {
			const time_elapsed_since_first_login = new Date($start_date * 1000);
			const current_date_time = new Date($end_date * 1000);
			return parseInt(Math.abs(current_date_time - time_elapsed_since_first_login) / (1000 * 60 * 60) % 24);
		}

		function get_days_between_unix_dates($end_date, $start_date) {
			const time_elapsed_since_first_login = new Date($start_date * 1000);
			const current_date_time = new Date($end_date * 1000);
			return parseInt(Math.abs(current_date_time - time_elapsed_since_first_login) / (1000 * 60 * 60 * 24));
		}

		function track_out_of_swipes() {
			//GA Datalayer Event to push the data to GA
			//Updated the code and used the predefined methods
			let filters_count = 0;
			if (pub.is_distance_filter_is_applied() || pub.is_age_filter_applied()) {
				filters_count++;
			}

			if (yalwa.dol.hashtags.get_selected_text().length > 0) {
				filters_count++;
			}

			const elapsed_hours_since_login = get_hours_between_unix_dates(yalwa.basics.unix(), yalwa.v.start_ts);
			const elapsed_days_since_login = get_days_between_unix_dates(yalwa.basics.unix(), yalwa.v.start_ts);
			const max_hours = 12;

			const config = {
				'filters_enabled': filters_count,
				'swipes': yalwa.basics.ss_get('swipes_count') || 1,
				'first_session': (elapsed_days_since_login === 0 && elapsed_hours_since_login <= max_hours) || false,
				'duration': max_hours
			};
			yalwa.basics.datalayer_push({event: 'out_of_swipes', data: config});
			setTimeout(function() {
				//Send ping to GA
				const active_session_config = {
					'countdown': 15,
					'first_session': (elapsed_days_since_login === 0 && elapsed_hours_since_login <= max_hours) || false,
					'duration': max_hours
				};
				yalwa.basics.datalayer_push({event: 'timer_expired', data: active_session_config});
			}, 15000);
		}

		/**
		 * set the position of filter icon, only works for frozen and unconfirmed users
		 */
		function set_filter_icon_position() {
			// DEV-7005
			if((yalwa.dol.helper.is_frozen() || yalwa.dol.helper.is_unconfirmed())){
				jQuery('.js-dol_search_refine').css('top' , '55px');
			}
		}

		let dont_show_educate_plp = false;

		function log_reaction(type, $profile) {
			const profileID = $profile.data('id'),
				gender = $profile.data('gender'),
				shared = $profile.data('shared') ? $profile.data('shared') : false;
			const international = $profile.data('is_international');
			if (international) {
				add_international_swipe_in_ss(international);
			}
			set_swipe_count_in_ss(type);
			if (type === 'like') {
				set_last_like_name_in_ss($profile);
			}
			set_filter_icon_position();
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {
					action: 'log_reaction',
					type: type,
					target_profileID: profileID,
					target_gender: gender,
					shared: shared
				}
			}).done(function(r) {
				// increase/set the reaction count in Local storage
				increase_reaction_count_on_ls();
				if (yalwa.discover) {
					yalwa.discover.increase_reaction_count_on_ss();
				}
				if (r.error) {
					if (r.error === 'gender_limit_reached') {
						show_limit_reached();
						return;
					}
					// if (r.error === 'gender_limit_reached') {
					// 	discover.load_results_default(false);
					// 	return;
					// }
					if (r.error === 'limit_reached') {
						// add tracking https://yalwa.atlassian.net/browse/DEV-5772/
						yalwa.basics.ga.event({
							category: 'cool_down',
							action: type + '_limit'
						});
						show_limit_reached();
						return;
					}
					if (r.error === 'tot_swipe_limit_reached') {
						show_tot_swipe_limit_reached(r.cta_variation);
						return;
					}
				}
				if (r.is_match) {
					yalwa.basics.ga.ping_metric('CM_DOL_MATCH', 1);
					yalwa.v.matches_count = r.match_count || yalwa.v.matches_count;
					match_after_like(profileID, r.conversationID, r.can_show_chat_highlight);
					
					if (yalwa.v.premium_enabled_country) {
						rewind.hide();
					}
					
					if (r.show_mc_warning_message) {
						yalwa.v.init_settings.seen_mc_warning_message.push(r.show_mc_warning_message);
					}
				} else {
					if (type === 'like') {
						if (yalwa.likes) {
							yalwa.likes.reset_like_page();
						}
						//todo refector it better
						if (show_filter_remove_plp && jQuery($profile_next).data('id') === show_filter_remove_plp.profileID) {
							dont_show_educate_plp = jQuery($profile_next).data('id');
						}
						let $current_profile = discover.get_current_profile();
						let this_profile_id = ($current_profile) ? $current_profile.data('id') : 0;
						if (dont_show_educate_plp && this_profile_id === dont_show_educate_plp) {
							dont_show_educate_plp = false;
						} else {
							yalwa.dol.match_educate.init(profileID);
						}
						yalwa.dol.app_rating.init();

						if (yalwa.v.premium_enabled_country && r.show_profile_boost_prompt) {
							yalwa.basics.ss_set('pf_all_touchpoint', 'profile_boost_prompt');
							yalwa.basics.ss_set('pf_all_type', 'premium_bundle');
							yalwa.basics.datalayer_push({
								'event': 'pf_all_touchpoint_click',
								'pf_all_touchpoint': 'profile_boost_prompt',
								'pf_all_type': 'premium_bundle',
								'pf_is_app': yalwa.basics.is_dol_app() !== false,
								'eventCallback': function() {
									yalwa.dol.nav.to_premium_profile_boost();
								},
								'eventTimeout': 2000
							});
						}
					}
					// when dol_reaction_count ls value reach 3 then show promo
					show_app_promo_after_three_swipes();
					if (r.swipe_motivation) {
						//todo refector it better
						if (show_filter_remove_plp && jQuery($profile_next).data('id') === show_filter_remove_plp.profileID) {
							dont_show_motivation_plp_profileID = jQuery($profile_next).data('id');
						}
						let $current_profile = discover.get_current_profile();
						let this_profile_id = ($current_profile) ? $current_profile.data('id') : 0;
						if (dont_show_motivation_plp_profileID && this_profile_id === dont_show_motivation_plp_profileID) {
							dont_show_motivation_plp_profileID = false;
						} else {
							yalwa.dol.swipe_motivation_plp.init();
						}
					}

					if (yalwa.v.premium_enabled_country) {
						if (r.rewind_used) {
							rewind.hide();
						}
						
						if (yalwa.v.premium_profile) {
							rewind.init();
						} else {
							// reduce the API request for non-premium users
							// https://yalwa.atlassian.net/browse/DEV-6636
							if (r.show_potential_match_tooltip) {
								rewind.show_tooltip(r.potential_match_tooltip_text);
							}
							
							if (r.rewind_profile_img) {
								rewind.update_rewind_img(r.rewind_profile_img);
							}
						}
					}
					show_international_swipes_survey();
					if (r.show_blind_date) {
						yalwa.dol.discover.blind_date_popup();
					}
					
					// https://yalwa.atlassian.net/browse/DEV-7044
					yalwa.discover.show_profile_boost_tooltip();
				}
				if (r.unconfirmed_swipes_data) {
					yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/unconfirmed_swipes.js', function() {
						yalwa.unconfirmed_swipes.init(r.unconfirmed_swipes_data);
					});
				}
				if (r.frozen_swipes_data) {
					yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/frozen_swipes.js', function() {
						yalwa.frozen_swipes.init(yalwa.v.VIEW_DISCOVER, false, r.frozen_swipes_data);
					});
				}
				//Only International Swipe + either active or pending profiles + no match educate
				if (r.show_international_swipe_onetime_promo) {
					yalwa.discover.init_global_swipe_info_plp('onetime_promo');
				}
				
				if (r.target_profileID) {
					yalwa.discover.hide_likes_card_after_swipe_on_discover(r.target_profileID);
				}
				
				if (r.has_reached_like_limit) {
					let $like_btns = jQuery('.js-like_btn');
					if ($like_btns.length) {
						$like_btns.addClass('js-like_limit_reached');
					}
				}
				if (is_first_swipe_of_session()) {
					//DEV-8520
					yalwa.basics.datalayer_push({event: 'first_swipe'});
				}
				// https://yalwa.atlassian.net/browse/DEV-9631
				if (type === 'like') {
					// check if this is first or every 10th like
					if (can_show_free_wow_send_page()) {
						yalwa.basics.navigate(yalwa.v.url_send_frozen_free_wow + '?pid=' + profileID);
						return;
					}
				}
				
			});
		}
		
		function can_show_free_wow_send_page() {
			if (!yalwa.v.FROZEN_FLOW_WITH_WOW) {
				return false;
			}
			
			if (!yalwa.dol.helper.is_frozen()) {
				return false;
			}
			
			if (yalwa.v.has_wow_premium_feature) {
				return false;
			}
			
			if (like_swipes_count === 1) {
				return true;
			}
			
			if (like_swipes_count % 10 === 0) {
				return true;
			}
		}

		function show_app_promo_after_three_swipes() {
			const ls_dol_reaction_count = yalwa.basics.ls_get('dol_reaction_count');
			if (ls_dol_reaction_count >= 3) {
				$document.trigger('can_show_promo_on_headroom');
			}
		}

		function show_limit_reached() {
			jQuery('.js-dol_results').remove();
			get_cooldown_version().done(function(response) {
				if (response && response.success) {
					// show limit reachout / out of results page
					yalwa.basics.show(jQuery('.js-dol_browse_limit'));
					yalwa.basics.hide(jQuery('.js-dol_search_refine'));
					yalwa.basics.hide(jQuery('.js-more_images_info'));
					$document.trigger('limit_reached_shown');

					// show the cooldown page
					show_cooldown(response.promote, response.variant);
					init_cool_down_page();
					// https://yalwa.atlassian.net/browse/DEV-9631
					yalwa.dol.profile.show_frozen_plp();
					if (yalwa.dol.helper.is_frozen()) {
						yalwa.frozen_swipes.allow_switching_tabs(yalwa.v.VIEW_DISCOVER);
					}
				}
			});
			//if cooldown is shown on discover view, then,
			// on hashtag deletion, check again which to promote
			$document.off('hashtag_deleted').on('hashtag_deleted', function() {
				if (!jQuery('.js-dol_browse_limit').hasClass('hidden')) {
					show_limit_reached();
				}
			});
		}

		function show_tot_swipe_limit_reached($cta_variation) {
			jQuery('.js-dol_results').remove();
			yalwa.basics.hide(jQuery('.js-dol_search_refine, .js-dol_browse_limit_wrap, .js-more_images_info'));
			yalwa.basics.show(jQuery('.js-dol_browse_limit, .js-cool_down_this_that_after_swipes'));

			const $factsheets_wrap = jQuery('.js-tot_cooldown_after_swipes_factsheets');
			const $hashtags_wrap = jQuery('.js-tot_cooldown_after_swipes_hashtags');
			switch ($cta_variation) {
				case 0: // no promo
					yalwa.basics.hide($factsheets_wrap);
					yalwa.basics.hide($hashtags_wrap);
					yalwa.basics.show(jQuery('.js-tot_cooldown_blog'));
					yalwa.basics.ga.event({
						category: 'cool_down',
						action: 'Tot_cool_down_done_nocta_view'
					});
					jQuery('.js-blog_card')
						.velocity("transition.slideUpBigIn", {duration: 1000, delay: 500})
						.on('click', function() {
							yalwa.basics.ga.event({
								category: 'cool_down',
								action: 'Tot_cool_down_done_nocta_click_blog'
							}).done(() => {
								yalwa.basics.new_tab(jQuery(this).data('href'));
							});
						});
					break;

				case 1: // factsheets
					yalwa.basics.show($factsheets_wrap);
					break;

				case 2: // hashtags
					yalwa.basics.show($hashtags_wrap);
					break;
			}

			jQuery('.js-tot_cooldown_after_swipes_hashtags_cta').on('click', function() {
				yalwa.basics.navigate(yalwa.dol.build_url(yalwa.v.VIEW_HASHTAGS));
			});

			jQuery('.js-tot_cooldown_after_swipes_factsheets_cta').on('click', function() {
				yalwa.basics.navigate(yalwa.dol.build_url(yalwa.v.VIEW_FACTSHEET));
			});

			jQuery('.js-tot_cooldown_after_swipes_results_cta').on('click', function() {
				jQuery.ajax({
					url: API_PATH_DOL,
					dataType: 'json',
					type: 'get',
					data: {action: 'get_last_initialized_played_tot_gameID'}
				}).done(function(response) {
					if (response.success) {
						helper.track_tot('See_my_results_cooldown_after_swipes', 'start').then(() => {
							const tot_results_url = yalwa.dol.build_url(yalwa.v.VIEW_THISTHAT, 'results', {
								gid: response.gameID,
								ref: 'cooldown'
							});
							yalwa.basics.navigate(tot_results_url);
						});
					}
				});
			});
			const track_action = yalwa.basics.ls_get('tot_invited_start_swipe') ? 'StartSwipe_invitematch_successpage' : 'StartSwipe_sucess_page';
			yalwa.dol.helper.track_tot(track_action, 'finish');
		}

		function init_cool_down_page() {
			if (cool_down_page_initialized) {
				return;
			}
			cool_down_page_initialized = true;

			jQuery('.js-cool_down_cta_hashtags').on('click', function() {
				yalwa.basics.ga.event({
					category: 'cool_down',
					action: 'Hashtag_cool_down_start'
				});
				yalwa.basics.ss_set('track_cool_down', true);
				yalwa.basics.navigate(yalwa.dol.build_url(yalwa.v.VIEW_HASHTAGS));
			});
		}

		function get_cooldown_version() {
			let selected_hashtags_text = hashtags.get_selected_text();
			selected_hashtags_text = selected_hashtags_text.length ? selected_hashtags_text.join() : null
			let exclude_profiles = buffer_exclude_items.length ? buffer_exclude_items.join() : null

			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {
					action: 'get_cooldown_version',
					hashtags: selected_hashtags_text,
					exclude_profiles: exclude_profiles
				}
			});
		}

		/**
		 *
		 * @param version
		 * @param variant used for AB testing for no promo view
		 */
		function show_cooldown(version, variant) {
			switch (version) {
				case 0:
					yalwa.basics.ga.event({category: 'cool_down', action: 'Cool_down_nocta_view'});
					yalwa.basics.show(jQuery('.js-cool_down_no_promo'));
					if (variant === 'A') {
						yalwa.basics.ga.event({category: 'cool_down', action: 'Cool_down_nocta_view_blog_article'});
						yalwa.basics.show(jQuery('.js-no_promo_blog'));
						jQuery('.js-blog_card')
							.velocity("transition.slideUpBigIn", {duration: 1000, delay: 500})
							.on('click', function() {
								yalwa.basics.ga.event({
									category: 'cool_down',
									action: 'Cool_down_nocta_click_blog'
								}).done(() => {
									yalwa.basics.new_tab(jQuery(this).data('href'));
								});
							});
					} else if (variant === 'B') {
						yalwa.basics.ga.event({category: 'cool_down', action: 'Cool_down_nocta_view_blog_buttons'});
						yalwa.basics.show(jQuery('.js-no_promo_blog_cat'));
						jQuery('.js-no_promo_blog_cat_cta').on('click', function() {
							yalwa.basics.ga.event({
								category: 'cool_down',
								action: 'Cool_down_nocta_click_blog_buttons',
								label: jQuery(this).data('ga-label')
							}).done(() => {
								yalwa.basics.new_tab(jQuery(this).data('href'));
							});
						});
					}
					break;

				case 1: // my info
					yalwa.basics.hide(jQuery('.js-cool_down_hashtags'));
					yalwa.basics.show(jQuery('.js-cool_down_factsheet'));
					yalwa.basics.ga.event({category: 'cool_down', action: 'Myinfo_cool_down_view'});
					break;

				case 2: // hashtag
					yalwa.basics.hide(jQuery('.js-cool_down_factsheet'));
					yalwa.basics.show(jQuery('.js-cool_down_hashtags'));
					yalwa.basics.ga.event({category: 'cool_down', action: 'Hashtag_cool_down_view'});
					break;

				case 3: // this or that
					yalwa.basics.ga.event({category: 'cool_down', action: 'Tot_cool_down_view'});
					yalwa.basics.hide(jQuery('.js-cool_down_factsheet, .js-cool_down_factsheet, .js-dol_browse_limit_wrap'));
					yalwa.basics.show(jQuery('.js-cool_down_this_that'));
					jQuery('.js-this_that_start')
						.off('click')
						.on('click', start_tot_game);
					break;
				// extra swipes
				case 4:
					yalwa.basics.ss_set('pf_all_touchpoint', 'cooldown_page');
					yalwa.basics.ss_set('pf_all_type', 'premium_bundle');
					yalwa.basics.load_css(yalwa.basics.static_url('css') + 'dol/pages/premium.css');
					yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/premium.js').done(function() {
						yalwa.basics.hide(jQuery('.js-dol_browse_limit_wrap'));
						yalwa.basics.show(jQuery('.js-extra_swipes_prompt'));
						rewind.hide();
						yalwa.premium.init_extra_swipes();
					});
					break;
			}
		}

		pub.match_after_like = match_after_like;

		function match_after_like(profileID, conversationID, show_chat_highlight_prompt, $liked_profile_card) {
			jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'html',
				type: 'get',
				data: {
					action: 'match_popup',
					target_profileID: profileID
				}
			}).done(function(html) {
				yalwa.mobile.generic_shadow.show();
				jQuery('body').append(html);
				jQuery('.js-dol_match_close').on('click', function() {
					track_match_screen('engagement', 'close');
					match_after_like_close(show_chat_highlight_prompt, $liked_profile_card);
				});
				jQuery('.js-dol_new_conversation_submit').on('click', function() {
					track_match_screen('engagement', 'custom_message');
					new_conversation_submit(conversationID, true, show_chat_highlight_prompt, $liked_profile_card);
				});
				let dol_init_message = jQuery('.js-dol_init_message');
				dol_init_message_input();
				dol_init_message.on('input', dol_init_message_input);
				dol_init_message.on('keypress', (event) => {
					if (event.keyCode === 13) { // enable keyboard enter button to send message
						event.preventDefault();
						jQuery('.js-dol_new_conversation_submit').trigger('click');
					}
				});
				yalwa.mobile.ali.init();
				if (yalwa.v.is_ios && yalwa.v.is_phonegap) {
					yalwa.mobile.force_repaint('.js-chat_append');
				}
				$document.trigger('hide_app_promo');
				//Init click
				jQuery('.js-match_emojis').on('click', function() {
					send_icebreaker_message(jQuery(this), conversationID, 'emoji', show_chat_highlight_prompt, $liked_profile_card);
				});
				jQuery('.js-icebreaker_btn').on('click', function() {
					new_conversation_submit_ajax(jQuery(this).data('salutation_msg'), conversationID, false);
					send_icebreaker_message(jQuery(this), conversationID, 'icebreaker', show_chat_highlight_prompt, $liked_profile_card);
				});
				track_match_screen('view', '');

				//Animations
				if (!yalwa.v.its_a_match_animation) {
					//No animation (load simple)
					jQuery('.js-animate_match_wrapper').addClass('fade_in_wrapper');
				} else {
					let animation_speed = 300;
					setTimeout(function() {
						jQuery('.js-animate_match_title').fadeIn();
						jQuery('.js-animate_match_title').addClass('glow');
						setTimeout(function() {
							jQuery('.js-animate_match_title').addClass('scroll_to_top');
							setTimeout(function() {
								jQuery('.js-animate_match_images > img').addClass('slide_images');
								setTimeout(function() {
									jQuery('.js-animate_match_title').css('top', '35px');
									jQuery('.js-animate_match_images').css('top', '17%');
									//Show wrapper
									jQuery('.js-animate_match_wrapper').addClass('fade_in_wrapper');
									//Hide these
									jQuery('.js-animate_match_title').addClass('fade_out_wrapper');
									jQuery('.js-animate_match_images').addClass('fade_out_wrapper');
								}, animation_speed);
							}, animation_speed);
						}, animation_speed);
					}, animation_speed);
				}
			})

		}

		pub.blind_date_popup = blind_date_popup;

		function blind_date_popup() {
			jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {
					action: 'blind_date'
				}
			}).done(function(response) {
				if (response.success) {
					let conversationID = response.conversationID;
					jQuery('body').append(response.html);

					//TODO below events area same as match popup code can be common
					jQuery('.js-dol_new_conversation_submit').on('click', function() {
						new_conversation_submit(conversationID);
					});
					let dol_init_message = jQuery('.js-dol_init_message');
					dol_init_message_input();
					dol_init_message.on('input', dol_init_message_input);
					dol_init_message.on('keypress', (event) => {
						if (event.keyCode === 13) { // enable keyboard enter button to send message
							event.preventDefault();
							jQuery('.js-dol_new_conversation_submit').trigger('click');
						}
					});
					//Init click
					jQuery('.js-match_emojis').on('click', function() {
						send_icebreaker_message(jQuery(this), conversationID, 'emoji')
					});
					jQuery('.js-icebreaker_btn').on('click', function() {
						new_conversation_submit_ajax(jQuery(this).data('salutation_msg'), conversationID, false);
						send_icebreaker_message(jQuery(this), conversationID, 'icebreaker');
					});

					jQuery('.js-animate_blind_match_wrapper').addClass('fade_in_wrapper');

					jQuery('.js-blind_match_close').on('click', function() {
						close_blind_match();
					})

					jQuery('.js-show_profile').on('click', function() {
						show_blind_date_profile(conversationID);
					});

					//Trak in GA
					yalwa.basics.datalayer_push({event: 'first_session_match'});
				}
			});

			jQuery('.js-blind_match_close').on('click', close_blind_match)
		}

		function close_blind_match() {
			jQuery('.js-dol_match_popup').remove();
		}

		function show_blind_date_profile(conversationID) {
			if (jQuery('.js-other_profile_view').length) {
				yalwa.basics.show(jQuery('.js-other_profile_view'));
				return '';
			}
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {
					action: 'view_profile',
					target_profileID: jQuery('.js-dol_match_popup').data('target_profileid')
				}
			}).done(function(r) {
				let html = '<div class="profile_view_container js-other_profile_view" >' + r.top_bar + r.html + '</div>';
				jQuery('.js-dol_match_popup').append(html);
				jQuery('.js-close_profile_view').on('click', function() {
					close_profile_view(conversationID);
				});
			});
		}

		function close_profile_view(conversationID) {
			yalwa.basics.navigate(yalwa.dol.build_url('chats') + '?cID=' + conversationID + '&sl_index=1');
		}

		function send_icebreaker_message($this, conversationID, tracking_type = false, show_chat_highlight_prompt, $liked_profile_card) {
			//let $this = jQuery(this);
			let this_text = $this.data('text');
			let this_key = $this.data('key');
			let dol_init_message = jQuery('.js-dol_init_message');
			dol_init_message.val(this_text);
			//Track in GA
			if (tracking_type === 'icebreaker') {
				let lang_key = $this.data('lang_key');
				let ga_label = this_text;
				ga_label = 'icebreaker_' + ga_label + '_' + lang_key;
				ga_label = ga_label.split(' ').join('_');
				track_match_screen('engagement', ga_label)
			} else if (tracking_type === 'emoji') {
				let ga_label = tracking_type + '_' + this_key;
				track_match_screen('engagement', ga_label);
			}

			new_conversation_submit(conversationID, true, show_chat_highlight_prompt, $liked_profile_card);
		}

		function track_match_screen(action, label) {
			yalwa.basics.ga.event({
				category: 'match_screen',
				action: action,
				label: label
			});
		}

		function dol_init_message_input() {
			const textarea = jQuery('.js-dol_init_message');
			let val = textarea.val();
			jQuery('.js-dol_init_message_contact').css({height: 'auto'});
			textarea[0].style.height = "1px";
			textarea[0].style.height = (textarea[0].scrollHeight) + "px";
			if (val.length < 29) {
				textarea[0].style.height = "auto";
			}
			if (val.length < 70 && val.length > 29) {
				textarea[0].style.height = "60px";
			}
		}

		function new_conversation_submit(conversationID, close_window = true, show_chat_highlight_prompt, $liked_profile_card) {
			var message = jQuery('.js-dol_init_message').val();
			if (!message) {
				jQuery('.js-dol_init_message').parent().velocity('callout.shake');
				return;
			}
			new_conversation_submit_ajax(message, conversationID, close_window, show_chat_highlight_prompt, $liked_profile_card);
		}

		function new_conversation_submit_ajax(message, conversationID, close_window = true, show_chat_highlight_prompt, $liked_profile_card) {
			jQuery.ajax({
				url: '/api/ajax/chat',
				dataType: 'json',
				async: false,
				type: 'POST',
				data: {
					action: 'new_message',
					conversationID: conversationID,
					text: message,
					emailID: yalwa.v.emailID,
					is_dol: true,
					mark_read: true
				}
			}).done(function(response) {
				if (response.type === 'error') {
					yalwa.dol.toast({message: response.html, type: 'error', timeOut: 2000});
				} else {
					if (close_window) {
						yalwa.dol.toast({
							message: yalwa.v.lang.dol_matches_message_sent,
							type: 'success',
							timeOut: 1000
						});
						match_after_like_close(show_chat_highlight_prompt, $liked_profile_card);
					}
				}
			});
		}

		function match_after_like_close(show_chat_highlight_prompt, $liked_profile_card) {
			yalwa.mobile.generic_shadow.hide();
			jQuery('.js-dol_match_popup').remove();
			if (yalwa.chat) {
				yalwa.chat.reload_list(yalwa.chat.current_context()).done(chats.check_empty_chats_view);
			}
			yalwa.dol.app_rating.init();
			if (show_chat_highlight_prompt) {
				yalwa.basics.ss_set('pf_all_touchpoint', 'mc_highlight_prompt');
				yalwa.basics.ss_set('pf_all_type', 'premium_bundle');
				yalwa.basics.datalayer_push({
					'event': 'pf_all_touchpoint_click',
					'pf_all_touchpoint': 'mc_highlight_prompt',
					'pf_all_type': 'premium_bundle',
					'pf_is_app': yalwa.basics.is_dol_app() !== false,
					'eventCallback': yalwa.dol.nav.to_premium_chats,
					'eventTimeout': 2000
				});
			}
			
			if ($liked_profile_card && $liked_profile_card.length) {
				$liked_profile_card
					.velocity("fadeOut", { duration: 1500 });
			}
		}

		/**
		 * set/increase count on reaction count for Android/iOS users
		 * used showing app promos
		 */
		function increase_reaction_count_on_ls() {
			const allowed_device_types = ['Android', 'iOS'];
			if (allowed_device_types.indexOf(helper.detect_device_type()) === -1) {
				return;
			}
			let ls_dol_reaction_count;
			ls_dol_reaction_count = (ls_dol_reaction_count = yalwa.basics.ls_get('dol_reaction_count')) ?
				parseInt(ls_dol_reaction_count) + 1 : 1;
			if (ls_dol_reaction_count < 5) {
				yalwa.basics.ls_set('dol_reaction_count', ls_dol_reaction_count);
			}
		}
		
		function increase_reaction_count_on_ss() {
			ss_swipe_count = (ss_swipe_count = yalwa.basics.ls_get('ss_swipe_count')) ?
				parseInt(ss_swipe_count) + 1 : 1;
			yalwa.basics.ls_set('ss_swipe_count', ss_swipe_count);
		}

		function init_global_swipe_country_info_tooltip() {
			let $this = jQuery(this);
			let user_selection = jQuery('.js-select_preference_buttons > .js-select_swipe_preference.js-active').data('preference_type') || false;
			//check if user has selected international only
			let label = (user_selection && user_selection === 1) ? yalwa.v.init_settings.dol_country_flag.replace('%1$s', $this.data('country_name')) : yalwa.v.dol_country_flag_info.replace('%1$s', $this.data('country_name'));
			yalwa.basics.load_tippy().done(() => {
				yalwa.basics.load_css('https://unpkg.com/tippy.js@6.2.6/animations/scale-extreme.css');
				const gs_country_info_tooltip = tippy(this, {
					content: label,
					maxWidth: 180,
					allowHTML: true,
					animation: 'scale-extreme',
					delay: 1,
					strategy: 'fixed',
					trigger: 'manual',
					hideOnClick: true,
					theme: 'dol_removed_filters',
					onShow(instance) {
						setTimeout(instance.hide, 3000);
					},
					onHide() {

					}
				});

				gs_country_info_tooltip.show(100);
			});
		}

		function start_tot_game() {
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'GET',
				data: {
					action: 'tot_start_game'
				}
			}).done(function(response) {
				if (response && response.success) {
					helper.track_tot('Game_system', 'start').then(() => {
						const game_start_url = yalwa.dol.build_url(yalwa.v.VIEW_THISTHAT, 'play', {gid: response.id});
						yalwa.basics.navigate(game_start_url);
					});
				}
			});
		}
		
		pub.start_tot_game = start_tot_game;

		pub.results_init_done = () => results_init_done;

		function add_international_swipe_in_ss(international) {
			if (yalwa.v.language !== 'english') {
				return;
			}
			if (international) {
				let international_swipes_count = yalwa.basics.ss_get('international_swipes_count') ? parseInt(yalwa.basics.ss_get('international_swipes_count')) : 0;
				yalwa.basics.ss_set('international_swipes_count', international_swipes_count + 1);
			}
		}

		function show_international_swipes_survey() {
			if (yalwa.v.language !== 'english') {
				return;
			}

			const swipes_count_threshold = 5;
			const international_swipes_count = parseInt(yalwa.basics.ss_get('international_swipes_count'));
		}

		return pub;

	}(pub.discover));

	const chats = (function(pub) {

		pub = pub || {};

		const FILTERS = {
			all: 'all',
			fav: 'favorites',
			unread: 'unread',
			unanswered: 'unanswered',
		};

		pub.init = function() {
			jQuery('.js-dol_go_discover').on('click', function() {
				jQuery('.js-htabs_item').filter('[data-sectionid="' + yalwa.v.VIEW_DISCOVER + '"]').trigger('click');
			});
			jQuery('.js-chat_search').off('keyup').on('keyup', function() {
				const name = jQuery(this).val();
				if (name.length > 0 && name.length < 3) {
					return;
				}
				yalwa.basics.debounce(() => {
					handle_chat_search(name);
				}, 500);
			});
			jQuery('.js-chat_filters').off('click').on('click', show_filters_menu);
			jQuery(".js-chat_filter_option").on('change', handle_filter_changes);
			prefill_search();
			preset_filter();
			jQuery('.js-chat_filtered_by').off('click').on('click', () => reset_filter());
		};

		function reset_filter(trigger = true) {
			const $default_filter = jQuery('.js-chat_filter_option[value="' + FILTERS.all + '"]');
			if (trigger) {
				$default_filter.trigger('click');
				return;
			}
			yalwa.basics.ls_remove('dol_chats_filter');
			jQuery('.js-chat_filter_option').prop('checked', false);
			$default_filter.prop('checked', true);
			update_filtered_by($default_filter.data('label'));
		}

		function prefill_search() {
			if (!has_set_search()) {
				return;
			}
			jQuery('.js-chat_search').val(yalwa.basics.get_get('query'));
		}

		function preset_filter() {
			const ls_dol_chats_filter = yalwa.basics.ls_get('dol_chats_filter', true);
			if (!ls_dol_chats_filter) {
				return;
			}
			for (const active_filter in ls_dol_chats_filter) {
				const $filtered_by = jQuery('.js-chat_filter_option[value="' + active_filter + '"]');
				jQuery('.js-chat_filter_option').prop('checked', false);
				$filtered_by.prop('checked', true);
				update_filtered_by($filtered_by.data('label'));
			}
		}

		function reset_search() {
			if (!has_set_search()) {
				return;
			}
			jQuery('.js-chat_search').val('');
			yalwa.basics.set_get({query: null});
		}

		function handle_filter_changes() {
			const filter_by = jQuery(this).val();
			let filter_label = jQuery(this).data('label');
			const ONE_DAY_IN_SECONDS = 86400;
			if (filter_by !== 'all') {
				yalwa.basics.ls_set('dol_chats_filter', {[filter_by]: true}, yalwa.basics.unix() + ONE_DAY_IN_SECONDS);
			} else {
				yalwa.basics.ls_remove('dol_chats_filter');
			}
			reset_search();
			hide_filters_menu(filter_label);
			yalwa.chat.reload_list(yalwa.chat.current_context()).done(pub.check_empty_chats_view);
		}

		function hide_filters_menu(filtered_by) {
			yalwa.mobile.generic_shadow.hide();
			const $filter_options = jQuery('.js-chat_filter_options');
			$filter_options.velocity('transition.slideDownBigIn', {duration: 150, display: ''});
			yalwa.basics.hide($filter_options);
			if (filtered_by) {
				update_filtered_by(filtered_by);
			}
		}

		function show_filters_menu() {
			yalwa.mobile.generic_shadow.show({zindex: 8, namespace: 'dialog', onclick: () => hide_filters_menu()});
			const $filter_options = jQuery('.js-chat_filter_options');
			$filter_options.velocity('transition.slideUpBigIn', {duration: 150, display: ''});
			yalwa.basics.show($filter_options);
		}

		function handle_chat_search(name) {
			yalwa.basics.set_get({query: name}, true);
			reset_filter(false);
			yalwa.chat.reload_list(yalwa.chat.current_context()).done(pub.check_empty_chats_view);
		}

		function has_set_filters() {
			const $filter_options = jQuery('.js-chat_filter_option');
			if (!$filter_options.length) {
				return false;
			}
			return $filter_options.filter(':checked').val() !== FILTERS.all;
		}

		function has_set_search() {
			return yalwa.basics.get_get('query') || jQuery('.js-chat_search').val() ? true : false;
		}

		function has_set_filters_or_search() {
			return has_set_filters() || has_set_search();
		}

		function update_filtered_by(label) {
			const show_or_hide = (jQuery('.js-chat_filter_option:checked').val() !== FILTERS.all) ? 'show' : 'hide';
			yalwa.basics[show_or_hide](jQuery('.js-chat_filtered_by'));
			jQuery('.js-chat_filtered_by_label').html(label);
		}

		function show_no_chat_results_for_filters_or_search() {
			if (has_set_search()) {
				yalwa.basics.hide(jQuery('.js-chat_no_results_favorites, .js-chat_no_results_generic'));
				yalwa.basics.show(jQuery('.js-chat_no_results_search'));
			} else { // filter is set then show respective no results elements
				if (jQuery('.js-chat_filter_option:checked').val() === 'favorites') {
					yalwa.basics.hide(jQuery('.js-chat_no_results_search, .js-chat_no_results_generic'));
					yalwa.basics.show(jQuery('.js-chat_no_results_favorites'));
				} else {
					yalwa.basics.hide(jQuery('.js-chat_no_results_favorites, .js-chat_no_results_search'));
					yalwa.basics.show(jQuery('.js-chat_no_results_generic'));
				}
			}
			yalwa.basics.show(jQuery('.js-chat_no_results'));
			jQuery('.js-chat_filter_reset').off('click').on('click', function() {
				reset_search();
				reset_filter();
			});
		}

		pub.refresh_list_on_using_fav_filters = function() {
			if (jQuery('.js-chat_filter_option:checked').val() === FILTERS.fav) {
				yalwa.chat.reload_list(yalwa.chat.current_context()).done(pub.check_empty_chats_view);
			}
		};

		pub.refresh_list_on_using_unread_unanswered_filters = function() {
			const current_filter = jQuery('.js-chat_filter_option:checked').val();
			if (current_filter === FILTERS.unread || current_filter === FILTERS.unanswered) {
				yalwa.chat.reload_list(yalwa.chat.current_context()).done(pub.check_empty_chats_view);
			}
		};

		pub.update_filtered_by = update_filtered_by;

		pub.get_profileID_mc = function() {
			return jQuery('.js-chat_instance').data('dol_profileid');
		};

		pub.check_empty_chats_view = function() {
			if (jQuery('.js-c_select').length) { // show chats
				// fix showing both list and chat view on same screen
				let sl_index = parseInt(yalwa.basics.get_get('sl_index')) || 0;
				let cID = yalwa.basics.get_get('cID');
				if (sl_index && cID && !jQuery('.js-c_select[data-conversationid="' + cID + '"]').length) {
					yalwa.basics.show(jQuery('.js-chat_append, .js-view_list, .js-chat_header'));
					yalwa.basics.hide(jQuery('.js-dol_chat_empty, .js-chat_no_results'));
				} else if (!sl_index && !cID && yalwa.basics.get_get('view') !== 'requests') { // requests means to show wow requests
					yalwa.basics.show(jQuery('.js-chat_append, .js-view_list, .js-chat_header'));
					yalwa.basics.hide(jQuery('.js-dol_chat_empty, .js-chat_no_results'));
				}
			} else if (has_set_filters_or_search() && parseInt(yalwa.v.matches_count)) { // show no filtered results view
				yalwa.basics.hide(jQuery('.js-chat_append, .js-view_list, .js-dol_chat_empty'));
				show_no_chat_results_for_filters_or_search();
			} else if (!parseInt(yalwa.v.matches_count)) { // show empty chats
				if (parseInt(yalwa.v.wows_received_count) || yalwa.v.has_liked_by_profiles) {
					yalwa.basics.show(jQuery('.js-chat_append, .js-chat_header'));
					yalwa.basics.hide(jQuery('.js-dol_chat_empty'));
				} else {
					yalwa.basics.hide(jQuery('.js-chat_append, .js-chat_header'));
					yalwa.basics.show(jQuery('.js-dol_chat_empty'));
				}
			}
		};

		pub.do_unmatch = function() {
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {
					action: 'unmatch',
					target_profileID: chats.get_profileID_mc(),
					conversationID: yalwa.chat.get_conversationID()
				}
			}).done(function(r) {
				yalwa.v.matches_count = r.match_count || yalwa.v.matches_count;
				yalwa.chat.after_unmatch(() => {
					chats.check_empty_chats_view();
				});
			});
		};

		function safari_do_not_change_inner_height_if_soft_keyboard_opened_fix() {
			if (typeof window.visualViewport === 'undefined' || !yalwa.v.is_ios) {
				return false;
			}
			let height_on_keyboard_opened,
				height_on_keyboard_closed;

			jQuery('.js-chat_answer').on('focusout', function(e) {
				jQuery('.js-add_extra_padding').css({'padding-bottom' : '15px'});
				setTimeout(function() {
					let height_on_keyboard_opened_fo = window.visualViewport.height;
					jQuery('.js-htab_section').each(function() {
						let header_height = jQuery('.js-htabs').closest('header').outerHeight();
						jQuery(this).css({height: height_on_keyboard_opened_fo - header_height});
						jQuery('html, body').height(height_on_keyboard_opened_fo);
					});
				}, 800);
			});

			jQuery('.js-chat_answer').on('focus', function(e) {
				jQuery('.js-add_extra_padding').css({'padding-bottom' : '0'});
				clearTimeout(yalwa.v.safari_keyboard_resize_to);
				yalwa.v.safari_keyboard_resize_to = setTimeout(function() {
					height_on_keyboard_opened = window.visualViewport.height;
					jQuery('.js-htab_section').each(function() {
						let header_height = jQuery('.js-htabs').closest('header').outerHeight();
						jQuery(this).css({height: height_on_keyboard_opened - header_height});
						jQuery('html, body').height(height_on_keyboard_opened);
					});
					jQuery(window).scrollTop(0);
					window.visualViewport.onscroll = function(e) {
						if (jQuery('html').scrollTop() > 0) {
							e.preventDefault();
							jQuery(window).scrollTop(0);
							return false;

						}
					};
					jQuery('.js-chat_instance').bind('touchstart', function(e) {
						window.ts = e.originalEvent.touches[0].clientY;
					});
					jQuery('.js-chat_instance').bind('touchmove', function(e) {
						var te = e.originalEvent.changedTouches[0].clientY;
						if (window.ts > te + 5) {
							// Down
							let $chat_instance = jQuery('.js-chat_instance');
							let scroll_end = $chat_instance[0].scrollHeight;
							let scroll_pos = $chat_instance.outerHeight() + $chat_instance.scrollTop();
							if (scroll_end === scroll_pos) {
								e.stopImmediatePropagation();
								e.stopPropagation();
								e.preventDefault();
								jQuery(window).scrollTop(0);
								return false;
							}
						}

						if (jQuery('html').scrollTop() > 0) {
							e.stopImmediatePropagation();
							e.stopPropagation();
							e.preventDefault();
							jQuery(window).scrollTop(0);
							return false;
						}
					});
					jQuery('html, body, .js-headroom_alternative, .js-mc_compose').bind('touchmove', function(e) {
						e.preventDefault();
						return false;
					});
				}, 1000);
			});
			jQuery('.js-chat_answer').on('blur', function(e) {
				clearTimeout(yalwa.v.safari_keyboard_resize_to);
				yalwa.v.safari_keyboard_resize_to = setTimeout(function() {
					height_on_keyboard_closed = window.visualViewport.height;
					jQuery('.js-htab_section').each(function() {
						let header_height = jQuery('.js-htabs').closest('header').outerHeight();
						jQuery(this).css({height: height_on_keyboard_closed - header_height});
						jQuery('html, body').height(height_on_keyboard_closed);
					});
					jQuery('.js-chat_details').unbind('touchmove');
					jQuery('html, body, .js-headroom_alternative, .js-mc_compose').unbind('touchmove');
				}, 400);
			});
		}

		function init_after_chat_view_prepared() {
			//initial
			helper.set_height_initial();
			jQuery(document).on('mc_chat_loading_finished', helper.set_height_initial);
			jQuery(document).on('mc_chat_loading_finished', discover.flag.mc_init());

			if (yalwa.v.is_ios) {
				safari_do_not_change_inner_height_if_soft_keyboard_opened_fix();
			} else {
				window.addEventListener('resize', function() {
					window.requestAnimationFrame(helper.set_height_initial);
				});
			}
			window.onpopstate = function() {
				upload.close_image_menu();
				upload.close_file_menu();
			};
		}

		pub.update_counter = function(event, show_it) {
			if (show_it) {
				jQuery('.js-dol_chats_counter').addClass('dol_counter');
			} else {
				jQuery('.js-dol_chats_counter').removeClass('dol_counter');
			}
		};

		pub.update_total_unread = function() {
			if (!jQuery('.js-c_select').length && jQuery('.js-menu_counter_mc').data('menu_count')) {
				chats.load();
			}
		};

		pub.check_unread_counter = function() {
			const matches_count = parseInt(yalwa.v.matches_count);
			if (!matches_count) {
				return;
			}
			jQuery.ajax({
				url: API_PATH_CHAT,
				dataType: 'json',
				type: 'post',
				data: {
					action: 'get_unread_counter',
					emailID: yalwa.v.emailID,
					is_dol: true,
				}
			}).done(function(response) {
				if (!isNaN(response)) {
					pub.update_counter(null, response);
				}
			});
		};

		pub.load = function(filters = {}, callback) {
			let load_data = {
				action: 'get_chats',
				is_dol: true,
				context: 'inbox',
				sl_index: yalwa.basics.get_get('sl_index'),
				cID: yalwa.basics.get_get('cID'),
				query: yalwa.basics.get_get('query'),
			};
			
			if (yalwa.basics.get_get('single_conversation')) {
				load_data.single_conversation = yalwa.basics.get_get('single_conversation')
			}

			if (jQuery.isEmptyObject(filters)) {
				filters = yalwa.basics.ls_get('dol_chats_filter', true) || filters;
			}

			load_data = jQuery.extend(load_data, filters);

			return jQuery.ajax({
				url: API_PATH_DOL,
				data: load_data,
				dataType: 'html',
				type: 'get'
			}).done((html) => {
				jQuery('.js-chat_append').css({
					'opacity': 0

				});
				jQuery('.js-chat_append').html(html);
				setTimeout(function() {
					jQuery('.js-chat_append').css({
						'transition': 'opacity 0.2s ease-out',
						'opacity': 1
					});
				}, 400);

				yalwa.mobile.check_for_detach();
				if (!jQuery.isEmptyObject(filters)) {
					jQuery('.js-chat_filter_option').prop('checked', false);
					jQuery.each(filters, function(filter) {
						const $filtered_by = jQuery('.js-chat_filter_option[value="' + filter + '"]');
						$filtered_by.prop('checked', true);
						update_filtered_by($filtered_by.data('label'));
					})
				}
				chats.check_empty_chats_view();
				if (typeof callback === 'function') {
					callback();
				}
			});
		};

		pub.load_chat_resources = function() {
			yalwa.basics.load_css(yalwa.basics.static_url('css') + 'dol/chat/all.css');
			var deferred = jQuery.Deferred();
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/jQuery.channel.js', () => {
				deferred.resolve();
			});
			yalwa.basics.load_dayjs().done(() => {
				deferred.promise().done(() => {
					yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/chat.js', () => {
						init_after_chat_view_prepared();
					});
				});
			});
		};

		return pub;

	}(pub.chats));

	const upload = (function(pub) {

		pub = pub || {};

		pub.initialized = false;

		let upload_counter = 0;
		let is_edit_profile;
		let is_image_editor_active = true;
		let min_image_size = 320;
		let is_doka_open = false;
		const imageMaxWidth = 1080;
		const imageMaxHeight = 1080;
		let total_selected_files = 0;
		let signup_flow = false;

		String.prototype.hashCode = function() {
			var hash = 0, i, chr;
			if (this.length === 0) {
				return hash;
			}
			for (i = 0; i < this.length; i++) {
				chr = this.charCodeAt(i);
				hash = ((hash << 5) - hash) + chr;
				hash |= 0; // Convert to 32bit integer
			}
			return hash;
		};
		
		
		pub.set_signup_flow = function (flow) {
			signup_flow = flow;
		}
		pub.get_signup_flow = function () {
			return signup_flow;
		}

		pub.init = function() {
			is_edit_profile = yalwa.basics.get_routing() === 'dol';
			if (yalwa.basics.is_dol_app() === 'dol_android' || (!yalwa.v.is_ios && yalwa.v.is_phonegap)) {
				is_image_editor_active = false;
			}
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/fileupload.js', function() {
				if (is_image_editor_active) {
					init_image_editor();
					jQuery('.js-dol_image_edit').on('click', edit_image_button_listener);
				} else {
					init_onload();
				}
				//in this case safari is very fast
				// we have to wait a while until the image editor and fileupload are fully initialized
				window.setTimeout(() => {
					$document.trigger('file_upload_init_done');
					pub.initialized = true;
					upload.activate_buttons();
				}, 141)
			});

			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/sortable.min.js', init_draggable_items);
		};

		pub.activate_buttons = function() {
			const $input_files = jQuery('.js-dol_file');
			const $deactivated_buttons = jQuery('.js-fileupload_wait');
			$deactivated_buttons.each(function() {
				jQuery(this).removeClass('js-fileupload_wait');
				yalwa.mobile.yli.stop(jQuery(this), true);
			});
			$input_files.each(function() {
				jQuery(this).prop('disabled', false);
			});

		}

		pub.get_counter = function() {
			return upload_counter;
		};

		pub.set_counter = function(value) {
			upload_counter = value;
		};

		pub.check_upload_counter = function() {
			if (!is_edit_profile) {
				if (upload_counter > 0) {
					jQuery('.js-dol_register_next').removeClass('invisible--slide_in');
				} else {
					jQuery('.js-dol_register_next').removeClass('invisible--slide_in');
				}
			}
			var $buttons = jQuery('.js-dol_upload_overview');
			yalwa.basics.hide($buttons);
			if (upload_counter < yalwa.v.max_profile_image) {
				yalwa.basics.show($buttons.eq(2));
				if (upload_counter % 3 !== 0) {
					yalwa.basics.show($buttons.eq(1));
				}
				if (upload_counter % 3 === 1) {
					yalwa.basics.show($buttons.eq(0));
				}
			}
		};

		pub.is_doka_open = function() {
			return is_doka_open;
		};

		function init_onload() {
			if (!is_image_editor_active) {
				jQuery('.js-dol_image_edit').remove();
			}
			let touchpoint = 'dol-profile';
			if (yalwa.dol_onboarding) {
				touchpoint = 'dol-profile-onboarding';
			}
			var config = jQuery.extend(yalwa.basics.upload_defaults(), {
				url: '/api/ajax/upload/',
				flow_type: signup_flow,
				formData: {
					touchpoint: touchpoint
				},
				imageMaxWidth: imageMaxWidth,
				imageMaxHeight: imageMaxHeight,
				autoUpload: false,
				// we'll disable image resizing, Doka can handle that
				//disableImageResize: true,
				previewMaxWidth: 100,
				previewMaxHeight: 100,
				previewCrop: true,
				process: [
					{
						action: 'load',
						fileTypes: /^image\/(gif|jpe?g|png)$/,
						maxFileSize: yalwa.basics.upload_max_file_size()
					},
					{
						action: 'resize',
						maxWidth: imageMaxWidth,
						maxHeight: imageMaxHeight
					},
					{
						action: 'save'
					}
				],
				add: upload_add,
				done: upload_done,
				fail: upload_fail,
				progress: upload_progress,
			});
			if (signup_flow !== 'native_ads') {
				jQuery('.js-dol_file').prop('multiple', true);
			}
			
			if (yalwa.v.is_phonegap && !yalwa.v.is_ios) {
				jQuery('.js-dol_file').width(1).height(1);
				jQuery('.js-dol_upload, .js-dol_upload_overview').on('click', function(e) {
					if (!jQuery(e.target).hasClass('js-dol_file')) {
						var $a = jQuery('.js-dol_upload_android');
						if ($a.length > 0 && $a.hasClass('hidden')) {
							yalwa.mobile.generic_shadow.show_queued({zindex: 8, onclick: upload.close_file_menu});
							yalwa.basics.show($a);
						} else {
							jQuery('.js-dol_file').eq(0).trigger('click');
							upload.close_file_menu();
						}
					}
				});
				jQuery('.js-dol_upload_android_option').on('click', function() {
					var $i = jQuery('.js-dol_file');
					$i.prop('accept', '').prop('accept', 'image/*');
					if (jQuery(this).data('type_append') === 'camera') {
						$i
							.prop('capture', true)
							.prop('multiple', false)
							.prop('cordova_camera', true);
					} else {
						$i
							.prop('cordova_camera', false)
							.attr('capture', null);
					}
					upload.close_file_menu();
					$i.eq(0).trigger('click');
				});
			} else {
				jQuery('.js-dol_upload_android').remove();
				jQuery('.js-dol_upload, .js-dol_upload_overview').on('click', function(e) {
					if (!jQuery(e.target).hasClass('js-dol_file')) {
						jQuery('.js-dol_file').eq(0).trigger('click');
					}
				});
			}
			jQuery('.js-dol_file').fileupload(config);
			jQuery('.js-dol_image_remove').on('click', dol_image_remove);
			jQuery("input:file").change(function () {
				total_selected_files = jQuery(this)[0].files.length;
			});
		}

		function upload_progress(e, data) {
			/*if (e.delegatedEvent.loaded && e.delegatedEvent.total) {
				const percent = e.delegatedEvent.loaded / e.delegatedEvent.total * 100;
				yalwa.mobile.yli.progress_percentage(jQuery(e.target).closest('.js-dol_upload_overview'), percent);
			}*/
			var id = data.files && data.files[0] && data.files[0].name ? data.files[0].name.hashCode() : 'single';
			if (!yalwa.basics.progress.is_started(id)) {
				yalwa.basics.progress.start(id, {
					container: jQuery('.js-headroom'),
					trickleRate: 0,
					// trickleSpeed: 0,
					// speed: 1,
					minimum: 0
				});
			}
			var progress = parseInt(data.loaded / data.total * 100, 10);
			yalwa.basics.progress.set(id, progress / 100);
		}

		function upload_add(e, data) {
			var acceptFileTypes = yalwa.basics.upload_type_regex();
			var file = data.files[0];
			var error = null;
			if (file.type !== undefined && !acceptFileTypes.test(file.type)) {
				error = yalwa.v.lang.dol_photo_format_error;
			}
			if (typeof (file.size) === 'number' && file.size > yalwa.basics.upload_max_file_size()) {
				error = yalwa.v.lang.file_upload_too_big;
			}

			if (upload_counter >= yalwa.v.max_profile_image && !data.edited_image_filename) {
				error = yalwa.v.lang.dol_photo_maximum_error;
			}
			if (error) {
				yalwa.dol.toast({message: error, type: 'error'});
				return;
			}
			yalwa.mobile.yli.start(jQuery('.js-dol_upload'), 'dol');
			yalwa.basics.hide(jQuery('.js-dol_upload_android'));
			var callback = function() {
				data.process(function() {
					return jQuery('.js-dol_file').fileupload('process', data);
				}).done(function() {
					data.submit();
				});
			};
			yalwa.basics.image_upload_dimensions(file).done(function(d) {
				if (d.w < min_image_size || d.h < min_image_size) {
					yalwa.dol.toast({
						message: yalwa.v.lang.dol_photo_resolution_error,
						type: 'error'
					});
					yalwa.mobile.yli.stop(jQuery('.js-dol_upload'), 'dol');
				} else {
					callback();
				}
			}).fail(callback);
		}

		function upload_done(e, data) {
			if (data.edited_image_filename) {
				update_edited_image_after_upload_done(e, data);
			} else {
				add_image_after_upload_done(e, data);
			}

		}

		function add_image_after_upload_done(e, data) {
			jQuery.each(data._response.result, function(index, f) {
				var file = f[0];
				if (file.error) {
					yalwa.dol.toast({message: file.error, type: 'error'});
					yalwa.mobile.yli.stop(jQuery('.js-dol_upload'), 'dol');
					return false;
				}
				if (upload_counter >= yalwa.v.max_profile_image) {
					yalwa.dol.toast({message: yalwa.v.lang.dol_photo_maximum_error, type: 'error'});
					return false;
				}

				var class_wrap = is_edit_profile ? 'dol_profile_edit__thumbnail' : 'dol_onboarding__thumbnail_wrap';
				var class_delete = is_edit_profile ? 'dol_profile_edit__thumbnail_delete' : 'dol_onboarding__thumbnail_delete';
				var class_image = is_edit_profile ? 'dol_profile_edit__image' : 'dol_onboarding__thumbnail';
				profile.save({action: 'image_add', name: file.name}, true).done(function(r) {
					if (data.flow_type && data.flow_type === 'native_ads') {
						load_native_ads_image(r);
						return;
					} else {
						load_saved_image(r, class_wrap, class_delete, class_image, true);
					}
				});
			});
		}

		pub.load_saved_image = load_saved_image;

		/**
		 * Reusable method between onboarding.js and main.js
		 * @param r
		 * @param class_wrap
		 * @param class_delete
		 * @param class_image
		 * @param from_profile_settings
		 */
		function load_saved_image(r, class_wrap, class_delete, class_image, from_profile_settings = true) {
			if (r.success) {
				$document.trigger('dol.upload_success');
				if (upload_counter > 0) {
					var $img = jQuery('<div class="dol_profile_edit__foto js-dol_foto js-sortable"><div class="js-dol_thumbnail ' + class_wrap + '" data-name="' + r.name + '"><div class="' + class_delete + '">' + yalwa.basics.yicon('edit', {
						folder: 'dol',
						pixel: 16
					}) + '</div><img class="' + class_image + '" src="' + r.url + '" /></div></div>');
				} else {
					var $img = jQuery('<div class="js-dol_thumbnail ' + class_wrap + '" data-name="' + r.name + '"><div class="' + class_delete + ' ' + yalwa.v.atd_add_more_photo_button + '">' + yalwa.basics.yicon('edit', {
						folder: 'dol',
						pixel: 16
					}) + '</div><img class="' + class_image + '" src="' + r.url + '" /></div>');
				}
				
			
				if (upload_counter === 0 && !is_edit_profile) {
					if (from_profile_settings) {
						if(total_selected_files === 1 || (yalwa.basics.is_dol_app() === 'dol_android' || (yalwa.basics.is_app() && yalwa.basics.is_dol_app() !== 'dol_ios') )) {
							yalwa.dol_onboarding.skip_foto_overview();
						} else {
							//Go to next (foto overiew)
							var $n = yalwa.dol_onboarding.get_next().addClass('js-s_active s_active');
							yalwa.dol_onboarding.init_subsection($n.data('step'));
							yalwa.dol_onboarding.update_url($n.data('step'));
						}
					}
					jQuery('.js-dol_fotos_first').html($img);
				} else {
					jQuery('.js-dol_upload_overview').first().before($img);
				}
				
				upload_counter++;
				pub.check_upload_counter();
				destroy_draggable_items();

				if (from_profile_settings) {
					init_draggable_items();
				}
				if (yalwa.v.profile_picture_change_forced) {
					profile.save({action: 'image_move_to_top', name: r.name}, true)
				}
				// When profile status is updated on adding new image, reload but not on onboarding flow
				if (r.hasOwnProperty('status') && r.status !== null && yalwa.v.dol_profile_status !== r.status.toString() && jQuery('.js-dol_onboarding').length < 1) {
					yalwa.basics.reload();
				}
				//track image uploaded successfully
				if (yalwa.v.reffer_view_photo_duel) {
					//Track now
					const config = {
						'uploaders_gender': yalwa.v.gender,
						'userstatus': yalwa.v.dol_profile_status
					};
					yalwa.basics.datalayer_push({event: 'photo_duel_upload', data: config});
					yalwa.v.reffer_view_photo_duel = false;
				}
			} else {
				if (upload_counter === 0 && !is_edit_profile) {
					yalwa.mobile.yli.stop(jQuery('.js-dol_upload'), 'dol');
				}
				yalwa.dol.toast({message: r.message, type: 'error'});
			}
		}
		
		function load_native_ads_image(r) {
			if (r.success) {
				//Show the image and take user to next step
				
				//Hide the add element
				yalwa.basics.hide(jQuery('.js-add_image'));
				
				//show edit element
				jQuery('.js-edit_image img').attr('src', r.url);
				jQuery('.js-edit_image').attr('data-name', r.name);
				yalwa.basics.show(jQuery('.js-edit_image'));
				
				//convert add button to next button
				if (yalwa.v.context === 'frozen' && yalwa.v.ref === 'loc') {
					// Take user to next step
					yalwa.dol_signup.update_step('upload-photo');
					yalwa.dol_signup.next();
					
				} else if (yalwa.v.context === 'frozen') {
					const discover_url = yalwa.dol.build_url(yalwa.v.VIEW_DISCOVER);
					const redirect_url = discover_url + '?naplp=1&context=frozen&pid=' + yalwa.basics.get_get('pid');
					// record a like when user came via wow icon
					if (yalwa.basics.ss_get('frozen_free_wow_ref') === 'wow_icon') {
						jQuery.ajax({
							url: API_PATH_DOL,
							dataType: 'json',
							type: 'get',
							data: {
								action: 'log_reaction',
								type: 'like',
								target_profileID: yalwa.basics.get_get('pid')
							}
						}).done(function(r) {
							if (r.success) {
								yalwa.basics.navigate(redirect_url);
							}
						});
					} else {
						yalwa.basics.navigate(redirect_url);
					}
				} else {
					yalwa.dol_signup.update_step('upload-photo');
					yalwa.dol_signup.next();
				}
			} else {
				if (upload_counter === 0) {
					yalwa.mobile.yli.stop(jQuery('.js-dol_upload'), 'dol');
				}
				yalwa.dol.toast({message: r.message, type: 'error'});
			}
		}

		function destroy_draggable_items() {
			if (pub.sort) {
				pub.sort.destroy();
			}
		}

		function update_edited_image_after_upload_done(e, data) {
			let flow_type = data.flow_type;
			let file = data._response.result.img_upload[0];
			let images_array = jQuery('.js-dol_thumbnail').map(function() {
				return jQuery(this).attr('data-name');
			}).get();
			profile.save({
				action: 'image_replace',
				add: file.name,
				delete: data.edited_image_filename,
				images_order: images_array
			}, true).done(function(r) {
				if (r.success) {
					
					if (flow_type === 'native_ads') {
						jQuery('.js-dol_edit_image_cta').attr('data-name', r.add.name);
						jQuery('.js-dol_image_options').attr('data-name', r.add.name)
						jQuery('.js-dol_edit_image_cta img').attr('src', r.add.url)
						return false;
					}
					let changed_image = jQuery(jQuery('.js-dol_thumbnail')[r.images_order.changed_image_key]);
					changed_image.attr('data-name', r.add.name);
					changed_image.find('img').attr('src', r.add.url);
				} else {
					if (upload_counter === 0 && !is_edit_profile) {
						yalwa.mobile.yli.stop(jQuery('.js-dol_upload'), 'dol');
					}
					yalwa.dol.toast({message: r.message, type: 'error'});
				}
			});
		}

		function upload_fail() {
			yalwa.dol.toast({message: yalwa.v.lang.an_error_occurred, type: 'error'});
		}

		function init_draggable_items() {
			let element = jQuery('.js-dol_fotos')[0];
			if (!element) {
				return;
			}
			
			// fix drag/drop for more toggle pics hidden under `show more/less`
			const $more_toggle_pics = jQuery('.js-toggle_fotos')[0];
			if ($more_toggle_pics) {
				Sortable.create($more_toggle_pics, {
					group: 'profile_pics',
					draggable: '.js-sortable',
					filter: '.js-dol_upload_overview',
					swap: true,
					delay: 141,
					touchStartThreshold: 5,
					// Called when dragging element changes position
					onEnd: function(/**Event*/event) {
						upload.image_sort_save();
						if (event.newIndex === 0 || event.oldIndex === 0) {
							jQuery('.js-dol_fotos_first').removeClass('dol_onboarding__foto_first dol_profile_edit__foto_first js-dol_fotos_first').addClass('js-dol_foto dol_profile_edit__foto');
							jQuery(jQuery('.js-dol_foto')[0]).addClass('dol_onboarding__foto_first  dol_profile_edit__foto_first js-dol_fotos_first').removeClass('js-dol_foto dol_profile_edit__foto');
						}
						yalwa.basics.ga.event({
							category: 'drag_drop_profile_pics',
							action: 'used_drag_drop',
						});
					},
					// Event when you move an item in the list or between lists
					onMove: function (/**Event*/evt, /**Event*/originalEvent) {
						// when an image is dropped into the main picture
						let $drop = evt.related;
						if ($drop) {
							$drop = jQuery($drop);
							const $main_image_wrap  = $drop.closest('.js-dol_fotos_first');
							if ($main_image_wrap.length) {
								const $dragged_pic = jQuery(evt.dragged);
								if ($dragged_pic.length) {
									const shows_person_pic = $dragged_pic.find('.js-dol_thumbnail').data('shows-face');
									if (!shows_person_pic) {
										return false;
									}
								}
							}
						}
						
						// when a main image is dropped into more images section
						let $drag =  evt.dragged;
						if ($drag) {
							$drag = jQuery($drag);
							const $main_image_wrap  = $drag.closest('.js-dol_fotos_first');
							if ($main_image_wrap.length) {
								const $drop_pic = jQuery(evt.related);
								if ($drop_pic.length) {
									const shows_person_pic = $drop_pic.find('.js-dol_thumbnail').data('shows-face');
									if (!shows_person_pic) {
										return false;
									}
								}
							}
						}
					}
				});
			}
			
			pub.sort = Sortable.create(element, {
				group: 'profile_pics',
				draggable: '.js-sortable',
				filter: '.js-dol_upload_overview',
				swap: true,
				delay: 141,
				touchStartThreshold: 5,
				// Called when dragging element changes position
				onEnd: function(/**Event*/event) {
					upload.image_sort_save();
					if (event.newIndex === 0 || event.oldIndex === 0) {
						jQuery('.js-dol_fotos_first').removeClass('dol_onboarding__foto_first dol_profile_edit__foto_first js-dol_fotos_first').addClass('js-dol_foto dol_profile_edit__foto');
						jQuery(jQuery('.js-dol_foto')[0]).addClass('dol_onboarding__foto_first  dol_profile_edit__foto_first js-dol_fotos_first').removeClass('js-dol_foto dol_profile_edit__foto');
					}
					yalwa.basics.ga.event({
						category: 'drag_drop_profile_pics',
						action: 'used_drag_drop',
					});
				},
				// Event when you move an item in the list or between lists
				onMove: function (/**Event*/evt, /**Event*/originalEvent) {
					// when an image is dropped into the main picture
					let $drop = evt.related;
					if ($drop) {
						$drop = jQuery($drop);
						const $main_image_wrap  = $drop.closest('.js-dol_fotos_first');
						if ($main_image_wrap.length) {1
							const $dragged_pic = jQuery(evt.dragged);
							if ($dragged_pic.length) {
								const shows_person_pic = $dragged_pic.find('.js-dol_thumbnail').data('shows-face');1
								if (!shows_person_pic) {
									return false;
								}
							}
						}
					}
					
					// when a main image is dropped into more images section
					let $drag =  evt.dragged;
					if ($drag) {
						$drag = jQuery($drag);
						const $main_image_wrap  = $drag.closest('.js-dol_fotos_first');
						if ($main_image_wrap.length) {
							const $drop_pic = jQuery(evt.related);
							if ($drop_pic.length) {
								const shows_person_pic = $drop_pic.find('.js-dol_thumbnail').data('shows-face');
								if (!shows_person_pic) {
									return false;
								}
							}
						}
					}
				}
			});
		}

		pub.image_sort_save = function() {
			let images_array = jQuery('.js-dol_thumbnail').map(function() {
				return jQuery(this).attr('data-name');
			}).get();
			var data = {action: 'image_sort', 'images': images_array};
			profile.save(data, true);
		};

		function edit_image_button_listener(e) {
			pub.close_image_menu();
			let image_name = jQuery('.js-dol_image_options').attr('data-name');
			if (image_name === undefined) {
				return;
			}
			init_image_editor_edit(image_name);
		}

		function use_doka_with_jqueryfileupload(Doka, options) {

			// Create a default Doka editor
			var doka = Doka.create(options);

			// add Doka processor to queue
			$.blueimp.fileupload.prototype.options.processQueue.push({action: 'doka'});

			// Define Doka file processor
			$.widget('blueimp.fileupload', $.blueimp.fileupload, {
				processActions: {
					doka: function(data) {
						var dfd = $.Deferred();
						var file = data.files[data.index];
						var _this = this;
						doka.edit(file).then(function(output) {

							// no output
							if (!output) {
								file.error = 'Not edited';
								data.files.error = true;
								dfd.rejectWith(this, [data]);
								return;
							}

							// no thumbnail needed?
							if (!data.previewThumbnail) {
								data.files[data.index] = output.file;
								return dfd.resolveWith(_this, [data]);
							}

							// create new thumbnail
							var image = new Image();
							image.onload = function() {

								var x = 0;
								var y = 0;
								var width = image.width;
								var height = image.height;
								var previewWidth = data.previewMaxWidth;
								var previewHeight = data.previewMaxHeight;
								var scalar = Math.min(previewWidth / width, previewHeight / height);

								if (data.previewCrop) {

									var previewAspectRatio = previewHeight / previewWidth
									var imageAspectRatio = height / width;

									if (previewAspectRatio < imageAspectRatio) {
										y = (height - width) * .5;
										height = width;
									} else if (previewAspectRatio > imageAspectRatio) {
										x = (width - height) * .5;
										width = height;
									}
								} else {
									previewWidth = width * scalar;
									previewHeight = height * scalar;
								}

								var preview = document.createElement('canvas');
								preview.width = previewWidth;
								preview.height = previewHeight;
								var ctx = preview.getContext('2d');
								ctx.drawImage(image,
									x, y, width, height,
									0, 0, previewWidth, previewHeight
								);

								output.file.preview = preview;
								data.files[data.index] = output.file;
								return dfd.resolveWith(_this, [data]);
							}

							// start loading the outputted image
							image.src = URL.createObjectURL(output.file);
						}).catch(e => {
							doka.close();
							file.error = 'Not edited';
							data.files.error = true;
							dfd.rejectWith(this, [data]);
							return;
						});

						return dfd.promise();
					}
				}
			});
		};

		let is_first_image = true;

		function init_image_editor() {
			
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/doka/doka.min.js', function() {
				yalwa.basics.load_css(yalwa.basics.static_url('js') + 'external/doka/doka.min.css', null);
				// Link up Doka and jQuery File Upload
				if (typeof (Doka) !== 'undefined') { // not defined when doka is not supporting this browser
					let aspect = 583 / 415;
					use_doka_with_jqueryfileupload(Doka, {
						utils: ['crop', 'filter', 'color'],
						cropMinImageWidth: min_image_size,
						cropMinImageHeight: min_image_size,
						cropAspectRatio: aspect,
						cropAllowResizeRect: false,
						cropShowSize: true,
						labelButtonReset: yalwa.v.lang.photo_editor_reset,
						labelButtonCancel: yalwa.v.lang.photo_editor_cancel,
						labelButtonConfirm: yalwa.v.lang.photo_editor_confirm,
						labelButtonUtilCrop: yalwa.v.lang.photo_editor_crop,
						labelButtonUtilResize: yalwa.v.lang.photo_editor_resize,
						labelButtonUtilFilter: yalwa.v.lang.photo_editor_filter,
						labelButtonUtilColor: yalwa.v.lang.photo_editor_color,
						labelStatusMissingWebGL: yalwa.v.lang.photo_editor_status_missing_webgl,
						labelStatusAwaitingImage: yalwa.v.lang.photo_editor_status_awaiting_image,
						labelStatusLoadImageError: yalwa.v.lang.photo_editor_status_load_image_error,
						labelStatusLoadingImage: yalwa.v.lang.photo_editor_loading_image,
						labelStatusProcessingImage: yalwa.v.lang.photo_editor_processing_image,
						oncancel: () => {
							yalwa.mobile.yli.stop(jQuery('.js-dol_upload'), 'dol');
						},
						onclose: () => {
							is_doka_open = false;
						},
						onload: (img) => {
							if (yalwa.basics.get_routing() === 'dol_onboarding') {
								yalwa.dol_onboarding.update_url('doka');
								if (is_first_image) {
									yalwa.dol_onboarding.gtm_push({
										'event': 'onboarding_photo_uploaded',
									});
									is_first_image = false;
								}
							}
							is_doka_open = true;
						},
						onloaderror: (error) => {
							switch (error.status) {
								case 'IMAGE_MIN_SIZE_VALIDATION_ERROR':
									yalwa.dol.toast({
										message: yalwa.v.lang.dol_photo_resolution_error,
										type: 'error'
									});
									break;
							}
						}
					});
				}
				init_onload();
			})
		}

		function init_image_editor_edit(image_name) {
			let image_url = '/api/ajax/dol?emailID=' + yalwa.v.emailID + '&is_dol=true&action=image_edit_get&name=' + image_name + '&dim=' + yalwa.v.dim;
			var image = new Image();
			var onload = function() {
				var canvas = document.createElement("canvas");
				canvas.width = this.width;
				canvas.height = this.height;
				canvas.id = image;
				var ctx = canvas.getContext("2d");
				ctx.drawImage(this, 0, 0);
				canvas.toBlob(function(blob) {
					//- Removed this line due to image add issue in IOS
					jQuery(jQuery('.js-dol_upload_overview')[0]).find('.js-dol_file').fileupload('add', {
						edited_image_filename: image_name,
						files: blob
					});
				}, 'image/jpeg');
			};
			image.onload = onload;
			image.src = image_url;
		}

		function dol_image_remove() {
			pub.close_image_menu();
			// if (jQuery('.js-dol_thumbnail').length <= 1) {
			// 	yalwa.dol.toast({message: yalwa.v.lang.dol_delete_picture_error, type: 'error'});
			// 	return;
			// }
			var name = jQuery('.js-dol_image_options').attr('data-name');
			profile.save({action: 'image_remove', name: name}, true).done(function(r) {
				if (r.success == true && r.is_deleted == true) {
					if (signup_flow === 'native_ads') {
						yalwa.basics.hide(jQuery('.js-edit_image'));
						yalwa.basics.show(jQuery('.js-add_image'));
						return;
					}
					let $thumbnail = jQuery('.js-dol_thumbnail');
					var $to_remove = $thumbnail.filter('[data-name="' + name + '"]');
					if ($to_remove.closest('.js-dol_fotos_first').length) {
						let foto_wrapper = $thumbnail.eq(1).closest('.js-dol_foto');
						$thumbnail.eq(1).detach().appendTo(jQuery('.js-dol_fotos_first'));
						foto_wrapper.remove();
					} else {

						$to_remove = jQuery('.js-dol_thumbnail').filter('[data-name="' + name + '"]').closest('.js-dol_foto');
					}
					$to_remove.remove();
					upload_counter--;
					upload.check_upload_counter();
					if (!jQuery('.js-dol_onboarding').length) {
						pub.show_max_4_images();
					}
					if (upload_counter === 0 && jQuery('.js-dol_onboarding').length > 0) {
						$window.off('beforeunload');
						jQuery('body').off('beforeunload');
						yalwa.basics.reload();
					}
				} else if (r.success == true && r.is_deleted == false) {
					//Show Error Message, that image cannot be deleted
					jQuery('.js-show_image_remove_error').trigger('plp_show', [{is_queued: true}]);
					//yalwa.mobile.generic_shadow.show_queued();
				} else {
					yalwa.dol.toast({message: yalwa.v.lang.an_error_occurred, type: 'error'});
				}
			});
		}

		pub.show_max_4_images = function() {
			const $show_more = jQuery('.js-show_more_fotos');
			const $show_less = jQuery('.js-show_less_fotos');
			const $toggle_fotos = jQuery('.js-toggle_fotos');
			if (jQuery('.js-dol_thumbnail').length <= 4) {
				if ($show_more.length) {
					yalwa.basics.hide($show_more);
				}
				if ($show_less.length) {
					yalwa.basics.hide($show_less);
				}
				if ($toggle_fotos.length) {
					if ($toggle_fotos.children().length) {
						jQuery('.js-show_more_fotos').before($toggle_fotos.children());
					}
				}
				return;
			}

			if (jQuery('.js-dol_thumbnail').length > 4) {
				if ($show_more.length) {
					// deleted photo is not from the first 3 items
					if (jQuery('.js-dol_fotos > .js-dol_foto').length === 3) {
						return;
					}
					const $first_foto_in_toggle = jQuery('.js-toggle_fotos .js-dol_foto').first();
					jQuery('.js-show_more_fotos').before($first_foto_in_toggle);
					return;
				}
				const show_more = `<div class="dol_profile_edit__show_more_fotos js-show_more_fotos">
						<div>${yalwa.v.lang.dol_show_photos}</div>
					</div>`;
				jQuery('.js-dol_foto').eq(2).after(show_more);

				const to_be_hidden_section = jQuery('.js-show_more_fotos').nextAll().filter(function() {
					return jQuery(this).hasClass('js-dol_foto') || jQuery(this).hasClass('js-dol_upload_overview');
				});

				jQuery(to_be_hidden_section).wrapAll('<div class="dol_profile_edit__toggle_fotos js-toggle_fotos hidden"></div>')

				const show_less = `<div class="dol_profile_edit__show_less_fotos js-show_less_fotos hidden">
                        <div>${yalwa.v.lang.dol_photos_show_less}</div>
                    </div>`;
				jQuery('.js-toggle_fotos').after(show_less);
			}
		};
		
		pub.close_image_menu = function() {
			if (jQuery('.js-dol_image_options').hasClass('hidden')) {
				return;
			}
			yalwa.mobile.generic_shadow.hide_queued();
			yalwa.basics.hide(jQuery('.js-dol_image_options'));
			jQuery('.dol_onboarding__thumbnail--active').removeClass('dol_onboarding__thumbnail--active');
		};

		pub.close_file_menu = function() {
			if (jQuery('.js-dol_upload_android').hasClass('hidden')) {
				return;
			}
			yalwa.basics.hide(jQuery('.js-dol_upload_android'));
			yalwa.mobile.generic_shadow.hide();
		};

		return pub;

	}(pub.upload));

	const hashtags = (function(pub) {

		pub = pub || {};

		var hashtag_initialized = false;
		let $hashtags_htabs;

		pub.init = function() {
			$hashtags_htabs = jQuery('.js-htabs_item_htag')
			jQuery('.js-hashtags_info_button').on('click', info_button_click_handler);
			jQuery('.js-dol_hashtag_search_input').one('focus', autocomplete_callback);
			jQuery('.js-dol_browse_search_hashtag').one('focus', autocomplete_callback_browse_search_hashtag);
			if (hashtag_initialized) {
				return;
			}

			$hashtags_htabs.each(function() {
				if (!jQuery('.js-htab_section[data-htabs_sectionid="' + jQuery(this).data('sectionid') + '"]').find('.js-hashtag_item').length) {
					jQuery(this).remove();
				}
			});

			hashtag_initialized = true;
			if (yalwa.basics.is_logged_in()) { // = dont do it in onboarding
				get_user_hashtag().then((response) => {
					if (response) {
						let hashtag_data = response.data;
						let category_id_data = response.category_ids;
						jQuery.each(hashtag_data, function(key, raw_hashtag_text) {
							append_selected_hashtag(key, '#' + raw_hashtag_text, category_id_data[key]);
							view_hashtag_as_selected(key);
							remove_popular_hashtag(key);
						});
						pub.update_selected_hashtags_count();
					}
				});
			}

			jQuery('.js-hashtag_item').on('click', function() {
				const $container = jQuery(this).closest('.js-grouped_hashtags');
				if ($container.hasClass('js-in_progress')) {
					return;
				}
				$container.addClass('js-in_progress');
				let hashtag_id = jQuery(this).attr('data-hashtag-id');
				let hashtag_cat_id = jQuery(this).attr('data-hashtag-cat_id');
				let hashtag_text = jQuery(this).html();
				const is_personality_hashtag = !!jQuery(this).data('is-personality');

				// handling clicking on already selected hashtag
				if (jQuery(this).hasClass('js-hashtag_item_selected')) {
					jQuery('.js-dol_hashtag_selected').find('[data-hashtag-id="' + hashtag_id + '"]').trigger('click');
					$container.removeClass('js-in_progress');
					return;
				}

				get_user_hashtag_count().then((response) => {
					if (response.success === true && response.total_hashtag >= parseInt(yalwa.v.MAX_HASHTAGS)) {
						yalwa.dol.toast({message: yalwa.v.lang.dol_hashtags_own_limit, type: 'error'});
						$container.removeClass('js-in_progress');
					} else {
						profile.after_changes_saved();
						set_user_hashtag(hashtag_id).then((response) => {
							if (response.success === true) {
								append_selected_hashtag(hashtag_id, hashtag_text, hashtag_cat_id);
								remove_popular_hashtag(hashtag_id);
								view_hashtag_as_selected(hashtag_id);
								pub.change_selected_hashtags_sub_title_body();
								pub.update_selected_hashtags_count();

								yalwa.basics.hide(jQuery('.js-dol_hashtag_tabbar_skip'));
								yalwa.basics.show(jQuery('.js-dol_hashtag_tabbar_done'));

								// personality hashtags promo conversion tracking checks
								if (is_personality_hashtag && yalwa.basics.ls_get('clicked_personality_hashtag_promo_cta')) {
									yalwa.basics.ga.event({
										category: 'personality_hashtags_promo',
										action: 'added_personality_hashtags',
									});
									// remove to avoid multiple tracking for a user
									yalwa.basics.ls_remove('clicked_personality_hashtag_promo_cta');
								}

								// tracking from cool_down
								if (yalwa.basics.ss_get('track_cool_down')) {
									yalwa.basics.ga.event({
										category: 'cool_down',
										action: 'Hashtag_cool_down_success'
									});
									// to avoid multiple tracking
									yalwa.basics.ss_remove('track_cool_down')
								}
							}
							$container.removeClass('js-in_progress');
						});
					}
				});
			});

			init_deleting_hashtags();
		};

		function init_deleting_hashtags() {
			let hashtag_selected_element = jQuery('.js-dol_hashtag_selected');
			hashtag_selected_element.on('click', '.js-dol_hashtag_selected_item', function() {
				let hashtag_id = jQuery(this).attr('data-hashtag-id');
				let hashtag_text = jQuery(this).html();
				delete_user_hashtag(hashtag_id).then((response) => {
					if (response.success === true) {
						profile.after_changes_saved();
						append_popular__hashtag(hashtag_id, hashtag_text);
						remove_selected_hashtag(hashtag_id);
						view_hashtag_as_unselected(hashtag_id);
						pub.change_selected_hashtags_sub_title_body();
						pub.update_selected_hashtags_count();
						remove_sexual_hashtag(hashtag_id);
						remove_pleasure_category();
						$document.trigger('hashtag_deleted');
					}
				});
			});
		}

		function autocomplete_callback_browse_search_hashtag() {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/jquery.autocomplete.js', function() {
				jQuery('.js-dol_browse_search_hashtag').autocomplete({
					serviceUrl: API_PATH_DOL,
					minChars: 2,
					zIndex: 5,
					paramName: 'term',
					params: {
						action: 'hashtag_search_autocomplete',
						countryID: yalwa.v.countryID,
						swipe_view: true
					},
					deferRequestBy: 200,
					orientation: 'auto',
					showNoSuggestionNotice: true,
					noSuggestionNotice: yalwa.v.lang.dol_no_match_found,
					beforeRender: function(container, suggestions) {
						jQuery(container).addClass('autocomplete-suggestions--hashtags');
					},
					onSelect: function(suggestion) {
						let hashtag_id = suggestion.data;
						if (hashtag_id === '') {
							jQuery('.js-dol_browse_search_hashtag').val('');
							return false;
						}
						let hashtag_text = suggestion.value.replace('#', '');
						const hashtag_cat_id = suggestion.category_id;
						if (jQuery('.js-dol_selected_hashtag_item').length === 3) {
							yalwa.dol.toast({
								message: yalwa.v.lang.dol_hashtags_partner_search_limit,
								type: 'error'
							});
							jQuery('.js-dol_browse_search_hashtag').autocomplete('clear');
						} else {
							if (!jQuery('.js-selected_hashtag').find("[data-hashtag-id='" + hashtag_id + "']").length) {
								const append_html = `<div class="dol_browse_filters__selected_hashtag_item
									js-dol_selected_hashtag_item hitbox_before dol_hashtag_category_${hashtag_cat_id}"
									data-hashtag-id ="${hashtag_id}"
									data-hashtag-text="${hashtag_text}">#${hashtag_text}</div>`;
								jQuery('.js-selected_hashtag').append(append_html);
								jQuery('.js-dol_browse_filters__popular_hashtag').find("[data-hashtag-id='" + hashtag_id + "']").remove();
								discover.append_hashtag_to_filter_overview(hashtag_id, hashtag_text, hashtag_cat_id);
							}
							jQuery('.js-dol_browse_search_hashtag').val('');
						}
					},
					onClick: function() {
						return;
					}
				});
			});
		}

		function autocomplete_callback() {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/jquery.autocomplete.js', function() {
				jQuery('.js-dol_hashtag_search_input').autocomplete({
					serviceUrl: API_PATH_DOL,
					minChars: 2,
					zIndex: 5,
					paramName: 'term',
					params: {
						action: 'hashtag_search_autocomplete',
						countryID: yalwa.v.countryID,
						swipe_view: false
					},
					appendTo: '.js-hashtag_suggestion',
					orientation: 'auto',
					showNoSuggestionNotice: true,
					noSuggestionNotice: yalwa.v.lang.dol_no_match_found,
					triggerSelectOnValidInput: false,
					tabDisabled: true,
					beforeRender: function(container, suggestions) {
						jQuery(container).addClass('autocomplete-suggestions--hashtags');
					},
					onSelect: function(suggestion) {
						let hashtag_id = suggestion.data;
						let hashtag_text = suggestion.value;
						let hashtag_category_id = suggestion.category_id;
						get_user_hashtag_count().then((response) => {
							if (response.success === true && response.total_hashtag >= parseInt(yalwa.v.MAX_HASHTAGS)) {
								yalwa.dol.toast({
									message: yalwa.v.lang.dol_hashtags_own_limit,
									type: 'error'
								});
								// to fix the no match found issue https://app.clubhouse.io/yalwa/story/2407/
								jQuery('.js-dol_hashtag_search_input').autocomplete('clear');
							} else {
								set_user_hashtag(hashtag_id).then((response) => {
									if (response.success === true) {
										if (jQuery('.js-dol_hashtag_selected').find("[data-hashtag-id='" + hashtag_id + "']").length === 0) {
											append_selected_hashtag(hashtag_id, hashtag_text, hashtag_category_id);
											view_hashtag_as_selected(hashtag_id);
											pub.change_selected_hashtags_sub_title_body();
											pub.update_selected_hashtags_count();
										}
										jQuery(this).val('');
										yalwa.basics.hide(jQuery('.js-dol_hashtag_tabbar_skip'));
										yalwa.basics.show(jQuery('.js-dol_hashtag_tabbar_done'));
									}
								});
							}
						});
					}
				});
			});
		}

		pub.append_selected_hashtag = append_selected_hashtag;
		function append_selected_hashtag(hashtag_id, value, category_id = 0) {
			let selected_hashtag_element = jQuery('.js-dol_hashtag_selected');
			let category_id_class = 'dol_hashtag_category_' + category_id;
			const html = `<div class="dol_hashtag_edit__selected_item js-dol_hashtag_selected_item ${category_id_class}"
				data-hashtag-id="${hashtag_id}"
				data-category-id="${category_id}">${value}</div>`;
			jQuery(html).appendTo(selected_hashtag_element).fadeIn('slow');
		}

		function remove_selected_hashtag(hashtag_id) {
			let selected_hashtag_element = jQuery('.js-dol_hashtag_selected');
			selected_hashtag_element.find("[data-hashtag-id='" + hashtag_id + "']").remove();
		}

		function remove_sexual_hashtag(id) {
			const $hashtags_container = jQuery('.js-grouped_hashtags');
			const $hashtag_item = $hashtags_container.find("[data-hashtag-id='" + id + "']");
			const $containerID = $hashtag_item.closest('.js-htab_section').data('htabs_sectionid');
			if ($hashtag_item.data('sexual-hashtag')) {
				$hashtag_item.remove();
				// remove this hashtag from hashtag filter popular hashtags
				const $popular_hashtag = jQuery('.js-dol_browse_popular_hashtag_item[data-hashtag-id="' + id + '"]')
				if ($popular_hashtag.length) {
					$popular_hashtag.remove();
				}
				if (!jQuery('.js-htab_section[data-htabs_sectionid="' + $containerID + '"]').find('.js-hashtag_item').length) {
					jQuery('.js-htabs_item_htag[data-sectionid="' + $containerID + '"]').remove();
				}
			}
		}

		function remove_pleasure_category() {
			const $hashtags_container = jQuery('.js-grouped_hashtags');
			const $pleasure_hashtags = $hashtags_container.find('[data-sexual-hashtag="true"]')
				.filter('[data-hashtag-pleasure="true"]');
			if (!$pleasure_hashtags.length) {
				const $hashtags_htabs = jQuery('.js-htabs.htabs_dol_hashtags').find('.js-htabs_item_htag');
				$hashtags_htabs.each(function() {
					if (jQuery(this).data("retired-category")) {
						// remove retired categoiries horizontal tab
						jQuery(this).remove();
						if (jQuery(this).hasClass('htabs__item--chosen_hashtag')) {
							// make the first category as selected when previously selected htab was retired
							$hashtags_htabs.first().trigger('click');
						}
					}
				});
			}
		}

		function view_hashtag_as_unselected(hashtag_id) {
			const $hashtags_container = jQuery('.js-grouped_hashtags');
			const $hashtag_item = $hashtags_container.find("[data-hashtag-id='" + hashtag_id + "']");
			$hashtag_item.removeClass('grouped_hashtags--item_selected js-hashtag_item_selected');
		}

		function append_popular__hashtag(hashtag_id, value) {
			let popular_hashtag_element = jQuery('.js-dol_popular_hashtag');
			yalwa.basics.show(popular_hashtag_element.find("[data-hashtag-id='" + hashtag_id + "']"));
		}

		function remove_popular_hashtag(hashtag_id) {
			let $popular_hashtag_element_container = jQuery('.js-dol_popular_hashtag');
			let $popular_hashtag_element = $popular_hashtag_element_container.find("[data-hashtag-id='" + hashtag_id + "']");
			yalwa.basics.hide($popular_hashtag_element);
		}

		pub.view_hashtag_as_selected = view_hashtag_as_selected;
		function view_hashtag_as_selected(hashtag_id) {
			const $hashtags_container = jQuery('.js-grouped_hashtags');
			const $hashtag_item = $hashtags_container.find("[data-hashtag-id='" + hashtag_id + "']");
			$hashtag_item.addClass('grouped_hashtags--item_selected js-hashtag_item_selected');
		}

		pub.change_selected_hashtags_sub_title_body = () => {
			const $sub_title = jQuery('.js-hashtag_selected_subtitle');
			if (jQuery('.js-dol_hashtag_selected_item').length) {
				yalwa.basics.show($sub_title);
				yalwa.basics.hide(jQuery('.js-hashtags_selected_none_body'));
			} else {
				yalwa.basics.show(jQuery('.js-hashtags_selected_none_body'));
			}
		};

		pub.update_selected_hashtags_count = () => {
			const $selected = jQuery('.js-dol_hashtag_selected_item');
			const count = $selected.length;
			jQuery('.js-hashtags_selected_count').html(count + '/' + yalwa.v.MAX_HASHTAGS);
			// on reaching the max limit, hide the swipe view add hashtags otherwise show it
			if (count === parseInt(yalwa.v.MAX_HASHTAGS)) {
				yalwa.basics.hide(jQuery('.js-swipe_view_add_hashtag'));
			} else {
				yalwa.basics.show(jQuery('.js-swipe_view_add_hashtag'));
			}
		};

		pub.set_selected_hashtags = () => {
			const $selected = jQuery('.js-dol_hashtag_selected_item');
			if ($selected.length) {
				$selected.each(function() {
					view_hashtag_as_selected(jQuery(this).data('hashtag-id'));
				});
			}
		};

		pub.set_first_htab_as_selected = (context) => {
			const $htabs_item = jQuery('.js-htabs_item_htag');
			if (!$htabs_item.length) {
				return;
			}

			if (!$htabs_item.filter('.htabs__item--chosen_hashtag').length) {
				if (context === 'onboarding') {
					$htabs_item.first().trigger('click');
				} else if (context === 'edit-profile') {
					$htabs_item.first().addClass('htabs__item--chosen_hashtag');
				}
			}
		};

		pub.select_personality_hashtag = function() {
			if (!$hashtags_htabs.length) {
				return;
			}
			const personality_hashtag_index = 2;
			$hashtags_htabs.eq(personality_hashtag_index).trigger('click');
		};

		function info_button_click_handler() {
			const plp_options = [{
				is_queued: true,
				htab: {
					clicked: true
				}
			}];
			jQuery('.js-dol_hashtags_info_plp').trigger('plp_show', plp_options);
		}

		function get_user_hashtag() {
			return yalwa.basics.ajaxservice({
				resource: 'profile',
				service: 'hashtags',
				action: 'get_user_hashtag',
			});
		}

		function get_user_hashtag_count() {
			return yalwa.basics.ajaxservice({
				resource: 'profile',
				service: 'hashtags',
				action: 'get_user_hashtag_count',
				csrf: $('.js-hashtag_suggestion').data('count_hashtag_csrf'),
			});
		}

		pub.set_user_hashtag = set_user_hashtag;
		function set_user_hashtag(hashtagID) {
			return yalwa.basics.ajaxservice({
				resource: 'profile',
				service: 'hashtags',
				action: 'set_user_hashtag',
				type: 'post',
				csrf: $('.js-htab_hashtags_sections').data('set_hashtag_csrf'),
				data: {
					hashtagID: hashtagID
				},
			});
		}

		function delete_user_hashtag(hashtagID) {
			return yalwa.basics.ajaxservice({
				resource: 'profile',
				service: 'hashtags',
				action: 'delete_user_hashtag',
				type: 'post',
				csrf: $('.js-htab_hashtags_sections').data('delete_hashtag_csrf'),
				data: {
					hashtagID: hashtagID
				},
			});
		}

		pub.get_selected = function() {
			let selected_hashtags = [];
			jQuery('.js-dol_selected_hashtag_item').each(function() {
				selected_hashtags.push(jQuery(this).html());
			});
			return selected_hashtags;
		};

		pub.get_selected_text = function() {
			let selected_hashtags_text = [];
			jQuery('.js-dol_selected_hashtag_item').each(function() {
				selected_hashtags_text.push(jQuery(this).attr('data-hashtag-text'));
			});
			return selected_hashtags_text;
		};

		return pub;

	}(pub.hashtags));

	pub.app_rating = (function(pub) {

		pub = pub || {};
		let $body;
		let variant_name;
		let handling_timeout = 0;
		let handlers_init_done = false;

		pub.init = function() {
			$body = jQuery('body');
			if (!should_init()) {
				return;
			}
			if (jQuery('.js-dol_match_popup').is(':visible')) {
				return;
			}
			can_show().done(function(response) {
				if (response.success) {
					if (yalwa.basics.overlay.register('app_rating', true)) {
						get_app_rating_plp_tpl().done(function(html) {
							if (!html) {
								return;
							}
							$body.append(html);
							variant_name = jQuery('.js-app_rating_variant').data('variant');
							handle_showing_plp();
							if (variant_name === 'stars') {
								init_stars();
							}
							if (!handlers_init_done) {
								handlers_init_done = true;
								$body.on('click', '.js-app_rating_bad, .js-app_rating_okay', handle_negative_rating);
								$body.on('click', '.js-app_rating_good, .js-app_rating_great', handle_positive_rating);
								$body.on('click', '.js-rate_app_later', handle_reply_later);
							}
						}); 
					}
				}
			});
		};

		function handle_showing_plp() {
			show_plp();
			track_app_rating('impression', variant_name);
		}

		function init_stars() {
			handling_timeout = 440; // in my opinion, good reaction time for eyes
			jQuery('body').on('click', '.js-app_rating_star', stars_click);
		}

		function stars_click(event) {
			let $clicked_star = jQuery(this);
			let $all_stars = jQuery('.js-app_rating_star');
			$all_stars.each(function() {
				let $icon = jQuery(this).find('.yicon');
				if (jQuery(this).data('count') <= $clicked_star.data('count')) {
					yalwa.basics.yicon_modifier($icon, 'active', 'add');
					yalwa.basics.yicon_modifier($icon, 'empty', 'remove');
				} else {
					yalwa.basics.yicon_modifier($icon, 'empty', 'add');
					yalwa.basics.yicon_modifier($icon, 'active', 'remove');
				}
				yalwa.mobile.force_repaint($icon);
			})
		}

		function handle_positive_rating(event) {
			const emoji_name = jQuery(event.currentTarget).data('name');
			set_app_rating_plp_feedback('p').done(() => {
				track_app_rating('click_on_' + variant_name, emoji_name).then(() => {
					hide_plp();
					remove_plp();
					let app_store_url = yalwa.v.app_store_url;
					const android_native_app_rating_active = yalwa.v.is_dol_app === 'dol_android' && yalwa.basics.dol_app_version() > 4232;
					const ios_native_app_rating_active = yalwa.v.is_dol_app === 'dol_ios' && yalwa.basics.dol_app_version() > 4520;
					if (android_native_app_rating_active || ios_native_app_rating_active) {
						yalwa.mobile.cordova_dol.show_native_rating_dialog();
					} else if (yalwa.basics.is_dol_app() === 'dol_ios') {
						let rating_url = app_store_url.replace('https', 'itms-apps');
						app_store_url = rating_url + '?action=write-review';
						setTimeout(yalwa.basics.navigate(app_store_url), handling_timeout);
					} else {
						yalwa.mobile.cordova_dol.openexternal(app_store_url);
					}
				})
			});
		}

		function handle_negative_rating(event) {
			const emoji_name = jQuery(event.currentTarget).data('name');
			set_app_rating_plp_feedback('n').done(_ => {
				track_app_rating('click_on_' + variant_name, emoji_name).then(_ => {
					hide_plp();
					remove_plp();
					setTimeout(show_feedback_form, 500);
				});
			});
		}

		function handle_reply_later() {
			set_app_rating_plp_feedback('l').done(_ => {
				track_app_rating('click_on_' + variant_name, 'reply_later').then(_ => {
					hide_plp();
					remove_plp();
				});
			});
		}

		function get_app_rating_plp_tpl() {
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'html',
				type: 'get',
				data: {action: 'app_rating_plp'}
			});
		}

		function set_app_rating_plp_feedback(feedback) {
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'post',
				data: {
					action: 'app_rating_plp_feedback',
					type: feedback
				}
			});
		}

		function detect_feedback_type() {
			switch (yalwa.v.is_dol_app) {
				case 'dol_android':
					return 'dol_app_android';
				case 'dol_ios':
					return 'dol_app_ios';
			}
		}

		function show_feedback_form() {
			jQuery('.js-dol_feedback_type').val(detect_feedback_type());
			get_app_feedback_form_title().done(function(response) {
				if (response.success) {
					const $current_title = jQuery('.js-feedback_popup .plp__title');
					yalwa.basics.ls_set('feedback_form_title', $current_title.text());
					$current_title.text(response.text);
					yalwa.dol.burger_menu_feedback();
				}
			});
		}

		function get_app_feedback_form_title() {
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {
					action: 'get_app_feedback_form_title'
				}
			});
		}

		function show_plp() {
			jQuery('.js-dol_app_rating_plp').trigger('plp_show');
		}

		function hide_plp() {
			jQuery('.js-dol_app_rating_plp').trigger('plp_hide');
		}

		function remove_plp() {
			yalwa.basics.overlay.unregister('app_rating');
			jQuery('.js-dol_app_rating_plp').remove();
		}

		function can_show() {
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {
					action: 'can_show_app_rating_plp'
				}
			});
		}

		function should_init() {
			return yalwa.v.dol_profile_status === yalwa.v.STATUS_ACTIVE && yalwa.v.is_dol_app;
		}

		function track_app_rating(action, label) {
			var deferred = jQuery.Deferred();
			if (!action || !label) {
				setTimeout(deferred.resolve, handling_timeout)
			}
			yalwa.basics.ga.event({
				category: 'app_rating_plp',
				action: action,
				label: label
			});
			setTimeout(deferred.resolve, handling_timeout);

			return deferred.promise();
		}

		return pub;

	})(pub.app_rating);

	pub.swipe_motivation_plp = (function(pub) {
		pub = pub || {};
		let tpl_loaded = false;
		let $tpl = null;
		let $close_btn = null;
		let scale = 1;
		pub.init = function() {
			if (!tpl_loaded) {
				get_swipe_motivation_tpl().done(function(html) {
					if (yalwa.mobile.generic_shadow.show_in_progress) {
						return;
					}
					if (!html) {
						yalwa.dol.toast({message: yalwa.v.lang.an_error_occurred, type: 'error'});
						return;
					}
					jQuery('body').append(html);
					tpl_loaded = true;
					$tpl = jQuery('.js-swipe_motivation');
					$close_btn = jQuery('.js-swipe_motivation_close');
					$close_btn.on('click', hide_plp);
					show_shadow();
					$tpl.velocity("slideDown", {duration: 500, complete: animate_this});
				});
			} else {
				scale = 1;
				$tpl.velocity("slideDown", {duration: 500, complete: animate_this});
			}
		};
		pub.get_swipe_motivation_tpl = get_swipe_motivation_tpl;

		function get_swipe_motivation_tpl() {
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'html',
				type: 'get',
				data: {action: 'swipe_motiation_plp_tpl'}
			});
		}

		function animate_this() {
			jQuery('.js-swipe_motivation_logo').css({transform: 'translate(-50%, -50%) scale(' + scale + ')'});
		}

		function show_shadow() {
			yalwa.mobile.generic_shadow.show();
		}

		function hide_shadow() {
			yalwa.mobile.generic_shadow.hide();
			yalwa.mobile.generic_shadow.remove_events();
		}

		function hide_plp() {
			scale = 0;
			animate_this();

			setTimeout(function() {
				$tpl.velocity("slideUp", {duration: 500});
				hide_shadow();
			}, 500);

		}

		return pub;
	})(pub.swipe_motivation_plp);

	pub.pic_guide = (function(pub) {

		pub = pub || {};

		let slider_initialized = false;
		let pic_guide_tpl_loaded = false;
		let $pic_guide = null;
		let $slider = null;
		let $slides = null;
		let $indicators = null;
		let initialization_on_progress = false;
		const SCREEN_WIDTH = screen.width;

		pub.init = function(context = '', track_label = '') {
			if (initialization_on_progress) {
				return false;
			}
			initialization_on_progress = true;
			if (!pic_guide_tpl_loaded) {
				get_pic_guide_tpl(context).done(function(html) {
					if (!html) {
						yalwa.dol.toast({message: yalwa.v.lang.an_error_occurred, type: 'error'});
						initialization_on_progress = false;
						return;
					}
					jQuery('body').append(html);
					pic_guide_tpl_loaded = true;
					$pic_guide = jQuery('.js-pic_guide');
					$slider = jQuery('.js-pic_guide_slider');
					$slides = jQuery('.js-pic_guide_slide');
					$indicators = jQuery('.js-pic_guide_dot');
					handle_pic_guide_toggle();
					initialization_on_progress = false;
				});
			} else {
				initialization_on_progress = false;
				handle_pic_guide_toggle();
			}
			if (track_label) {
				pub.track(track_label);
			}
		};

		function handle_pic_guide_toggle() {
			if ($pic_guide.hasClass('hidden')) {
				const $plp = jQuery('.js-plp');
				if ($plp.not('.hidden').length) {
					$plp.not('.hidden')
						.on('plp_hidden', show_pic_guide)
						.trigger('plp_hide');
				} else {
					show_pic_guide();
				}
			} else {
				hide_pic_guide();
			}
		}

		function get_pic_guide_tpl(context) {
			const onboarding_context = (context === 'onboarding');
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'html',
				type: 'get',
				data: {action: 'pic_guide_tpl', onboarding_context: onboarding_context}
			});
		}

		function slider_init() {
			if (slider_initialized) {
				return;
			}
			slider_initialized = true;
			if ($slider.length) {
				if ($pic_guide.length) {
					const hammertime = new Hammer($pic_guide[0], {});
					hammertime.get('swipe').set({direction: Hammer.DIRECTION_ALL});
					hammertime.on('swipeleft swiperight swipedown', pic_guide_swipe);
				}

				$indicators.on('click', set_slide);
			}
			if (upload.initialized) {
				upload.activate_buttons();
			}
			jQuery('.js-pic_guide_upload').on('click', () => {
				hide_pic_guide();
				jQuery('.js-dol_upload_overview').first().trigger('click');
			});
		}

		function show_shadow() {
			yalwa.mobile.generic_shadow.show_queued();
			jQuery('.js-generic_shadow').on('click', hide_pic_guide);
		}

		function hide_shadow() {
			yalwa.mobile.generic_shadow.hide_queued();
			yalwa.mobile.generic_shadow.remove_events();
		}

		function show_pic_guide() {
			show_shadow();
			yalwa.basics.show($pic_guide);
			$pic_guide.velocity("slideDown", {
				duration: 500, complete: function() {
					slider_init();
				}
			});
			handle_back_button();
			jQuery('.js-pic_guide_help')
				.off('click')
				.on('click', function() {
					// wait 500 ms until the pic guide close to open the plp
					hide_pic_guide(() => {
						setTimeout(init_foto_upload_reason_plp, 500);
					});
				});
		}

		function init_foto_upload_reason_plp() {
			jQuery('.js-no_foto_reason_plp').trigger('plp_show');
			jQuery('.js-no_foto_reason_dont_want')
				.off('click')
				.on('click', function() {
					yalwa.basics.ga.event({
						category: 'no_photo_reason',
						action: 'click',
						label: 'dont_like_to',
					});

					jQuery('.js-no_foto_reason_plp')
						.off('plp_hidden')
						.on('plp_hidden', () => {
							jQuery('.js-foto_upload_convince_plp')
								.off('plp_confirm')
								.on('plp_confirm', profile.user_without_pictures_handling)
								.trigger('plp_show', {is_queued: true});
						})
						.trigger('plp_hide', {is_queued: true});
				});
			jQuery('.js-no_foto_reason_technical')
				.off('click')
				.on('click', () => {
					yalwa.basics.ga.event({
						category: 'no_photo_reason',
						action: 'click',
						label: 'technical',
					});
					yalwa.basics.navigate(yalwa.dol.build_url('settings-feedback') + '?type=photo-upload-problem');
				});
		}

		function handle_back_button() {
			jQuery(window).on('popstate', () => $document.trigger('back_on_pic_guide'));
			$document
				.off('back_on_pic_guide')
				.on('back_on_pic_guide', hide_pic_guide);
		}

		function hide_pic_guide(callback) {
			$pic_guide.velocity("slideUp", {
				duration: 500, complete: function() {
					yalwa.basics.hide($pic_guide);
				}
			});
			hide_shadow();
			if (typeof callback === "function") {
				callback();
			}
		}

		function slide_state_reset(num) {
			$indicators.eq(num).attr('data-state', '');
			$slides.eq(num).attr('data-state', '');
		}

		function slides_state_reset() {
			$indicators.attr('data-state', '');
			$slides.attr('data-state', '');
		}

		function slide_state_set(num) {
			$indicators.eq(num).attr('data-state', 'active');
			$slides.eq(num).attr('data-state', 'active');
		}

		function set_slide() {
			const slide = jQuery(this).data('slide');
			slides_state_reset();
			$slides.velocity('fadeOut', {duration: 250});
			yalwa.basics.hide($slides);

			slide_state_set(slide);
			$slides.eq(slide)
				.velocity({translateX: 0}, {duration: 50})
				.velocity('fadeIn', {duration: 250});
			yalwa.basics.show($slides.eq(slide));
		}

		function get_next_slide_index(step, current_slide_index) {
			let next_slide_index = (step === 'next') ? current_slide_index + 1 : current_slide_index - 1;
			if (next_slide_index < 0) {
				next_slide_index = $indicators.length - 1;
			} else if (next_slide_index === $indicators.length) {
				next_slide_index = 0;
			}
			return next_slide_index;
		}

		function switch_slide(step) {
			let next_slide_index = 0;
			let current_slide_index = $indicators.filter('[data-state="active"]').index();
			let hide_effect;
			let show_effect;

			if (step === 'next') {
				hide_effect = -SCREEN_WIDTH;
				show_effect = [0, SCREEN_WIDTH];
			} else {
				hide_effect = SCREEN_WIDTH;
				show_effect = [0, -SCREEN_WIDTH];
			}

			next_slide_index = get_next_slide_index(step, current_slide_index);

			const $current_slide = $slides.filter('[data-state="active"]');
			$current_slide.velocity({
				translateX: hide_effect,
				opacity: 1,
			}, {
				duration: 250,
				display: 'none',
				complete: function() {
					yalwa.basics.hide($current_slide);
					$slides.eq(next_slide_index).velocity({
						translateX: show_effect,
						opacity: 1,
					}, {
						duration: 250,
						display: 'block'
					});
					yalwa.basics.show($slides.eq(next_slide_index));
				}
			});

			slide_state_reset(current_slide_index);
			slide_state_set(next_slide_index);
		}

		function pic_guide_swipe(event) {
			switch (event.type) {

				case 'swipeleft':
					switch_slide('next');
					break;

				case 'swiperight':
					switch_slide('prev');
					break;

				case 'swipedown':
					hide_pic_guide();
					break;

				default:
					break;
			}
		}

		pub.track = (label) => {
			if (!label) {
				return;
			}
			yalwa.basics.ga.event({
				category: 'pic_guide',
				action: 'click',
				label: label
			});
		};

		return pub;

	})(pub.pic_guide);

	pub.match_educate = (function(pub) {

		pub = pub || {};

		let has_last_result;
		let likes_count;

		pub.init = function(profileID) {
			if (has_last_result && likes_count > 2) {
				yalwa.dol.push_check('dol-after-swipe');
				return;
			}
			can_show(profileID).done(function(response) {
				has_last_result = true;
				likes_count = response.likes_count;
				if (response.success) {
					if (yalwa.basics.overlay.current_count() || !jQuery('.js-generic_shadow').hasClass('hidden')) {
						return;
					}
					jQuery('body').append(response.html);
					const $match_guide_tpl = jQuery('.js-match_educate_plp');
					$match_guide_tpl
						.trigger('plp_show')
						.on('plp_hidden', () => $match_guide_tpl.remove());
				}
				yalwa.dol.push_check('dol-after-swipe');
			});
		};

		function can_show(profileID) {
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {
					action: 'can_show_match_educate_plp',
					liked_profileID: profileID
				}
			});
		}

		return pub;

	})(pub.match_educate);

	//TODO (pledge) code can be removed completely later
	pub.pledge = (function(pub) {

		pub = pub || {};

		pub.init = function() {
			set_height();
			yalwa.basics.ga.event({
				category: 'pledge_screen',
				action: 'seen',
			});
			jQuery('.js-pledge_cta').on('click', handle_pledge);
		};

		function set_height() {

			const $root = jQuery(':root');

			$root.css('--vh', window.innerHeight / 100 + 'px');
			$window.on('resize', () => $root.css('--vh', window.innerHeight / 100 + 'px'));
		}

		function handle_pledge() {
			yalwa.basics.ga.event({
				category: 'pledge_screen',
				action: 'agreed',
			});
			set_pledged().done(response => {
				if (response.success) {
					if (yalwa.basics.get_get('continue')) {
						yalwa.basics.navigate(yalwa.basics.get_get('continue'));
					} else {
						yalwa.basics.navigate(yalwa.v.dol_url_base + yalwa.v.VIEW_DISCOVER);
					}

				} else {
					yalwa.basics.sentry.submit_error(new Error('unable to set pledge'));
				}
			});
		}

		function set_pledged() {
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'POST',
				data: {action: 'set_pledged'}
			});
		}

		pub.should_pledge = () => {
			const RELEASE_DATE = 'December 16, 2020 00:00:00';
			const pledge_release_ts = Math.floor(new Date(RELEASE_DATE).getTime() / 1000);
			return !yalwa.v.pledged && parseInt(yalwa.v.start_ts) > pledge_release_ts;
		};

		return pub;

	})(pub.pledge);

	//New Module for Second Chance
	const second_chance = (function(pub) {
		pub = pub || {};
		const show_tool_tip_for_timer = 4000;//4 seconds

		pub.init_second_chance = () => {
			//jQuery('.js-second_chance_lets_go').on('click', lets_go);
			jQuery('.js-dol_trigger_search_refine').on('click', open_filter_panel);
		}

		pub.open_filter_panel = open_filter_panel;

		function open_filter_panel() {
			jQuery('.js-dol_search_refine').trigger('click');
		}

		pub.update_distance = update_distance;

		function update_distance() {
			let $distance_element = jQuery(".js-distance_slider_max");
			let max_distance = parseInt($distance_element.attr('max'));
			$distance_element.val(max_distance);
			if (yalwa.discover) {
				yalwa.discover.change_distance();
			} else {
				yalwa.basics.sentry.submit_error(new Error('yalwa.discover is unavailable'));
			}
			//Save distance with promise
			save_distance(max_distance);
			yalwa.basics.ls_set('distance_filter_removed', JSON.stringify({
				'profileID': yalwa.v.userID,
				'removed': true
			}));
		}

		function save_distance(max_distance) {
			return new Promise((resolve, reject) => {
				let data = {action: 'save', 'section': 'distance', 'distance': max_distance};
				jQuery.ajax({
					url: API_PATH_DOL,
					data: data,
					async: false,
					dataType: 'json',
					type: 'get'
				}).done(function(response) {
					if (response.success === true && yalwa.v.has_dol_profile) {
						yalwa.v.filters_changed = true;
						resolve(true);
					}

				}).fail((e) => console.log('error', e));
			})
		}

		pub.show_tool_tip = (which_filter) => {
			//Remove the # Filters
			if (yalwa.v.init_global_swipe && which_filter && which_filter.hashtag_filter_removed) {
				jQuery('.js-dol_selected_hashtag_item').each(function() {
					let thisData = jQuery(this).attr('data-hashtag-id');
					jQuery(this).remove();
					yalwa.dol.discover.remove_hashtag_from_filter_overview(thisData);
				});
				yalwa.v.filters_changed = true;
			} else {
				jQuery('.js-dol_selected_hashtag_item').each(function() {
					let thisData = jQuery(this).attr('data-hashtag-id');
					jQuery(this).remove();
					yalwa.dol.discover.remove_hashtag_from_filter_overview(thisData);
				});
			}
			//Update the Distance only when distance filter is applied
			if (!yalwa.basics.ls_get('distance_filter_removed')) {
				if (which_filter && which_filter.distance_filter_removed) {
					update_distance();
					jQuery('.js-dol_selected_hashtag_item').each(function() {
						let thisData = jQuery(this).attr('data-hashtag-id');
						let thisData1 = jQuery(this).attr('data-hashtag-text');
						jQuery(this).remove();
						yalwa.dol.discover.remove_hashtag_from_filter_overview(thisData);
						yalwa.dol.discover.remove_hashtag_from_filter_overview(thisData1);
					});
					yalwa.v.filters_changed = true;
				}
			} else {
				let cookie_data = JSON.parse(yalwa.basics.ls_get('distance_filter_removed'));
				if (cookie_data.profileID !== yalwa.v.userID) {
					if (which_filter && which_filter.distance_filter_removed) {
						update_distance();
						jQuery('.js-dol_selected_hashtag_item').each(function() {
							let thisData = jQuery(this).attr('data-hashtag-id');
							let thisData1 = jQuery(this).attr('data-hashtag-text');
							jQuery(this).remove();
							yalwa.dol.discover.remove_hashtag_from_filter_overview(thisData);
							yalwa.dol.discover.remove_hashtag_from_filter_overview(thisData1);
						});
						yalwa.v.filters_changed = true;
					}
				} else {
					if (which_filter && !which_filter.hashtag_filter_removed) {
						return false;
					}
				}
			}
			const filter_icon_top_position = jQuery(".js-dol_search_refine").offset().top;
			const filter_html = jQuery('.js-dol_search_refine').html();
			const start_div = '<div class="js-dol_search_refine js-dol_search_refine_overlay dol_browse_search__refine snh_tip_html--dol_refine hitbox" style="top:' + filter_icon_top_position + 'px;left:20px">';
			const end_div = '</div>';
			yalwa.basics.load_tippy().done(() => {
				yalwa.basics.load_css('https://unpkg.com/tippy.js@6.2.6/animations/scale-extreme.css');
				if (!jQuery('.js-generic_shadow').hasClass('hidden') || typeof (tippy) === 'undefined') {
					return;
				}
				yalwa.basics.overlay.register('second_chance_tooltip');
				const second_chance_tooltip = tippy(jQuery('.js-dol_search_refine')[0], {
					content: yalwa.v.second_chance_tooltip_text || '',
					maxWidth: 180,
					allowHTML: true,
					animation: 'scale-extreme',
					delay: 200,
					strategy: 'fixed',
					trigger: 'manual',
					hideOnClick: true,
					placement: 'right-end',
					theme: 'dol_removed_filters',
					onShow(instance) {
						setTimeout(instance.hide, show_tool_tip_for_timer);
					},
					onHide() {
						yalwa.mobile.generic_shadow.hide();
						yalwa.basics.overlay.unregister('second_chance_tooltip');
						jQuery('.js-generic_shadow').empty();
					}
				});

				second_chance_tooltip.show(show_tool_tip_for_timer);
				jQuery('.js-generic_shadow').append(start_div + filter_html + end_div);
				yalwa.mobile.generic_shadow.show();
				//change the top position again only when margin-top is more than 0 - DEV-7005
				let pos = jQuery('.js-generic_shadow').css('margin-top') ? parseInt(jQuery('.js-generic_shadow').css('margin-top').replace('px', '')) : 0;
				if(pos > 0) {
					jQuery('.js-dol_search_refine_overlay').css('top', filter_icon_top_position - parseInt(jQuery('.js-generic_shadow').css('margin-top').replace('px')) + 'px');
				}

			});
		};

		pub.show_info_plp = () => {
			jQuery('.js-sc_info_plp').trigger('plp_show');
		}

		return pub;

	})(pub.second_chance);

	const nav = (function(pub = {}) {

		pub.to_discover = function() {
			const discover_url = yalwa.dol.build_url(yalwa.v.VIEW_DISCOVER);
			yalwa.basics.navigate(discover_url);
		};

		pub.to_chats = function() {
			const chats_url = yalwa.dol.build_url(yalwa.v.VIEW_CHATS);
			yalwa.basics.navigate(chats_url);
		};

		pub.to_signup = function() {
			const signup_url = yalwa.dol.build_url(yalwa.v.VIEW_ONBOARDING);
			yalwa.basics.navigate(signup_url);
		};

		pub.to_premium_overview = function(referrer, start_pos) {
			if (!yalwa.v.PREMIUM_OVERVIEW_URL) {
				return; // most likely country without PFs enabled
			}
			let url = referrer ? yalwa.v.PREMIUM_OVERVIEW_URL + '?referrer=' + referrer : yalwa.v.PREMIUM_OVERVIEW_URL;
			let start_pos_map = {
				'unlimited_likes': 0,
				'message_highlight': 1,
				'profile_boost': 2,
				'swipe_rewind': 3
			};
			url = start_pos ? url + '?slide_start_at=' + start_pos_map[start_pos] : url;
			yalwa.basics.navigate(url);
		};

		/**
		 * @desc two_step_tp = two-step touchpoint used to track if the page is triggered by the user by clicking
		 * touchpoint or not
		 * @param two_step_tp
		 */
		pub.to_premium_chats = function(two_step_tp = false) {
			if (!yalwa.v.URL_PREMIUM_CHATS) {
				yalwa.basics.sentry.submit_error(new Error('dol_premium: URL_PREMIUM_CHATS is undefined'));
				return;
			}
			
			yalwa.basics.navigate(yalwa.v.URL_PREMIUM_CHATS + '?two_step_tp=' + two_step_tp);
			
		};

		pub.to_premium_rewind = function(two_step_tp = false) {
			if (!yalwa.v.URL_PREMIUM_REWIND) {
				yalwa.basics.sentry.submit_error(new Error('dol_premium: URL_PREMIUM_REWIND is undefined'));
				return;
			}
			yalwa.basics.navigate(yalwa.v.URL_PREMIUM_REWIND + '?two_step_tp=' + two_step_tp);
		};

		pub.to_premium_profile_boost = function(referrer = null, two_step_tp = false) {
			if (!yalwa.v.URL_PREMIUM_PROFILE_BOOST) {
				yalwa.basics.sentry.submit_error(new Error('dol_premium: URL_PREMIUM_PROFILE_BOOST is undefined'));
				return;
			}
			const url = referrer ? yalwa.v.URL_PREMIUM_PROFILE_BOOST + '?referrer=' + referrer + '&two_step_tp=' + two_step_tp
				: yalwa.v.URL_PREMIUM_PROFILE_BOOST + '?two_step_tp=' + two_step_tp;
			yalwa.basics.navigate(url);
		};

		pub.to_hashtags = function(from) {
			const hashtags_url = yalwa.dol.build_url(yalwa.v.VIEW_HASHTAGS);
			let url_suffix = '';
			if(from === 'discover') {
				url_suffix = '?r=discover';
			}
			yalwa.basics.navigate(hashtags_url + url_suffix);
		};
		
		pub.to_photo_duel = function(params = {}) {
			const photo_duel_url = yalwa.dol.build_url(yalwa.v.VIEW_PHOTO_DUEL, null, params);
			yalwa.basics.navigate(photo_duel_url);
		};
		
		pub.to_buy_see_who_likes = function(params = {}) {
			const url = yalwa.dol.build_url(yalwa.v.VIEW_LIKES, yalwa.v.VIEW_GET_LIKES_PATH, params);
			yalwa.basics.navigate(url);
		};
		
		pub.to_buy_wows = function() {
			if (yalwa.v.GET_DM_URL) {
				yalwa.basics.navigate(yalwa.v.GET_DM_URL)
			} else {
				yalwa.basics.sentry.submit_error(new Error('invalid value for GET_DM_URL' + yalwa.v.GET_DM_URL));
			}
		};

		pub.to_like_you = function(params = {}) {
			//Tracking
			yalwa.basics.ss_set('pf_all_touchpoint', params.touchpoint);
			yalwa.basics.ss_set('pf_all_type', 'see_who_liked_you');
			yalwa.basics.datalayer_push({
				'event': 'pf_all_touchpoint_click',
				'pf_all_touchpoint': params.touchpoint,
				'pf_all_type': 'see_who_liked_you',
				'pf_is_app': yalwa.basics.is_dol_app() !== false,
				'eventCallback': function() {
					if(params && params.redirect) {
						const likes_url = yalwa.dol.build_url(yalwa.v.VIEW_LIKES);
						yalwa.basics.navigate(likes_url);
					} else {
						let $htab = jQuery('.js-htabs_item[data-sectionid="' + yalwa.v.VIEW_LIKES + '"]');
						$htab.trigger('click');
					}
				},
				'eventTimeout': 2000
			});
		};
		
		pub.to_profile = function(params = {}) {
			const url = yalwa.dol.build_url(yalwa.v.VIEW_PROFILE, null, params);
			yalwa.basics.navigate(url);
		};
		
		pub.to_stream = function(params = {}) {
			const url = yalwa.dol.build_url(yalwa.v.VIEW_STREAM, null, params);
			yalwa.basics.navigate(url);
		};
		
		return pub;

	})(pub.nav);

	function dol_back_to_locanto(button_clicked, action_name) {
		button_clicked.on('click', (e) => {
			e.preventDefault();
			yalwa.basics.ga.event({
				category: 'dol_back_to_locanto',
				action: action_name
			}).done(() => {
				yalwa.basics.navigate(button_clicked.attr('href'))
			});
			return false;
		});
	}

	dol_back_to_locanto(jQuery('.js-profile_back_locanto'), 'back_from_profile');
	dol_back_to_locanto(jQuery('.js-settings_back_locanto'), 'back_from_settings');

	function delete_profile_via_email() {
		jQuery.ajax({
			url: API_PATH_DOL,
			dataType: 'json',
			type: 'post',
			data: {
				action: 'delete_dol_profile_via_email',
				eid: yalwa.basics.get_get('eid'),
				csrf_bust: yalwa.v.csrf_bust
			}
		}).done(function(response) {
			if (response.success === true) {
				if (yalwa.basics.is_dol_app()) {
					$document.on('logout_success', function() {
						window.location = response.redirect;
					});
					yalwa.mobile.cordova_dol.cordova_send({
						action: 'logout'
					});
				} else {
					setTimeout(function() {
						window.location = response.redirect; //redirect to signup
					}, 1000);
				}
				jQuery('.js-delete_via_email').trigger('plp_hide');
				yalwa.dol.toast({message: response.message, type: 'success'});
				yalwa.mobile.generic_shadow.hide();
			} else {
				yalwa.dol.toast({message: response.message, type: 'error'});
				yalwa.mobile.generic_shadow.hide();
			}
		});
	}

	function global_ajax_error_handler() {
		jQuery(document).ajaxError(function(event, request, settings) {
			switch (request.status) {
				case 503: // readonly mode
					//navigate to maintenance page
					yalwa.basics.navigate(yalwa.v.dol_url_base + 'maintenance');
					break;
			}
		});
	}

	function set_last_like_name_in_ss($profile) {
		yalwa.basics.ss_set('last_like_name', $profile.find('.js-dol_profile_core_name').text());
	}

	const rewind = (function(pub = {}) {

		let $last_reacted_profile = null;
		let $rewind_wrap;
		let timeout_ID;
		let $rewind_pic;

		pub.init = function(type) {
			$rewind_wrap = jQuery('.js-rewind');
			rewind_icon_profile_pic_swap_process(type);
			$rewind_wrap.off('click').on('click', process_rewind);
		};

		pub.set_last_reacted_profile = function($profile_card) {
			$last_reacted_profile = $profile_card;
		};

		pub.unset_last_reacted_profile = function() {
			$last_reacted_profile = null;
		};

		pub.hide = function() {
			if ($rewind_wrap && !$rewind_wrap.hasClass('hidden')) {
				yalwa.basics.hide($rewind_wrap);
			}
		};

		pub.show = function() {
			const $dol_results = jQuery('.js-dol_results');
			// if profiles are not shown, do not show rewind icon
			if (!$dol_results.length || $dol_results.hasClass('hidden')) {
				return;
			}
			if ($rewind_wrap.length && $rewind_wrap.hasClass('hidden')) {
				yalwa.basics.show($rewind_wrap);
			}
		};

		function process_rewind() {
			if (yalwa.v.premium_profile) {
				check_rewind('reset').done(function(response) {
					if (response.success) {
						if (yalwa.v.premium_profile) {
							$last_reacted_profile = jQuery(response.html_card);
							rewind_profile_html(response.positive_reaction);
							yalwa.basics.datalayer_push({
								'event': 'premium_rewind_click'
							});
						} else {
							nav_to_prompt();
						}
					} else {
						if (response.reload) {
							yalwa.basics.reload();
						}
					}
				});
			} else { // non premium user just navigate to rewind swipe prompt
				nav_to_prompt();
			}
		}
		
		function nav_to_prompt() {
			yalwa.basics.ss_set('pf_all_touchpoint', 'rewind_swipe_icon');
			yalwa.basics.ss_set('pf_all_type', 'premium_bundle');
			yalwa.basics.datalayer_push({
				'event': 'pf_all_touchpoint_click',
				'pf_all_touchpoint': 'rewind_swipe_icon',
				'pf_all_type': 'premium_bundle',
				'pf_is_app': yalwa.basics.is_dol_app() !== false,
				'eventCallback': () => yalwa.dol.nav.to_premium_rewind(true),
				'eventTimeout': 2000
			});
		}

		function rewind_profile_html(positive_reaction) {
			discover.set_current_profile($last_reacted_profile);
			const $dol_results = jQuery('.js-dol_results');
			$dol_results.append($last_reacted_profile);
			animate_rewinded_card($last_reacted_profile, positive_reaction);
			discover.current_profile_init();
			discover.init_current();
			yalwa.basics.hide($rewind_wrap);
			yalwa.basics.hide(jQuery('.js-dol_browse_empty'));
			yalwa.basics.show($dol_results);
		}

		function animate_rewinded_card($card, positive_reaction) {
			let delta = positive_reaction ? 80 : -80;
			let delta_val_adjust = 2;
			let timeout = 0;
			let timeout_increase = 20;

			if (positive_reaction) {
				let rewind_animate_interval = setInterval(function() {
					if (delta >= 0) {
						let css = {transform: 'translate3d(' + delta + 'px,0,0) rotate(' + deg(delta) + 'deg)'};
						css.opacity = opacity_dislike(delta);
						requestAnimationFrame(function() {
							$card.css(css);
							animate_buttons($card, delta);
						});
						delta -= delta_val_adjust;
					} else {
						clearInterval(rewind_animate_interval);
					}
					timeout += timeout_increase;
				}, timeout);
			} else {
				let rewind_animate_interval = setInterval(function() {
					if (delta <= 0) {
						let css = {transform: 'translate3d(' + delta + 'px,0,0) rotate(' + deg(delta) + 'deg)'};
						css.opacity = opacity_dislike(delta);
						requestAnimationFrame(function() {
							$card.css(css);
							animate_buttons($card, delta);
						});
						delta += delta_val_adjust;
					} else {
						clearInterval(rewind_animate_interval);
					}
					timeout += timeout_increase;
				}, timeout);
			}
			animate_rewind_icon_wrapper(positive_reaction);
		}

		function animate_rewind_icon_wrapper(positive_reaction) {
			const $rewind_animate = jQuery('.js-rewind_animate');
			if (positive_reaction) {
				$rewind_animate.velocity('transition.slideRightBigIn', {duration: 1000});
				$rewind_animate.velocity('transition.slideLeftBigOut', {duration: 1000, delay: 500});
			} else {
				$rewind_animate.velocity('transition.slideLeftBigIn', {duration: 1000});
				$rewind_animate.velocity('transition.slideRightBigOut', {duration: 1000, delay: 500});
			}
		}

		function animate_buttons($card, delta) {
			let delta_copy = delta;
			const $buttons = $card.find('.js-buttons_static');
			const $dislike_button = $buttons.find('.js-dol_shadow_clone').eq(0);
			const $like_button = $buttons.find('.js-dol_shadow_clone').eq(1);
			const delta_max = 60;
			if (delta_copy > delta_max) {
				delta_copy = delta_max;
			}
			if (delta_copy < delta_max * -1) {
				delta_copy = delta_max * -1;
			}
			let scale = delta_copy / 50;
			if (scale > 0.8) {
				scale = 0.8;
			} else if (scale < -0.8) {
				scale = -0.8;
			}
			let scale_like = (1 + scale);
			let scale_dislike = (1 - scale);
			let translate_like;
			let translate_dislike;
			let translate_y_like;
			let translate_y_dislike;
			let y;
			if ($buttons.position().top < 120) {
				y = Math.abs(delta_copy);
			} else {
				y = Math.abs(delta_copy) * -1;
			}
			if (delta_copy > 0) { // like
				translate_like = -1 * delta_copy;
				translate_dislike = 0;
				translate_y_dislike = 0;
				translate_y_like = y;
			} else { // dislike
				translate_like = 0;
				translate_dislike = Math.abs(delta_copy);
				translate_y_like = 0;
				translate_y_dislike = y;
			}
			$like_button.css('transform', 'scale(' + scale_like + ') translateX(' + translate_like + 'px) translateY(' + translate_y_like + 'px)');
			$dislike_button.css('transform', 'scale(' + scale_dislike + ') translateX(' + translate_dislike + 'px) translateY(' + translate_y_dislike + 'px)');
		}

		function deg(delta) {
			return delta / 10;
		}

		function opacity_dislike(delta) {
			let opacity = 1.2 + (delta / 100);
			if (opacity < 0.2) {
				opacity = 0.2;
			}
			return opacity;
		}

		function rewind_icon_profile_pic_swap_process(type) {
			check_rewind('pre_check', type).done(function(response) {
				if (!jQuery('.js-dol_browse_empty').hasClass('hidden')) {
					return;
				}
				if (response.success) {
					update_rewind_img(response.rewind_profile_image);
					$last_reacted_profile = jQuery(response.html_card);
					if (type && response.liked_by) {
						show_missed_match_tooltip(response.liked_by_tooltip);
					}
				} else {
					pub.hide();
				}
			});
		}

		function show_missed_match_tooltip(liked_by_tooltip) {
			if (!liked_by_tooltip) {
				yalwa.basics.sentry.submit_error(new Error('rewind swipe missed match promo tooltip trigger without a content'));
				return;
			}
			
			// show the rewind icon, just to make sure when user comes after chat highlight popup
			// https://yalwa.atlassian.net/browse/DEV-6884
			pub.show();
			
			yalwa.basics.load_tippy().done(() => {
				yalwa.basics.load_css('https://unpkg.com/tippy.js@6.2.6/animations/scale-extreme.css');
				tippy($rewind_wrap[0], {
					content: liked_by_tooltip,
					maxWidth: 250,
					allowHTML: true,
					animation: 'scale-extreme',
					delay: 1,
					strategy: 'fixed',
					trigger: 'manual',
					hideOnClick: true,
					theme: 'potential-match',
					showOnCreate: true,
					placement: 'left',
					onShow(instance) {
						setTimeout(instance.hide, 3000);
					}
				});
			});
		}
		
		pub.show_tooltip = function(text) {
			show_missed_match_tooltip(text);
		};

		function check_rewind(task, type = null) {
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {
					action: 'rewind',
					do: task,
					reaction_type: type
				}
			});
		}

		function update_rewind_img(url) {
			if (!url) {
				return;
			}
			const html = `<img src="${url}" alt='' width="36"/>`;
			$rewind_pic = jQuery('.js-rewind_pic');
			$rewind_pic.html(html);
			toggle_previous_swiped_profile_and_icon();
			pub.show();
		}
		
		function toggle_previous_swiped_profile_and_icon() {
			clearTimeout(timeout_ID);
			if ($rewind_pic.hasClass('hidden')) {
				yalwa.basics.show($rewind_pic);
				yalwa.basics.hide(jQuery('.js-swipe_rewind_icon'));
			} else {
				yalwa.basics.hide($rewind_pic);
				yalwa.basics.show(jQuery('.js-swipe_rewind_icon'));
			}
			timeout_ID = setTimeout(toggle_previous_swiped_profile_and_icon, 2000);
		}
		
		pub.update_rewind_img = update_rewind_img;

		return pub;

	})(pub.rewind);

	/**
	 * Loads Photo Duel Module from here
	 *
	 * @type {{}}
	 */
	const photo_duel_loader = (function(pub = {}) {

		pub.init = function() {
			toggle_photo_duel();
			//jQuery('.js-init_photo_duel').on('click', load_assets);
		};

		// push notification opt-in/out

		function toggle_photo_duel() {
			jQuery('.js-opt_photo_duel').on('change', function() {
				let $this = jQuery(this);
				
				let is_checked = $this.is(':checked');
				yalwa.v.is_photo_duel_enabled = is_checked;
				let action = !!is_checked;
                let label = is_checked ? $this.data('label-enabled') : $this.data('label-disabled');
				$this.attr('aria-label', label);
                jQuery('label[for="'+ $this.attr('id') +'"]').html(label);
			
				 yalwa.basics.ajaxservice({
					action: 'toggle_photo_duel',
					resource: 'profile',
					type: 'post',
					csrf: $('.js-opt_photo_duel').data('toggle_photo_duel_csrf'),
					data: {
						enabled: action ? 1 : 0
					},
				}).then(function(response) {
					if (response && !response.success) {
						yalwa.dol.toast({message: yalwa.v.lang.an_error_occurred, type: 'success'});
					}
				});
		
				track_photo_duel_on_off(is_checked);
			});
		}

		function track_photo_duel_on_off(is_checked) {
			const data = {
				'toggle': is_checked ? 'on' : 'off',
				'user_gender': yalwa.v.gender,
				'userstatus': yalwa.v.dol_profile_status
			};
			yalwa.basics.datalayer_push({event: 'duel_toggle', data: data});
		}

		pub.load_assets = load_assets;

		function load_assets() {
			//load css and js
			if (yalwa.v.dol_tot_play_active) {
				yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/play.js', load_photo_duel);
				yalwa.basics.load_css(yalwa.basics.static_url('css') + 'dol/pages/play.css', load_photo_duel);
			}
		}

		function load_photo_duel() {
			if (yalwa.photo_duel) {
				yalwa.photo_duel.init();
			}
		}

		pub.validate = function() {
			//Calling it everytime when user is in frozen state only
			if (yalwa.photo_duel) {
				yalwa.photo_duel.init();
			}

		}

		pub.init();
		return pub;
	})(pub.photo_duel_loader);

	pub.magic_link = (function(pub) {
		
		pub = pub || {};
		
		pub.init = function() {
			if(yalwa.basics.get_get('ml')) {
				show_magic_link_form();
			}
			jQuery('.js-lost-pw-ml-redirect').on('click', (event) => {
				event.preventDefault();
				if(jQuery('.js-lost_pw_email').val().length !== 0) {
					yalwa.basics.ss_set('ml_lostpw_redirect_email', jQuery('.js-lost_pw_email').val());
				}
				yalwa.basics.navigate(event.target.href);
			});
			jQuery(document).on('ltabs_login', function() {
				toggle_to_login_form();
			});
		};
		
		pub.init_magic_link_btns = () => {
			jQuery('.js-ajax_magic_link_start').on('click', () => {
				yalwa.dol.magic_link.toggle_to_ml_form();
			});
			
			jQuery('.js-magic_link_back_link').on('click', () => {
				toggle_to_login_form();
			});
			
			jQuery('.js-ajax_ml_submit').on('click', () => {
				request_magic_link();
			});
			
			jQuery('.js-ajax_login__magic_link_form_el').on('submit', (e) => {
				e.preventDefault();
				request_magic_link();
			});
		}
		
		pub.check_for_failed_login = () => {
			if(yalwa.v.mll_expired) {
				show_notice('expired');
			}
		}
		
		pub.toggle_to_ml_form = () => {
			if(jQuery('.js-login_id').val().length !== 0) {
				jQuery('.js-login_id_ml').val(jQuery('.js-login_id').val());
				if(yalwa.basics.ss_get('ml_lostpw_redirect_email')) {
					jQuery('.js-login_id_ml').val(yalwa.basics.ss_get('ml_lostpw_redirect_email'));
					yalwa.basics.ss_remove('ml_lostpw_redirect_email')
				}
				jQuery('.js-login_id_ml_ali').addClass('ali--infocus');
			}
			if(yalwa.basics.ss_get('ml_lostpw_redirect_email')) {
				jQuery('.js-login_id_ml').val(yalwa.basics.ss_get('ml_lostpw_redirect_email'));
				yalwa.basics.ss_remove('ml_lostpw_redirect_email')
				jQuery('.js-login_id_ml_ali').addClass('ali--infocus');
			}
			yalwa.basics.hide(jQuery('.js-ajax_login__login_form'));
			yalwa.basics.show(jQuery('.js-ajax_login__magic_link_form'));
		}
		
		function toggle_to_login_form() {
			reset_ml_form();
			yalwa.basics.hide(jQuery('.js-ajax_login__magic_link_form'));
			yalwa.basics.show(jQuery('.js-ajax_login__login_form'));
		}
		
		function show_magic_link_form() {
			yalwa.mobile.auth.show_dialog().then(() => {
				yalwa.dol.magic_link.toggle_to_ml_form();
			});
		}
		
		function request_magic_link() {
			let email = jQuery('.js-ml_email_input').val();
			if(email.length > 0) {
				let result = false;
				jQuery.ajax({
					url: API_PATH_DOL,
					type: 'post',
					dataType: 'json',
					async: false,
					cache: false,
					data: {
						action: 'magic_link_request',
						email: email
					}
				}).done((response) => {
					if (response.success === true) {
						result = true;
						show_notice('email_sent', email);
					} else {
						result = false;
						show_notice(response.error, response.time_to_wait);
					}
				});
			} else {
				show_notice('invalid_email');
			}
		}
		
		function show_notice(error_name, value = '') {
			if(!error_name) {
				return false;
			}
			yalwa.basics.hide(jQuery('.js-ml_intro_text'));
			reset_ml_form(true);
			switch (error_name) {
				case 'invalid_email':
					jQuery('.js-ml_email_input').addClass('ajax_login__ml_email_input--error');
					yalwa.basics.show(jQuery('.js-ml_error_invalid_email'));
					break;
				case 'banned_email':
					jQuery('.js-ml_email_input').addClass('ajax_login__ml_email_input--error');
					yalwa.basics.show(jQuery('.js-ml_error_banned_email'));
					break;
				case 'old_email':
					jQuery('.js-ml_email_input').addClass('ajax_login__ml_email_input--error');
					yalwa.basics.show(jQuery('.js-ml_error_old_email'));
					break;
				case 'expired':
					yalwa.basics.show(jQuery('.js-ml_error_expired'));
					break;
				case 'wait_time':
					let minutes = Math.floor(value / 60);
					let seconds = String(value - minutes * 60).padStart(2, '0');
					let new_val = minutes + ':' + seconds;
					let new_wt_label_val = jQuery('.js-wait_time_text_tpl').html().replace('%1$s', new_val);
					jQuery('.js-wait_time_text').html(new_wt_label_val);
					yalwa.basics.show(jQuery('.js-ml_error_wait_time'));
					break;
				case 'email_sent':
					let new_label_val = jQuery('.js-email_sent_text').html().replace('%1$s', value);
					jQuery('.js-email_sent_text').html(new_label_val);
					yalwa.basics.hide(jQuery('.js-ajax_ml_submit'))
					yalwa.basics.show(jQuery('.js-ml_email_sent'));
					break;
			}
		}
		
		function reset_ml_form(only_hide = false) {
			jQuery('.js-ml_email_input').removeClass('ajax_login__ml_email_input--error');
			yalwa.basics.hide(jQuery('.js-ml_error_invalid_email'));
			yalwa.basics.hide(jQuery('.js-ml_error_banned_email'));
			yalwa.basics.hide(jQuery('.js-ml_error_expired'));
			yalwa.basics.hide(jQuery('.js-ml_error_wait_time'));
			yalwa.basics.hide(jQuery('.js-ml_email_sent'));
			yalwa.basics.hide(jQuery('.js-ml_error_old_email'));
			if(!only_hide) {
				yalwa.basics.show(jQuery('.js-ml_intro_text'));
				yalwa.basics.show(jQuery('.js-ajax_ml_submit'));
			}
		}
		
		return pub;
		
	})(pub.magic_link);
	
	pub.show_wow_new_icon = function($discover_context = false) {
		let wow_new_icon_ls_key = yalwa.dol.get_wow_new_icon_ls_key();
		let wow_new_icon_seen_profiles = yalwa.basics.ls_get(wow_new_icon_ls_key, true) || [];
		let wow_new_icon_seen = wow_new_icon_seen_profiles.indexOf(yalwa.v.userID) !== -1;
		if (!wow_new_icon_seen) {
			if ($discover_context) {
				let $current_profile = yalwa.dol.discover.get_current_profile();
				let $wow_new_icon = $current_profile.find('.js-wow_new_icon');
				if ($wow_new_icon.length) {
					yalwa.basics.show($wow_new_icon);
				}
			} else {
				yalwa.basics.show(jQuery('.js-wow_new_icon'));
			}
		}
	};
	
	pub.get_wow_new_icon_ls_key = function() {
		return 'seen_wow_new_icon';
	};
	
	pub.get_seen_wow_tp_on_duel_ls_key = function() {
		return 'seen_wow_tp_on_duel';
	};
	
	pub.set_seen_wow_new_icon = function() {
		let wow_new_icon_ls_key = yalwa.dol.get_wow_new_icon_ls_key();
		let wow_new_icon_seen_profiles = yalwa.basics.ls_get(wow_new_icon_ls_key, true) || [];
		let wow_new_icon_seen = wow_new_icon_seen_profiles.indexOf(yalwa.v.userID) !== -1;
		if (!wow_new_icon_seen) {
			wow_new_icon_seen_profiles.push(yalwa.v.userID);
			yalwa.basics.ls_set(wow_new_icon_ls_key, wow_new_icon_seen_profiles);
		}
	};
	
	/**
	 * @desc https://yalwa.atlassian.net/browse/DEV-7543
	 */
	function show_dot_on_play() {
		let seen_wow_tp_on_duel_ls_key = yalwa.dol.get_seen_wow_tp_on_duel_ls_key();
		let seen_wow_tp_on_duel_profiles = yalwa.basics.ls_get(seen_wow_tp_on_duel_ls_key, true) || [];
		let wow_tp_on_duel_seen = seen_wow_tp_on_duel_profiles.indexOf(yalwa.v.userID) !== -1;
		if (!wow_tp_on_duel_seen) {
			jQuery('.js-init_photo_duel').addClass('dol_counter');
		}
	}
	
	const likes = (function(pub = {}) {
		
		let $likes_tab_body;
		let has_liked_by_profiles = false;
		let initialized = false;
		pub.full_count_bucket = null;
		pub.full_count_bucket_you_liked = null;
		
		pub.init = function() {
			if (initialized) {
				return;
			}
			initialized = true;
			$likes_tab_body = jQuery('.js-dol_section_likes');
			yalwa.basics.load_css(yalwa.basics.static_url('css') + 'dol/pages/likes.css');
			load_template().done(function(r) {
				if (r.csrf_bust) {
					yalwa.v.dtc = r.csrf_bust;
				}
				load_assets();
				if (r.success && r.html) {
					pub.full_count_bucket = r.full_count_bucket;
					pub.full_count_bucket_you_liked = r.full_count_bucket_you_liked;
					has_liked_by_profiles = r.has_liked_by_profiles;
					yalwa.v.has_liked_by_profiles = r.has_liked_by_profiles;
					yalwa.basics.hide(jQuery('.js-likes_loader'));
					$likes_tab_body.append(r.html);
					if (r.has_liked_by_profiles) {
						show_dot_on_likes_tab();
						if (yalwa.dol.url_id() === yalwa.v.VIEW_CHATS) {
							yalwa.dol.chats.check_empty_chats_view();
						}
					}
				}
			});
		};
		
		function load_assets() {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/likes.js', load_likes);
		}
		
		function load_template() {
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {
					action: 'likes_view'
				}
			});
		}
		
		function load_likes() {
			if (yalwa.likes) {
				yalwa.likes.init();
			}
		}
		
		function show_dot_on_likes_tab() {
			jQuery('.js-htabs').find('[data-sectionid="likes"]').find('.yicon').addClass('dol_counter');
		}
		
		return pub;
		
	})(pub.likes);
	
	
	const stream = (function(pub = {}) {
		
		let $stream_tab_body;
		let initialized = false;
		
		pub.init = function() {
			if (initialized) {
				return;
			}
			
			initialized = true;
			$stream_tab_body = jQuery('.js-dol_section_stream');
			yalwa.basics.load_css(yalwa.basics.static_url('css') + 'dol/pages/stream.css');
			load_template().done(function(r) {
				if (r.success && r.html) {
					$stream_tab_body.html(r.html);
					load_assets();
				}
			});
		};
		
		function load_assets() {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/stream.js', load_stream, 'module');
		}
		
		function load_template() {
			let controller = yalwa.basics.get_get('c') || false;
			
			return jQuery.ajax({
				url: API_PATH_DOL,
				dataType: 'json',
				type: 'get',
				data: {
					action: 'stream_view',
					c : controller
				}
			});
		}
		
		function load_stream() {
			if (yalwa.stream) {
				yalwa.stream.init();
			}
		}
		
		// function show_dot_on_stream_tab() {
		// 	jQuery('.js-htabs').find('[data-sectionid="likes"]').find('.yicon').addClass('dol_counter');
		// }
		
		pub.live_stream_toastr_polling = function() {
			if (yalwa.dol.helper.is_active()  && !yalwa.v.ghost_high && has_seen_toastr_a_day_ago_or_never_seen()) {
				let toastr_interval = 1000 * 30; // 30 seconds
				
				let toastr_timeoutID = setTimeout(function repeat() {
					return jQuery.ajax({
						url: yalwa.basics.API_PATH_DOL,
						dataType: 'json',
						type: 'GET',
						cache: false,
						data: {
							action: 'get_live_streams_toastr'
						}
					}).done((response) => {
						if (response.success &&
							response.data && response.data.length
							&& is_user_in_toastr_allowed_pages()
							&& jQuery('.js-generic_shadow').hasClass('hidden')
						) {
							show_live_stream_toaster(
								response.toastr_body_text,
								response.toastr_cta_text,
								response.toastr_profile_pic,
								response.stream_to_promote.sessionId,
								response.stream_to_promote.profileID);
							clearTimeout(toastr_timeoutID);
							jQuery.ajax({
								url: yalwa.basics.API_PATH_DOL,
								dataType: 'json',
								type: 'POST',
								cache: false,
								data: {
									action: 'set_live_stream_toastr_ts',
								}
							}).done(function(response) {
								if (response.success) {
									yalwa.v.live_stream_toastr_ts = response.live_stream_toastr_ts;
								}
							});
						} else {
							setTimeout(repeat, toastr_interval);
						}
					});
				}, toastr_interval);
			}
		};
		function is_user_in_toastr_allowed_pages() {
			let toastr_allowed_pages = [yalwa.v.VIEW_DISCOVER, yalwa.v.VIEW_CHATS, yalwa.v.VIEW_PROFILE, yalwa.v.VIEW_PHOTO_DUEL];
			let url_id = yalwa.dol.url_id();
			return toastr_allowed_pages.indexOf(url_id) !== -1;
		}
		
		function has_seen_toastr_a_day_ago_or_never_seen() {
			if (!yalwa.v.live_stream_toastr_ts) {
				return true;
			}
			
			return (yalwa.basics.unix() - yalwa.v.live_stream_toastr_ts) / (yalwa.basics.ONE_DAY) > 1;
		}
		
		function show_live_stream_toaster(text, cta, pic, sessionId = '', profileID = '') {
			let template = `
				<div class="premium-toaster">
					<div class="live_toastr_img">
						<img src="${pic}" width="32px" height="32px" alt="" />
					</div>
					<div class="text">${text}</div>
					<div class="button">
						<div class="live_stream_toastr__cta js-live_stream_toaster">${cta}</div>
					</div>
				</div>`;
			yalwa.dol.toast({
				message: template,
				type: 'success',
				timeOut: 5000, // 5 seconds delay for toastr
				extendedTimeOut: 1000,
				positionClass: "toast-top-full-width live_stream_toast",
				onclick: function() {
					take_to_live_stream(sessionId, profileID);
				}
			});
		}
		
		function take_to_live_stream(sessionId , profileID ) {
			
			// let $stream_htab = jQuery('.js-htabs_item[data-sectionid="' + yalwa.v.VIEW_STREAM + '"]');
			// $stream_htab.trigger('click');
			yalwa.dol.nav.to_stream({c : 'watching', sessionId : sessionId});
			
			// yalwa.stream_helper.load_session_details(sessionId).done(function(response) {
			// 	const session_details = JSON.stringify(response.session_details);
			// 	const profile_details = response.profile_details;
			// 	let profile_image = response.profile_details.image;
			// 	let profileID = response.profile_details.id;
			// 	let profile_age = response.profile_details.age;
			// 	let profile_name = response.profile_details.name;
			// 	let country_flag = response.profile_details.flag;
			// 	let countryID = response.profile_details.countryID;
			// 	let gender = response.profile_details.gender;
			// 	yalwa.stream_helper.watch_now_init_helper(session_details, profile_details, profileID, gender, countryID);
			// });
		}
		
		pub.open_tab = function() {
			let $stream_htab = jQuery('.js-htabs_item[data-sectionid="' + yalwa.v.VIEW_STREAM + '"]');
			$stream_htab.trigger('click');
		}
		
		pub.take_to_live_stream = take_to_live_stream;
		
		return pub;
		
	})(pub.stream);
	
	const inbetween_fixed_promos = (function(pub = {}) {
		
		function hide_filter_and_rewind_swipe() {
			yalwa.basics.hide(jQuery('.js-discover_top_bar_actions'));
		}

		/**
		 * Checks if
		 * @returns {*}
		 */
		function can_show_swipe_preference_selection() {
			return yalwa.v.init_settings.can_show_swipe_inbetween_swipe_selection;
		}
		
		function can_show_female_stream_promo() {
			return yalwa.v.init_settings.can_show_female_stream_promo;
		}
		
		pub.show_swipe_preference = function () {
			hide_filter_and_rewind_swipe();
			
			//as soon as we show this to user
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/swipe_preference.js');
			//yalwa.swipe_preference.init();
		};
		
		pub.init_stream_promo = function() {
			hide_filter_and_rewind_swipe();
			
			//Track view
			yalwa.basics.datalayer_push({event: 'start_stream_promo_view'});
			
			//Init button clicks
			jQuery('.js-stream_promo_try_now').on('click', function() {
				let $card = jQuery('.js-inbetween_promo');
				yalwa.dol.discover.promo_swipe($card, 'right', 'action_taken');
				yalwa.basics.ls_set('start_stream_touchpoint', 'inbetween_swipes_stream_promo' , yalwa.basics.unix() + 120);
				//Track click
				yalwa.basics.datalayer_push({event: 'start_stream_promo_clicks', 'stream_promo_actions': 'start_stream_promo_cta_click'});
				
				stream.open_tab();
				yalwa.stream_helper.open_tnc();
			})
			
			jQuery('.js-goto_stream_tab').on('click', function() {
				let $card = jQuery('.js-inbetween_promo');
				yalwa.dol.discover.promo_swipe($card, 'right', 'action_taken');
				yalwa.basics.ls_set('join_stream_touchpoint', 'inbetween_swipes_stream_promo' , yalwa.basics.unix() + 120);
				//Track click
				yalwa.basics.datalayer_push({event: 'start_stream_promo_clicks', 'stream_promo_actions': 'start_stream_promo_watch_click'});
				
				stream.open_tab();
			});
			
			jQuery('.js-close_stream_promo').on('click', function() {
				let $card = jQuery('.js-inbetween_promo');
				yalwa.dol.discover.promo_swipe($card, 'right');
				
				//yalwa.basics.datalayer_push({event: 'start_stream_promo_clicks', 'stream_promo_actions': 'start_stream_promo_close'});
			});
		}

		pub.set_action_taken = function (type) {
			yalwa.basics.ls_set('AK_TAKEN_IBPROMO_'+type, true);
		}

		/**
		 * Loads the HTML for promo card
		 * @param type
		 * @param force_show
		 * @returns {*}
		 */
		function load_inbetween_promo_card(type, force_show = false) {
			return jQuery.ajax({
				url: yalwa.basics.API_PATH,
				dataType: 'json',
				type: 'get',
				async: false,
				data: {action: 'get_inbetween_swipe_elements', type: type, force_show : force_show}
			})
		}

		/**
		 * Master list of all the prompts
		 * display order will be based on the array key
		 * @returns {[{html_card: (function(*): *), can_show: *, init_method: boolean, type: string, show_at_position: number, show_at_positions: number[], loaded_callback: boolean}]}
		 */
		pub.prompts_inbetween_swipe = function () {
			return [
				{
					can_show: can_show_swipe_preference_selection(),
					html_card: load_inbetween_promo_card,
					type: 'swipe_preference_selection',
					show_at_position: 5,
					show_at_positions: [5, 10, 15, 20],
					force_show_at_position: false,
					init_method: false,//not in use
				},
				{
					can_show: can_show_female_stream_promo(),
					html_card: load_inbetween_promo_card,
					type: 'stream_female_promo',
					show_at_position: 10,
					show_at_positions: [10, 20, 30, 40],
					force_show_at_position: 40,
					init_method: false,//not in use
				},
			];
		}

		return pub;
	})(pub.inbetween_fixed_promos)
	
	function initial_check_for_welcome_back_plp() {
		if (!yalwa.v.is_logged_in) {
			return;
		}
		if (!yalwa.v.WELCOME_BACK_PLP) {
			return;
		}
		// only active profile can see the welcome back plp
		if (yalwa.v.dol_profile_status !== yalwa.v.STATUS_ACTIVE) {
			return;
		}
		
		let views_to_show_welcome_back_plp = [yalwa.v.VIEW_PROFILE, yalwa.v.VIEW_DISCOVER, yalwa.v.VIEW_PHOTO_DUEL];
		if (views_to_show_welcome_back_plp.indexOf(yalwa.dol.url_id()) !== -1) {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'dol/welcome_back.js');
			yalwa.basics.load_css(yalwa.basics.static_url('css') + 'dol/modules/welcome_back.css');
			
		}
	}
	
	pub.hashtags = hashtags;
	pub.profile = profile;
	pub.discover = discover;
	pub.chats = chats;
	pub.upload = upload;
	pub.helper = helper;
	pub.nav = nav;
	pub.second_chance = second_chance;
	pub.rewind = rewind;
	pub.photo_duel_loader = photo_duel_loader;
	pub.likes = likes;
	pub.stream = stream;
	pub.inbetween_fixed_promos = inbetween_fixed_promos;

	return pub;

}(yalwa.dol));

yalwa.basics.init_wrapper(yalwa.dol.init);
